module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERRIDE_PRO_SELECTION = exports.SET_NEW_PASSWORD_VALIDATION_MESSAGES = exports.SET_ON_CLOSE = exports.UPDATE_VALID_EMAIL_TOKEN = exports.UI_CONFIG = exports.VALIDATE_ON_KEYUP = exports.SET_GEOIP_API_CALLED = exports.SET_EMAIL_CONSENT_DISPLAY = exports.TOGGLE_EMAIL_CONSENT_DISPLAY = exports.SUBMIT_FORM = exports.SHOW_FB_CONNECT_ERROR = exports.SHOW_EMAIL_FORM = exports.SET_FB_CONNECT_ERROR = exports.RESPONSE_RECEIVED = exports.RESET_FORM_ERROR = exports.RESET_FIELDS = exports.REGISTER_CONTEXT = exports.NETWORK_ERROR = exports.INIT_FB_CONNECT = exports.HIDE_FB_CONNECT_ERROR = exports.HIDE_EMAIL_FORM = exports.FORM_VALIDATED = exports.AUTH_TOKEN = exports.AUTH_PROCESS = exports.LOGGED_IN = exports.APP_MOUNTED = exports.LS_REDIRECT_URL = exports.LS_NAMESPACE = exports.REGISTER_PROFILE_SUBMIT = exports.LOGIN_PROFILE_SUBMIT = exports.SUBMIT_SUCCESS = exports.AUTHENTICATED = exports.LIGHTBOX_HIDDEN = exports.APP_LOAD = exports.APP_REDIRECT = exports.DEFAULT_AUTH_PROCESS = exports.FB_NOT_LOGGED_IN = exports.FB_NOT_AUTHENTICATED = exports.PHONE_LABEL = exports.COMMUNITY_PILLAR_DESCRIPTION = exports.TAB_TYPES = exports.FORM_TEXT = exports.SOCIAL_BUTTON_TYPES = exports.STATUS_ERROR_CODES = exports.SERVER_ROUTES = exports.PASSWORDLESS_APS = exports.BLACKLISTED_INPUTS = exports.PROFESSIONAL_INPUTS = exports.LINK_TARGETS = exports.STRONG_PASSWORD_NEW_PASSWORD_INPUT_CONFIG = exports.INPUT_TYPES = exports.REG_PRO_TYPES = exports.PASSWORDLESS_CREATE_PASSWORD_INPUT_TYPES = exports.PASSWORDLESS_SIGNIN_INPUT_TYPES = exports.EMAIL_CONFIRMED_INPUT_TYPES = exports.FORGOT_INPUT_TYPES = exports.REG_INPUT_TYPES = exports.LOGIN_INPUT_TYPES = exports.getNewPasswordValidationMessagesInitialState = exports.STRONG_PASSWORD_VALIDATOR = exports.STRONG_PASSWORD_VALIDATORS = exports.validatePasswordNotEmail = exports.getValueFromInputStateObject = exports.validateValueNotEmailOrAlias = exports.validateAlphaNumeric = exports.validateLength = exports.validateMaxLength = exports.BUTTON_TYPES = exports.CANADA_ZIPCODE_REGEX = exports.EMAIL_VALIDATION_REGEX = exports.COUNTRY_TYPE_OPTIONS = exports.DEFAULT_PRO_TYPE_OPTIONS = exports.APP_VIEWS = exports.SOCIAL = exports.REGISTER = exports.PRO_REG = exports.LOGIN = exports.PASSWORDLESS = exports.WELCOME_HEADER = exports.GEOIP_SERVICE_ENDPOINT = exports.PASSWORD_STRENGTH_ENDPOINT = exports.APP_ID = exports.APP_CONFIG = exports.POST_LOAD_TIMEOUT = exports.MAX_INLINE_WIDTH = exports.INLINE_BUFFER = exports.REFOCUS = exports.GOOGLE_CLIENT_ID = exports.PROFILER_APP_RENDER_EVENT = exports.FOCUS = exports.NOOP = exports.DEFAULT_REDIRECT_URL = exports.ROUTES = undefined;

var _promise = __webpack_require__(33);

var _promise2 = _interopRequireDefault(_promise);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreActions = __webpack_require__(21);

var _appConfig = __webpack_require__(34);

var _abTests = __webpack_require__(54);

var _actions = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Keep ROUTES at top of file to make accessible to rest of constants
var rootPath = '/user/acct';
var apiPath = '/user/account/services';
var adminPath = '/user';

// ex: "forgot" - Links to ForgotPassword view
// ex: "forgotPost" - API url to ForgotPass
var ROUTES = exports.ROUTES = {
  confirmEmail: '/user/account/UpdatePassword.htm',
  confirmEmailPost: apiPath + '/UpdatePassword.htm',
  emailCheck: '/user/EmailCheck.htm',
  forgot: rootPath + '/forgot-password/',
  changePasswordForgot: '/myzillow/ChangePassword.htm',
  forgotPost: apiPath + '/ForgotPassword.htm',
  forgotSuccess: rootPath + '/ForgotPassword.htm/success',
  home: '/',
  invalidTokenMsg: rootPath + '/email-not-confirmed/',
  login: rootPath + '/login/',
  loginPost: apiPath + '/Login.htm',
  passwordlessSignin: rootPath + '/passwordless/signin/',
  passwordlessCreatePassword: rootPath + '/passwordless/create-password/',
  passwordlessSendEmailPost: '/ajax/account/SendPasswordlessAccountCreateEmail.htm',
  recovery: rootPath + '/password-recovery/',
  register: rootPath + '/register/',
  registerAdmin: adminPath + '/Register.htm',
  registerPost: apiPath + '/Register.htm'
};

var DEFAULT_REDIRECT_URL = exports.DEFAULT_REDIRECT_URL = ROUTES.home;

// fallback callback
var NOOP = exports.NOOP = function NOOP() {};

// Custom event names
var FOCUS = exports.FOCUS = 'focus';

// Profiler event names - for https://zwiki.zillowgroup.net/pages/viewpage.action?spaceKey=zproddev&title=How+to+Measure+User+Perceived+Performance
var PROFILER_APP_RENDER_EVENT = exports.PROFILER_APP_RENDER_EVENT = 'reglogin:app_render';

// Google client id
var GOOGLE_CLIENT_ID = exports.GOOGLE_CLIENT_ID = '238648973530-phn3l5mlqc61qms7m76qjta4mpubcedu.apps.googleusercontent.com';

// Context types
var REFOCUS = exports.REFOCUS = 'refocus';

// Inline dimensions
var INLINE_BUFFER = exports.INLINE_BUFFER = 10;
var MAX_INLINE_WIDTH = exports.MAX_INLINE_WIDTH = 448;

// Post load timeout used for reg lightbox prompt
var POST_LOAD_TIMEOUT = exports.POST_LOAD_TIMEOUT = 1000;

// Button display text
var SEND = 'Send';
var SIGN_IN = 'Sign in';
var SIGN_UP = 'Sign up';
var SUBMIT = 'Submit';
var LATER = 'Do this later';
var CARRY_ON = 'Continue';

// App config
var BUNDLE_NAME = 'static-reg-login';
var CONFIG_PATH = 'reg-login';
var GLOBAL_KEY = 'RegProxiedReactAppGlobalConfig';

var APP_CONFIG = exports.APP_CONFIG = (0, _appConfig.getAppConfig)(BUNDLE_NAME, CONFIG_PATH, GLOBAL_KEY);

var APP_ID = exports.APP_ID = 'reg-login-app';

var PASSWORD_STRENGTH_ENDPOINT = exports.PASSWORD_STRENGTH_ENDPOINT = 'https://auth.zillow.com/password/strength';

var GEOIP_SERVICE_ENDPOINT = exports.GEOIP_SERVICE_ENDPOINT = '/geo/GeoIPService.htm';

// Login header text
var WELCOME_HEADER = exports.WELCOME_HEADER = 'Welcome to Zillow';

// Supported App views
var PASSWORDLESS = exports.PASSWORDLESS = 'PASSWORDLESS';
var LOGIN = exports.LOGIN = 'LOGIN';
var PRO_REG = exports.PRO_REG = 'PRO_REG';
var REGISTER = exports.REGISTER = 'REGISTER';
var SOCIAL = exports.SOCIAL = 'SOCIAL';
var APP_VIEWS = exports.APP_VIEWS = [PASSWORDLESS, LOGIN, PRO_REG, REGISTER, SOCIAL];
var DEFAULT_PRO_TYPE_OPTIONS = exports.DEFAULT_PRO_TYPE_OPTIONS = {
  'Select your category': '0',
  'Real Estate Agent/Broker': '1',
  'Mortgage Lender': '2',
  'Home Improvement Services': '3',
  'Landlord': '5',
  'Photographer': '6',
  'Home Builder': '7',
  'Home Inspector': '8',
  'Property Manager': '9',
  'Other Real Estate Professional': '11'
};

var COUNTRY_TYPE_OPTIONS = exports.COUNTRY_TYPE_OPTIONS = {
  'Select your country': '0',
  'US': '1',
  'Canada': '2'
};

var EMAIL_VALIDATION_REGEX = exports.EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i;
var CANADA_ZIPCODE_REGEX = exports.CANADA_ZIPCODE_REGEX = /^\s*[A-CEGHJ-NPR-TVXY]\d[A-CEGHJ-NPR-TV-Z]\s?(\d[A-CEGHJ-NPR-TV-Z]\d)?\s*$/i;

var BUTTON_TYPES = exports.BUTTON_TYPES = {
  send: {
    type: 'submit',
    value: SEND,
    className: 'zsg-button_primary zsg-button_fullsize'
  },
  signIn: {
    type: 'submit',
    value: SIGN_IN,
    className: 'zsg-button_primary zsg-button_fullsize'
  },
  submit: {
    type: 'submit',
    value: SUBMIT,
    className: 'zsg-button_primary zsg-button_fullsize'
  },
  submitDisabled: {
    type: 'submit',
    value: SUBMIT,
    disabled: true,
    className: 'zsg-button_primary zsg-button_fullsize'
  },
  later: {
    type: 'submit',
    value: LATER,
    className: 'zsg-button_ghost zsg-button zsg-button_fullsize'
  },
  carryOn: {
    type: 'submit',
    value: CARRY_ON,
    className: 'zsg-button_primary zsg-button_fullsize'
  }

  /**
   *  Validates that input is not more than 128 characters
   * @param {*} v
   *            input value
   * @return {Object} input value validation and validation message
   */
};var validateMaxLength = exports.validateMaxLength = function validateMaxLength(v) {
  var validated = /^.{0,128}$/.test(v);
  return {
    validated: validated,
    message: validated ? '' : 'Cannot exceed 128 characters'
  };
};

/**
 *  Validates that input is 8 characters or more
 * @param {*} v
 *            input value
 * @return {Object} input value validation and validation message
 */
var validateLength = exports.validateLength = function validateLength(v) {
  return {
    validated: /^.{8,}$/.test(v),
    message: 'At least 8 characters'
  };
};

/**
 * Checks if input has at least 1 number and 1 letter, validation message updates based on what's needed
 * @param {*} v
 *            input value
 * @return {Object} input value validation and validation message
 */
var validateAlphaNumeric = exports.validateAlphaNumeric = function validateAlphaNumeric(v) {
  var validated = /^(?=.*[0-9])(?=.*[a-zA-Z])(.+)$/.test(v);
  var message = void 0;

  if (!validated && /^[a-zA-Z]+$/.test(v)) {
    message = 'At least 1 number';
  } else if (!validated && /^[0-9]+$/.test(v)) {
    message = 'At least 1 letter';
  } else {
    message = 'Mix of letters and numbers';
  }

  return {
    validated: validated,
    message: message
  };
};

/**
 * Checks if a value is equal to the email address or its alias (alias@domain)
 * @param {String} value
 *                  value to check against
 * @param {String} email
 *                  email address
 * @return {Boolean} value isn't equal to email or alias
 */
var validateValueNotEmailOrAlias = exports.validateValueNotEmailOrAlias = function validateValueNotEmailOrAlias(value, email) {
  var alias = /^(.+)@/.exec(email);
  return value !== email && (alias === null || value !== alias[1]);
};

/**
 * Get the input value from a redux-input managed input object. returns value or error as fallback
 * @param {Object} inputObject {value, error}
 * @return {String} input value
 */
var getValueFromInputStateObject = exports.getValueFromInputStateObject = function getValueFromInputStateObject(_ref) {
  var inputValue = _ref.value,
      fallbackInputValue = _ref.error;

  return inputValue || fallbackInputValue;
};

/**
 * Checks if input does not match the email address or email address alias
 * @param {*} v
 *                  input value
 * @param {Object} newEmail
 *                  inputs with newEmail value
 * @return {Object} input value validation and validation message
 */
var validatePasswordNotEmail = exports.validatePasswordNotEmail = function validatePasswordNotEmail(password, _ref2) {
  var newEmail = _ref2.newEmail;

  var email = getValueFromInputStateObject(newEmail);
  var validated = validateValueNotEmailOrAlias(password, email);

  return {
    validated: validated,
    message: validated || !password ? '' : 'Cannot use your email alias or address'
  };
};

var STRONG_PASSWORD_VALIDATORS = exports.STRONG_PASSWORD_VALIDATORS = [validatePasswordNotEmail, validateMaxLength, validateLength, validateAlphaNumeric];

/**
 * Redux inputs validator for the strong newPassword field. Validates against the array of validators
 * defined, and dispatches the validationMessages updates to the store
 *
 * @param {String} input
 *                  password field's value
 * @param {Object} inputs
 *                  The store's inputs state. Used to cross validate the password with email
 * @param {Object} state
 *                  Store, not used
 * @param {Function} dispatch
 *                  Dispatch
 *
 * @return {Boolean} value passes all validation or not
 */
var STRONG_PASSWORD_VALIDATOR = exports.STRONG_PASSWORD_VALIDATOR = function STRONG_PASSWORD_VALIDATOR(input, inputs, state, dispatch) {
  var finalValidation = true;
  var validationMessages = [];

  STRONG_PASSWORD_VALIDATORS.forEach(function (validator) {
    var result = validator(input, inputs);
    validationMessages.push(result);
    finalValidation = finalValidation && result.validated;
  });

  dispatch((0, _actions.setNewPasswordValidationMessages)(validationMessages));
  return finalValidation;
};

/**
 * Primes the initial state for the validationMessages, which enables us to initially show the visible rules
 * @return {Array} list of validationMessages object
 */
var getNewPasswordValidationMessagesInitialState = exports.getNewPasswordValidationMessagesInitialState = function getNewPasswordValidationMessagesInitialState() {
  var validationMessages = [];

  STRONG_PASSWORD_VALIDATORS.forEach(function (validator) {
    var result = validator('', { newEmail: {} });
    validationMessages.push(result);
  });

  return validationMessages;
};

var LOGIN_INPUT_TYPES = exports.LOGIN_INPUT_TYPES = {
  requiredTypes: ['email', 'password']
};

var REG_INPUT_TYPES = exports.REG_INPUT_TYPES = {
  requiredTypes: ['newEmail', 'newPassword']
};

var FORGOT_INPUT_TYPES = exports.FORGOT_INPUT_TYPES = {
  requiredTypes: ['email']
};

var EMAIL_CONFIRMED_INPUT_TYPES = exports.EMAIL_CONFIRMED_INPUT_TYPES = {
  requiredTypes: ['newPassword']
};

var PASSWORDLESS_SIGNIN_INPUT_TYPES = exports.PASSWORDLESS_SIGNIN_INPUT_TYPES = {
  requiredTypes: ['email']
};

var PASSWORDLESS_CREATE_PASSWORD_INPUT_TYPES = exports.PASSWORDLESS_CREATE_PASSWORD_INPUT_TYPES = {
  requiredTypes: ['newPassword']
};

var REG_PRO_DEFAULT_INPUTS = ['areaCode', 'firstName', 'lastName', 'newEmail', 'newPassword', 'phoneExt', 'phonePrefix', 'phoneSuffix', 'proCheck', 'proSelect', 'countrySelect'];

var REG_PRO_DEFAULT_REDIRECT_URL = '/user/EditProfile.htm';

var REG_PRO_INPUT_TYPES = {
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var REAL_ESTATE_AGENT_INPUT_TYPES = {
  gaSuffix: 'agent',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var MORTGAGE_LENDER_INPUT_TYPES = {
  gaSuffix: 'lender',
  redirectUrl: '/mortgage/EditLenderProfile.htm',
  requiredTypes: ['newEmail', 'newPassword', 'proSelect']
};

var HOME_IMPROVEMENT_INPUT_TYPES = {
  gaSuffix: 'homeimprovement',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var LANDLORD_INPUT_TYPES = {
  gaSuffix: 'landlord',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: [].concat(REG_PRO_DEFAULT_INPUTS, ['isCommunityPillar'])
};

var PHOTOGRAPHER_INPUT_TYPES = {
  gaSuffix: 'photographer',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var HOME_BUILDER_INPUT_TYPES = {
  gaSuffix: 'homebuilder',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var HOME_INSPECTOR_INPUT_TYPES = {
  gaSuffix: 'homeinspector',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var PROPERTY_MANAGEMENT_INPUT_TYPES = {
  gaSuffix: 'propertymanager',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: [].concat(REG_PRO_DEFAULT_INPUTS, ['isCommunityPillar'])
};

var INVESTOR_INPUT_TYPES = {
  gaSuffix: 'investor',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: REG_PRO_DEFAULT_INPUTS
};

var OTHER_REAL_ESTATE_PRO_INPUT_TYPES = {
  gaSuffix: 'other',
  redirectUrl: REG_PRO_DEFAULT_REDIRECT_URL,
  requiredTypes: [].concat(REG_PRO_DEFAULT_INPUTS, ['isCommunityPillar'])

  // Used by reducer to determine current set of registration.
  // In current implementation array order here should match
  // dropdown select order.
};var REG_PRO_TYPES = exports.REG_PRO_TYPES = {
  0: REG_PRO_INPUT_TYPES, // default option
  1: REAL_ESTATE_AGENT_INPUT_TYPES,
  2: MORTGAGE_LENDER_INPUT_TYPES,
  3: HOME_IMPROVEMENT_INPUT_TYPES,
  4: OTHER_REAL_ESTATE_PRO_INPUT_TYPES,
  5: LANDLORD_INPUT_TYPES,
  6: PHOTOGRAPHER_INPUT_TYPES,
  7: HOME_BUILDER_INPUT_TYPES,
  8: HOME_INSPECTOR_INPUT_TYPES,
  9: PROPERTY_MANAGEMENT_INPUT_TYPES,
  10: INVESTOR_INPUT_TYPES,
  11: OTHER_REAL_ESTATE_PRO_INPUT_TYPES
};

var INPUT_TYPES = exports.INPUT_TYPES = {
  areaCode: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^\d{3}$/.test(input)
      );
    },
    props: {
      type: 'tel',
      placeholder: '555',
      maxLength: 3,
      errorText: 'Enter a valid 3-digit area code'
    }
  },
  authProcess: {
    defaultValue: '',
    props: {
      type: 'hidden'
    }
  },
  authToken: {
    defaultValue: '',
    props: {
      type: 'hidden'
    }
  },
  isCommunityPillar: {
    defaultValue: false,
    props: {
      id: 'isCommunityPillar',
      label: 'I am a Community Pillar'
    }
  },
  email: {
    defaultValue: '',
    validator: function validator(input, _, state, dispatch) {

      // Once a Candian Email address is detected,
      // the consent box will be always shown
      if (!state.login.showEmailConsent && /\.ca$/.test(input)) {
        dispatch((0, _actions.toggleEmailConsentDisplay)());
      }

      return EMAIL_VALIDATION_REGEX.test(input);
    },
    props: {
      type: 'email',
      placeholder: 'Enter email',
      autoComplete: 'email',
      errorText: 'Enter a valid email address',
      id: 'reg-login-email'
    }
  },
  emailConsent: {
    defaultValue: false,
    props: {
      id: 'emailConsent',
      label: 'By checking the box, I consent to receive emails from Zillow, including newsletters, alerts, updates, invitations, promotions and other news and notifications'
    }
  },
  firstName: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^.{1,20}$/.test(input)
      );
    },
    props: {
      type: 'text',
      placeholder: 'First name',
      errorText: 'Enter your first name, not to exceed 20 characters'
    }
  },
  lastName: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^.{1,20}$/.test(input)
      );
    },
    props: {
      type: 'text',
      placeholder: 'Last name',
      errorText: 'Enter your last name, not to exceed 20 characters'
    }
  },
  newEmail: {
    defaultValue: '',
    validator: function validator(input, _, state, dispatch) {

      // Once a Candian Email address is detected,
      // the consent box will be always shown
      if (!state.login.showEmailConsent && /\.ca$/.test(input)) {
        dispatch((0, _actions.toggleEmailConsentDisplay)());
      }

      if (!EMAIL_VALIDATION_REGEX.test(input)) {
        return 'Enter a valid email address';
      }
      // async email existence check
      return new _promise2.default(function (resolve, reject) {
        (0, _actions.validateEmailUniqueness)(input, dispatch, resolve, reject);
      });
    },
    props: {
      type: 'email',
      placeholder: 'Enter email',
      autoComplete: 'email'
    }
  },
  newPassword: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^.{6,20}$/.test(input)
      );
    },
    props: {
      type: 'password',
      id: 'password',
      placeholder: 'Create password',
      autoComplete: 'new-password',
      errorText: 'Password must be between 6 and 20 characters'
    }
  },
  password: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^.+$/.test(input)
      );
    },
    props: {
      type: 'password',
      placeholder: 'Enter password',
      autoComplete: 'current-password',
      errorText: 'Please enter a password'
    }
  },
  phoneExt: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^\d{0,5}$/.test(input)
      );
    },
    props: {
      id: 'extension',
      type: 'tel',
      placeholder: '55555',
      maxLength: '5',
      errorText: 'Extension cannot exceed 5 digits'
    }
  },
  phonePrefix: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^\d{3}$/.test(input)
      );
    },
    props: {
      type: 'tel',
      placeholder: '555',
      maxLength: '3',
      errorText: 'Enter a valid 3-digit prefix'
    }
  },
  phoneSuffix: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^\d{4}$/.test(input)
      );
    },
    props: {
      type: 'tel',
      placeholder: '5555',
      maxLength: '4',
      errorText: 'Enter a valid 4-digit suffix'
    }
  },
  proCheck: {
    defaultValue: false,
    onChange: function onChange(_ref3, inputs, state, dispatch) {
      var value = _ref3.value;

      // GA tracking for is pro reg
      if (value) {
        var login = state.login,
            register = state.register;

        var currReducer = login || register;

        (0, _universalAnalytics.trackEvent)({
          action: 'procheckbox//',
          category: 'auth',
          label: currReducer.authProcess
        });
      }
    },
    props: {
      id: 'proCheck',
      label: 'I am a landlord or industry professional'
    }
  },
  /**
   * This property gets overwritten in our app entrypoint, but we still need this here as it is
   * referenced by our set/reset input fields actions
   */
  proSelect: {
    defaultValue: '0',
    validator: function validator(input) {
      return input !== '0';
    },
    props: {
      id: 'proSelect',
      options: DEFAULT_PRO_TYPE_OPTIONS,
      errorText: 'Please select a professional category'
    }
  },
  countrySelect: {
    defaultValue: '1',
    validator: function validator(input) {
      return input !== '0';
    },
    props: {
      id: 'countrySelect',
      options: COUNTRY_TYPE_OPTIONS,
      errorText: 'Please select a country'
    }
  },
  /**
   * zip code having format 5 digits for US
   * @return True if valid zipcode
   */
  zipCode: {
    defaultValue: '',
    validator: function validator(input) {
      return (/^\d{5}$/.test(input)
      );
    },
    props: {
      type: 'tel',
      id: 'inputs-zipCode',
      placeholder: 'Zip',
      maxLength: '5',
      errorText: 'Enter a valid zip code'
    }
  },
  /**
   * zip code for Canada
   * validates 3 or 6 alphanumeric without space (i.e. Canadian zipcode e.g: 'A1A1A1' / 'A1A 1A1' /'A1A')
   * @return True if valid zipcode
   */
  zipCodeCanada: {
    defaultValue: '',
    validator: function validator(input) {
      return CANADA_ZIPCODE_REGEX.test(input);
    },
    props: {
      type: 'text',
      id: 'inputs-zipCode',
      placeholder: 'Zip',
      maxLength: '7',
      errorText: 'Enter a valid zip code'
    }
  }
};

var STRONG_PASSWORD_NEW_PASSWORD_INPUT_CONFIG = exports.STRONG_PASSWORD_NEW_PASSWORD_INPUT_CONFIG = {
  defaultValue: '',
  validator: STRONG_PASSWORD_VALIDATOR,
  props: {
    type: 'password',
    id: 'password',
    placeholder: 'Create password',
    autoComplete: 'new-password',
    errorText: ''
  }
};

var LINK_TARGETS = exports.LINK_TARGETS = ['_blank', '_parent', '_self', '_top'];

// Form elements hidden behind professional checkbox on Register
var PROFESSIONAL_INPUTS = exports.PROFESSIONAL_INPUTS = ['areaCode', 'isCommunityPillar', 'firstName', 'lastName', 'phoneExt', 'phonePrefix', 'phoneSuffix', 'proSelect', 'countrySelect'];

// input fields that we are not allowed to be set through inputValues
var BLACKLISTED_INPUTS = exports.BLACKLISTED_INPUTS = ['password', 'newPassword'];

var PASSWORDLESS_APS = exports.PASSWORDLESS_APS = {
  saveHome: 'Save home'

  // redirect paths returned from server.  TODO: when no longer using YUI reg/login app update server to use the new ones?
};var SERVER_ROUTES = exports.SERVER_ROUTES = {
  '/user/account/PasswordRecovery': ROUTES.recovery
};

var STATUS_ERROR_CODES = exports.STATUS_ERROR_CODES = {
  redirect: {
    code: 300,
    errorMessage: 'Redirect error'
  },
  validation: {
    code: 400,
    errorMessage: 'Validation error'
  },
  notFound: {
    code: 404,
    errorMessage: 'Page not found'
  },
  conflict: {
    code: 409,
    errorMessage: 'Data conflict'
  },
  server: {
    code: 500,
    errorMessage: 'Server error'
  }
};

var SOCIAL_BUTTON_TYPES = exports.SOCIAL_BUTTON_TYPES = ['google-plus', 'facebook'];

var FORM_TEXT = exports.FORM_TEXT = {
  createAPasswordText: 'Create a password',
  createAPasswordMessage: 'Create a password to access your account on your phone, tablet, or computer',
  emailConfirmedText: 'Email confirmed',
  forgotPasswordLink: 'Forgot your password?',
  forgotPasswordPasswordless: 'Create a password',
  invalidTokenMsgText: 'Email could not be confirmed',
  invalidTokenMsgMessage: 'Your email could not be confirmed because the link you clicked is expired or invalid. Please click below to try again.',
  knowPasswordText: 'Know your password?',
  loginText: 'Already have an account?',
  loginLink: SIGN_IN,
  registerText: 'Don\'t have an account?',
  registerLink: SIGN_UP,
  passwordRecovery: 'For security, confirm that you own this account by clicking the link in the email we just sent you and then update your password.',
  welcomeBack: 'Welcome back to Zillow!'
};

var TAB_TYPES = exports.TAB_TYPES = {
  login: {
    text: SIGN_IN,
    url: ROUTES.login
  },
  register: {
    text: 'New account',
    url: ROUTES.register
  }

  // Form text
};var COMMUNITY_PILLAR_DESCRIPTION = exports.COMMUNITY_PILLAR_DESCRIPTION = '\n  A Community Pillar landlord has agreed to modify their standard tenant\n  screening process in order to help applicants with potential rental\n  barriers - such as low incomes, spotty credit scores, unemployment, or\n  lack of housing references - be able to obtain housing. These landlords\n  know that securing safe and reliable housing is often the first step\n  towards a brighter future, and they want to help everyone in their\n  community find their way home.\n  ';
var PHONE_LABEL = exports.PHONE_LABEL = 'Cell phone';

// Social error messages
var FB_NOT_AUTHENTICATED = exports.FB_NOT_AUTHENTICATED = 'User has not authorized app to connect to Facebook.';
var FB_NOT_LOGGED_IN = exports.FB_NOT_LOGGED_IN = 'User is not logged in to Facebook.';

// Default auth process event label
var DEFAULT_AUTH_PROCESS = exports.DEFAULT_AUTH_PROCESS = '';

//DEPRECATED events, remove once regLogin refactor has shipped and we
// made sure no one else relies on these
var APP_REDIRECT = exports.APP_REDIRECT = 'auth:app_redirect';
var APP_LOAD = exports.APP_LOAD = 'auth:app_load';
var LIGHTBOX_HIDDEN = exports.LIGHTBOX_HIDDEN = 'auth:lightbox_hidden';
var AUTHENTICATED = exports.AUTHENTICATED = 'auth:authenticated';
var SUBMIT_SUCCESS = exports.SUBMIT_SUCCESS = 'auth:submit_success';

// Client Profiler
var LOGIN_PROFILE_SUBMIT = exports.LOGIN_PROFILE_SUBMIT = 'reglogin:login_submit';
var REGISTER_PROFILE_SUBMIT = exports.REGISTER_PROFILE_SUBMIT = 'reglogin:register_submit';

// Local Storage
var LS_NAMESPACE = exports.LS_NAMESPACE = 'REG_LOGIN:';
var LS_REDIRECT_URL = exports.LS_REDIRECT_URL = 'redirectUrl';

// Action types
var APP_MOUNTED = exports.APP_MOUNTED = 'APP_MOUNTED';
var LOGGED_IN = exports.LOGGED_IN = 'LOGGED_IN';
var AUTH_PROCESS = exports.AUTH_PROCESS = 'AUTH_PROCESS';
var AUTH_TOKEN = exports.AUTH_TOKEN = 'AUTH_TOKEN';
var FORM_VALIDATED = exports.FORM_VALIDATED = 'FORM_VALIDATED';
var HIDE_EMAIL_FORM = exports.HIDE_EMAIL_FORM = 'HIDE_EMAIL_FORM';
var HIDE_FB_CONNECT_ERROR = exports.HIDE_FB_CONNECT_ERROR = 'HIDE_FB_CONNECT_ERROR';
var INIT_FB_CONNECT = exports.INIT_FB_CONNECT = 'INIT_FB_CONNECT';
var NETWORK_ERROR = exports.NETWORK_ERROR = 'NETWORK_ERROR';
var REGISTER_CONTEXT = exports.REGISTER_CONTEXT = 'REGISTER_CONTEXT';
var RESET_FIELDS = exports.RESET_FIELDS = 'RESET_FIELDS';
var RESET_FORM_ERROR = exports.RESET_FORM_ERROR = 'RESET_FORM_ERROR';
var RESPONSE_RECEIVED = exports.RESPONSE_RECEIVED = 'RESPONSE_RECEIVED';
var SET_FB_CONNECT_ERROR = exports.SET_FB_CONNECT_ERROR = 'SET_FB_CONNECT_ERROR';
var SHOW_EMAIL_FORM = exports.SHOW_EMAIL_FORM = 'SHOW_EMAIL_FORM';
var SHOW_FB_CONNECT_ERROR = exports.SHOW_FB_CONNECT_ERROR = 'SHOW_FB_CONNECT_ERROR';
var SUBMIT_FORM = exports.SUBMIT_FORM = 'SUBMIT_FORM';
var TOGGLE_EMAIL_CONSENT_DISPLAY = exports.TOGGLE_EMAIL_CONSENT_DISPLAY = 'TOGGLE_EMAIL_CONSENT_DISPLAY';
var SET_EMAIL_CONSENT_DISPLAY = exports.SET_EMAIL_CONSENT_DISPLAY = 'SET_EMAIL_CONSENT_DISPLAY';
var SET_GEOIP_API_CALLED = exports.SET_GEOIP_API_CALLED = 'SET_GEOIP_API_CALLED';
var VALIDATE_ON_KEYUP = exports.VALIDATE_ON_KEYUP = 'VALIDATE_ON_KEYUP';
var UI_CONFIG = exports.UI_CONFIG = 'UI_CONFIG';
var UPDATE_VALID_EMAIL_TOKEN = exports.UPDATE_VALID_EMAIL_TOKEN = 'UPDATE_VALID_EMAIL_TOKEN';
var SET_ON_CLOSE = exports.SET_ON_CLOSE = 'SET_ON_CLOSE';
var SET_NEW_PASSWORD_VALIDATION_MESSAGES = exports.SET_NEW_PASSWORD_VALIDATION_MESSAGES = 'SET_NEW_PASSWORD_VALIDATION_MESSAGES';
var OVERRIDE_PRO_SELECTION = exports.OVERRIDE_PRO_SELECTION = 'OVERRIDE_PRO_SELECTION';

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@zillow/universal-analytics");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/extends");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/get-prototype-of");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/classCallCheck");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/createClass");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/inherits");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("react-router-dom");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@zillow/zsg-redux-inputs");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@zillow/user-session-store-connect");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmailUniqueness = exports.setEmailConsentIfCanada = exports.toggleEmailConsentDisplay = exports.handleInvalidEmailCheck = exports.syncInputValues = exports.submitForm = exports.errorOnFormSubmitFailure = exports.handleFormSubmitSuccess = exports.resetPasswordValidation = exports.setNewPasswordValidationMessages = exports.setOnClose = exports.validateForm = exports.setInputValues = exports.showEmailForm = exports.handlePasswordlessSigninFailure = exports.handlePasswordlessSigninSuccess = exports.resetProfessionalForm = exports.resetFormError = exports.resetFields = exports.mobileUserLoggedIn = exports.isOptOut = exports.hideFacebookError = exports.hideEmailForm = exports.handleLoginRedirect = exports.handleForgotSuccess = exports.handleFacebookConnectionFailure = exports.handleFacebookConnectClick = exports.handleLoggedIn = exports.handleServerRedirect = exports.handleError = undefined;

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = __webpack_require__(4);

var _extends7 = _interopRequireDefault(_extends6);

var _typeof2 = __webpack_require__(37);

var _typeof3 = _interopRequireDefault(_typeof2);

var _superagent = __webpack_require__(24);

var _superagent2 = _interopRequireDefault(_superagent);

var _launcherBase = __webpack_require__(55);

var _stateRegionIdMap = __webpack_require__(56);

var _zsgReduxInputs = __webpack_require__(11);

var _userSessionStoreActions = __webpack_require__(21);

var _forms = __webpack_require__(57);

var _constants = __webpack_require__(2);

var _eventUtils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint no-unused-vars:0*/
var _hideEmailForm = function _hideEmailForm() {
  return { type: _constants.HIDE_EMAIL_FORM };
}; // TODO: keep/discard after Social Login AB test is resolved.
var _hideFbConnectError = function _hideFbConnectError() {
  return { type: _constants.HIDE_FB_CONNECT_ERROR };
};
var _networkError = function _networkError(errorMessage) {
  return { message: errorMessage, type: _constants.NETWORK_ERROR };
};
var _resetProfessionalForm = function _resetProfessionalForm() {
  return { type: _constants.RESET_FIELDS };
};
var _resetFormError = function _resetFormError() {
  return { type: _constants.RESET_FORM_ERROR };
};
var _setFbConnectError = function _setFbConnectError(errorMsg) {
  return { message: errorMsg, type: _constants.SET_FB_CONNECT_ERROR };
};
var _setRegisterContext = function _setRegisterContext(contextData) {
  return { contextData: contextData, type: _constants.REGISTER_CONTEXT };
};
var _showEmailForm = function _showEmailForm() {
  return { type: _constants.SHOW_EMAIL_FORM };
}; // TODO: keep/discard after Social Login AB test is resolved.
var _showFbConnectError = function _showFbConnectError() {
  return { type: _constants.SHOW_FB_CONNECT_ERROR };
};
var _switchToKeyupValidation = function _switchToKeyupValidation() {
  return { type: _constants.VALIDATE_ON_KEYUP };
};
var _toggleEmailConsentDisplay = function _toggleEmailConsentDisplay() {
  return { type: _constants.TOGGLE_EMAIL_CONSENT_DISPLAY };
};
var _setEmailConsentIfCanada = function _setEmailConsentIfCanada() {
  return { type: _constants.SET_EMAIL_CONSENT_DISPLAY };
};
var _setGeoIPApiCalled = function _setGeoIPApiCalled() {
  return { type: _constants.SET_GEOIP_API_CALLED };
};
var _validateForm = function _validateForm(validated) {
  return { type: _constants.FORM_VALIDATED, validated: validated };
};
var _setOnClose = function _setOnClose(onClose) {
  return { type: _constants.SET_ON_CLOSE, onClose: onClose };
};
var _setNewPasswordValidationMessages = function _setNewPasswordValidationMessages(messages) {
  return { type: _constants.SET_NEW_PASSWORD_VALIDATION_MESSAGES, messages: messages };
};
var _overrideProSelection = function _overrideProSelection() {
  return { type: _constants.OVERRIDE_PRO_SELECTION };
};

/**
 * Communicates error details to client.
 * @kind function
 * @param  {Number} code
 *                    network status code
 * @param  {String} message
 *                    display message associated with error
 * @return {Object} action payload
 */
var handleError = exports.handleError = function handleError(code, message) {
  if (message) {
    return _networkError(message);
  }

  var redirect = _constants.STATUS_ERROR_CODES.redirect,
      validation = _constants.STATUS_ERROR_CODES.validation,
      notFound = _constants.STATUS_ERROR_CODES.notFound,
      conflict = _constants.STATUS_ERROR_CODES.conflict,
      server = _constants.STATUS_ERROR_CODES.server;


  switch (code) {
    case redirect.code:
      return _networkError(redirect.errorMessage);

    case validation.code:
      return _networkError(validation.errorMessage);

    case notFound.code:
      return _networkError(notFound.errorMessage);

    case conflict.code:
      return _networkError(conflict.errorMessage);

    case server.code:
      return _networkError(server.errorMessage);

    default:
      return null;
  }
};

/**
 * Redirects based on redirect values from server
 * @param {Array}  router
 *                   array of visited routes
 * @param {String} redirectLink
 *                   link type to redirect to
 */
var handleServerRedirect = exports.handleServerRedirect = function handleServerRedirect(router, redirectLink) {
  var route = _constants.SERVER_ROUTES[redirectLink];

  if (route) {
    router.push(route);
  }
};

/**
 * Sets logged in to true and hides lightbox via user session dispatch.
 * NOTE: NOT A REDUX ACTION!
 * @kind function
 * @param {Boolean} persistLightbox - whether to keep lightbox showing after login
 * @param {Object}  payload - (DEPRECATED) custom event payload
 * @param {String}  redirectUrl - URL to redirect to when specified
 */
var handleLoggedIn = exports.handleLoggedIn = function handleLoggedIn() {
  var persistLightbox = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var redirectUrl = arguments[2];

  // redirect to designated URL
  if (window && redirectUrl) {
    window.location.href = redirectUrl;
  }
  // dispatch user session loggedIn action
  (0, _userSessionStoreActions.setUserLoggedIn)();

  //DEPRECATED
  (0, _eventUtils.trigger)(_constants.AUTHENTICATED, payload);

  // dispatch user session hide lightbox actions
  if (!persistLightbox) {
    (0, _userSessionStoreActions.hideRegLoginLightbox)();
  }
};

/**
 * Toggle auth view changes on Facebook click.
 * @kind function
 */
var handleFacebookConnectClick = exports.handleFacebookConnectClick = function handleFacebookConnectClick() {
  return function (dispatch) {
    dispatch(_showFbConnectError());
  };
};

/**
 * Sets error message for Facebook status.
 * @kind function
 * @param {String} errorMsg
 *                   message to display below social buttons
 */
var handleFacebookConnectionFailure = exports.handleFacebookConnectionFailure = function handleFacebookConnectionFailure(errorMsg) {
  return function (dispatch) {
    dispatch(_setFbConnectError(errorMsg));
  };
};

/**
 * Redirects successful forgot password attempt.
 * @kind function
 */
var handleForgotSuccess = exports.handleForgotSuccess = function handleForgotSuccess(router) {
  return function () {
    router.push(_constants.ROUTES.forgotSuccess);
  };
};

/**
 * Redirects when server returns redirectLink
 * @kind function
 * @param {Array}  router
 *                   array of visited routes
 * @param {String} link
 *                   link type to redirect to
 */
var handleLoginRedirect = exports.handleLoginRedirect = function handleLoginRedirect(router, link) {
  handleServerRedirect(router, link);
};

// TODO: keep/discard after Social Login AB test is resolved.
/**
 * Conceals email form inputs.
 * @kind function
 */
var hideEmailForm = exports.hideEmailForm = function hideEmailForm() {
  return function (dispatch) {
    dispatch(_hideEmailForm());
  };
};

/**
 * Conceals Facebook error message.
 * @kind function
 */
var hideFacebookError = exports.hideFacebookError = function hideFacebookError() {
  return function (dispatch) {
    dispatch(_hideFbConnectError());
  };
};

var isOptOut = exports.isOptOut = function isOptOut(email) {
  var showEmailOptIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // Canadian law requires new users opt in to email subscriptions
  var isCanadianEmail = /\.ca$/.test(email);

  return isCanadianEmail || showEmailOptIn;
};

/**
 * Wrapper for ZMOB native API userLoggedIn method.
 * @param {String} args.emailAddress
 * @param {String} args.zuid
 * @param {String} args.reason
 */
var mobileUserLoggedIn = exports.mobileUserLoggedIn = function mobileUserLoggedIn() {
  var _window$ZMOB_nativeAP;

  (0, _typeof3.default)(window.ZMOB_nativeAPI) === 'object' && typeof window.ZMOB_nativeAPI.userLoggedIn === 'function' && (_window$ZMOB_nativeAP = window.ZMOB_nativeAPI).userLoggedIn.apply(_window$ZMOB_nativeAP, arguments) || _constants.NOOP.apply(undefined, arguments);
};

/**
 * Returns action payload with specified
 * inputs to be reset.
 * @kind function
 * @param  {Array}    inputKeys
 *                      array of keys in INPUT_TYPES to reset
 * @param  {Array}    preservedKeys
 *                      array of keys in INPUT_TYPES to preserve value (suppress validation error)
 * @return {Function} dispatch handler
 */
var resetFields = exports.resetFields = function resetFields() {
  var inputKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var preservedKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch, getState) {
    var props = (0, _zsgReduxInputs.getInputProps)(_constants.INPUT_TYPES, getState().inputs);

    var changes = preservedKeys.reduce(function (accu, key) {
      if (props.hasOwnProperty(key) && props[key] && props[key].value) {
        return (0, _extends7.default)({}, accu, (0, _defineProperty3.default)({}, key, {
          value: props[key].value
        }));
      }

      return accu;
    }, {});

    var filtered = [].concat((0, _toConsumableArray3.default)(inputKeys), (0, _toConsumableArray3.default)(preservedKeys)).reduce(function (accu, key) {
      if (_constants.INPUT_TYPES.hasOwnProperty(key)) {
        return (0, _extends7.default)({}, accu, (0, _defineProperty3.default)({}, key, _constants.INPUT_TYPES[key]));
      }

      return accu;
    }, {});

    dispatch((0, _zsgReduxInputs.resetInputs)(filtered));
    dispatch((0, _zsgReduxInputs.setInputs)(_constants.INPUT_TYPES, changes));
  };
};

/**
 * Clear error messages below form.
 * @kind function
 * @return {Function} dispatched callback
 */
var resetFormError = exports.resetFormError = function resetFormError() {
  return function (dispatch) {
    dispatch(_resetFormError());
  };
};

/**
 * Returns action payload with specified
 * inputs to be reset on checkbox toggle.
 * @kind function
 * @param  {Array}    additionalKeys
 *                      array of keys in INPUT_TYPES to reset
 * @return {Function} dispatch handler
 */
var resetProfessionalForm = exports.resetProfessionalForm = function resetProfessionalForm() {
  var additionalKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var shouldOverrideProSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(_resetProfessionalForm());
    if (shouldOverrideProSelection) {
      dispatch(_overrideProSelection());
    }
    // Need to dispatch as resetInputs returns an action object
    return dispatch(resetFields([].concat((0, _toConsumableArray3.default)(_constants.PROFESSIONAL_INPUTS), (0, _toConsumableArray3.default)(additionalKeys))));
  };
};

/**
 * Get token from redirectLink and updates state
 *
 * @kind function
 * @param {String} redirectLink
 *                  redirect string from response that contains token
 */
var _getAndUpdateAuthToken = function _getAndUpdateAuthToken(redirectLink) {
  if (typeof redirectLink === 'string') {
    var tokenMatch = redirectLink.match(/token=([\w-]*)&?/);

    if (tokenMatch !== null && tokenMatch[1]) {
      (0, _userSessionStoreActions.setUserAuthToken)(tokenMatch[1]);
    }
  }
};

/**
 * Handler for passwordLessSignin success
 * Response returns a 300 and we route based on these scenarios:
 *  succeeded - email does not exist so uer is logged in through freepass, proceed
 *    to create a password form
 *
 * @kind function
 * @param {Object} data
 *                  response body with redirectLink props
 * @param {Object} router
 *                  router object
 */
var handlePasswordlessSigninSuccess = exports.handlePasswordlessSigninSuccess = function handlePasswordlessSigninSuccess(data, router) {
  return function () {
    _getAndUpdateAuthToken(data.redirectLink);
    router.push(_constants.ROUTES.passwordlessCreatePassword);

    return null;
  };
};
/**
 * Handler for passwordLessSignin failure
 * Response returns a 300 and we route based on these scenarios:
 *  !succeeded && hasPassword - email exists and has a password, proceed to login
 *  !succeeded && !hasPassword - email exists but has no password. Redirect to
 *    password recovery
 *
 * @kind function
 * @param {Boolean} hasPassword
 *                  if submitted email has an existing pw or not
 * @param {Object} router
 *                  router object
 */
var handlePasswordlessSigninFailure = exports.handlePasswordlessSigninFailure = function handlePasswordlessSigninFailure(hasPassword, router) {
  return function () {
    if (hasPassword) {
      router.push(_constants.ROUTES.login);
    } else {
      router.push(_constants.ROUTES.recovery);
    }

    return null;
  };
};

// TODO: keep/discard after Social Login AB test is resolved.
/**
 * Reveals email form inputs.
 * @kind function
 */
var showEmailForm = exports.showEmailForm = function showEmailForm() {
  return function (dispatch) {
    dispatch(_showEmailForm());
  };
};

/**
 * Set input values
 * @kind function
 * @param {Object} inputValues
 *                  input values to be updated { inputName: inputValue }
 * @param  {Function} dispatch
 *                      store dispatch function
 *
 * @return {Function} dispatched callback
 */
var setInputValues = exports.setInputValues = function setInputValues(inputValues) {
  return function (dispatch) {
    var inputs = (0, _keys2.default)(inputValues).reduce(function (accu, key) {
      if (inputValues[key]) {
        return (0, _extends7.default)({}, accu, (0, _defineProperty3.default)({}, key, { value: inputValues[key] }));
      }

      return accu;
    }, {});

    dispatch((0, _zsgReduxInputs.setInputs)(_constants.INPUT_TYPES, inputs));
  };
};

/**
 * Set validate form
 * @kind function
 * @param  {Boolean} validated
 *                    if input values pass validation
 * @return {Function} dispatched callback
 */
var validateForm = exports.validateForm = function validateForm(validated) {
  return function (dispatch) {
    dispatch(_validateForm(validated));
  };
};

/**
 * Set onClose for Corelayout
 * @param {Function} onClose
 */
var setOnClose = exports.setOnClose = function setOnClose(onClose) {
  return function (dispatch) {
    dispatch(_setOnClose(onClose));
  };
};

/**
 * Set new password validation messages
 * @param {Array} messages
 *                  array of valiation messages {status: 'pass', message: 'foo}
 * @return {Function} dispatched callback
 */
var setNewPasswordValidationMessages = exports.setNewPasswordValidationMessages = function setNewPasswordValidationMessages(messages) {
  return function (dispatch) {
    dispatch(_setNewPasswordValidationMessages(messages));
  };
};

/**
 * Reset password validation messages to its initial state and set form validation state back to false
 */
var resetPasswordValidation = exports.resetPasswordValidation = function resetPasswordValidation() {
  return function (dispatch) {
    dispatch(_setNewPasswordValidationMessages((0, _constants.getNewPasswordValidationMessagesInitialState)()));
    dispatch(_validateForm(false));
  };
};

/**
 * Wrapper for form submit success handler
 * @param {Function} successHandler
 *                     success callback
 * @param {Object}   responseBody
 *                     response object passed
 * @param {String}   authToken
 *                     authToken to be set
 */
var handleFormSubmitSuccess = exports.handleFormSubmitSuccess = function handleFormSubmitSuccess(successHandler, responseBody, authToken) {
  // update authToken if provided
  if (authToken) {
    (0, _userSessionStoreActions.setUserAuthToken)(authToken);
  }

  successHandler(responseBody);
};

/**
 * Wrapper for form submit error handler
 * @param {Function} errorHandler
 *                     error callback
 * @param {Object}   errorObject
 *                     error object passed
 * @param {Object}   responseBody
 *                     response object passed
 * @returns {Function} dispatcher
 */
var errorOnFormSubmitFailure = exports.errorOnFormSubmitFailure = function errorOnFormSubmitFailure(errorHandler, errorObject, responseBody) {
  return function (dispatch) {
    var validationErrors = responseBody.validationErrors,
        redirectLink = responseBody.redirectLink,
        hasPassword = responseBody.hasPassword;


    if (redirectLink) {
      errorHandler(errorObject, redirectLink, hasPassword);
    } else {
      // All errors in same element for now.
      dispatch(handleError(errorObject.status,
      // Unique error message text on multiple lines.
      (0, _forms.uniqueObjectValuesToArray)(validationErrors).join('\n')));
      errorHandler(errorObject);
    }
  };
};

/**
 * Wires error handling into form submit.
 * @kind function
 * @param  {Object} options - submit endpoint, data payload, success and error callbacks
 * @return {Function} request handling with dispatched callback
 */
var submitForm = exports.submitForm = function submitForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch) {
    // Option defaults
    var path = options.path || '/';
    var data = options.data || {};
    var success = options.success || function (resBody) {
      return resBody;
    };
    var error = options.error || function (err) {
      return console.log(err.status);
    };

    _superagent2.default.post(path).send((0, _forms.serialize)(data)).end(function (err, res) {
      // Register endpoint used by freepass returns 300, which we are treating as a
      // success. So current error checking relies on succeeded flag in res.body.
      // TODO: update to handle errors from somewhere other than AUTH endpoints.
      if (res.ok || res.body && res.body.succeeded === true) {
        handleFormSubmitSuccess(success, res.body, res.body && res.body.authToken);
      } else {
        dispatch(errorOnFormSubmitFailure(error, err, res.body));
      }
    });
  };
};

/**
 * Updates list of clone inputs to mirror value of specified input object
 * @kind function
 * @param  {Object}    originalInput
 *                       input object whose value needs to be cloned
 * @param  {...String} clones
 *                       input keys from INPUT_TYPES config to update value
 * @return {Function}  request handling with dispatched callback
 */
var syncInputValues = exports.syncInputValues = function syncInputValues(originalInput) {
  for (var _len = arguments.length, clones = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    clones[_key - 1] = arguments[_key];
  }

  return function (dispatch) {
    var value = originalInput.value;

    var changes = clones.reduce(function (accu, key) {
      return (0, _extends7.default)({}, accu, (0, _defineProperty3.default)({}, key, value));
    }, {});

    // Catching the exception with a NOOP to avoid an unhandled promise rejection
    // when syncing newEmail with an existing email/account
    dispatch((0, _zsgReduxInputs.updateAndValidate)(_constants.INPUT_TYPES, changes)).catch(_constants.NOOP);
  };
};

/**
 * Handler for invalid email check (generally duplicate or failed server-side validation)
 * @param {String}   invalidType
 *                     error type returned
 * @param {String}   emailAddress
 *                     invalid email
 * @param {Function} resolveHandler
 *                     resolve callback
 * @param {Function} rejectHandler
 *                     reject callback
 * @return {Function} dispatcher
 */
var handleInvalidEmailCheck = exports.handleInvalidEmailCheck = function handleInvalidEmailCheck(invalidType, emailAddress, resolveHandler, rejectHandler) {
  return function (dispatch) {
    switch (invalidType) {
      case 'DuplicateEmail':
        dispatch(_switchToKeyupValidation());
        dispatch((0, _zsgReduxInputs.setInputs)(_constants.INPUT_TYPES, { email: { value: emailAddress } }));
        rejectHandler('Email already exists');
        break;

      case 'InvalidEmail':
        dispatch(_switchToKeyupValidation());
        rejectHandler('Enter a valid email address');
        break;

      default:
        resolveHandler();
    }
  };
};

var toggleEmailConsentDisplay = exports.toggleEmailConsentDisplay = function toggleEmailConsentDisplay() {
  return function (dispatch) {
    dispatch(_toggleEmailConsentDisplay());
  };
};

/**
 * Calls GeoIPService endpoint and sets showEmailConsent when Canada country code
 * @kind function
 */
var setEmailConsentIfCanada = exports.setEmailConsentIfCanada = function setEmailConsentIfCanada() {
  return function (dispatch) {
    return Promise.resolve().then(function () {
      return _superagent2.default.get(_constants.GEOIP_SERVICE_ENDPOINT).then(function (response) {
        dispatch(_setGeoIPApiCalled());
        if ((0, _stateRegionIdMap.isCanadian)(response.body.countryCode)) {
          dispatch(_setEmailConsentIfCanada());
        }
      }).catch(function (err) {
        console.error(err);
      });
    }).then(function () {});
  };
};

/**
 * Async database check on email existence.
 * @kind function
 * @param  {String}   emailAddress
 *                      email address to verify is unique
 * @param  {Function} dispatch
 *                      store dispatch function
 * @param  {Function} resolve
 *                      resolve callback provided by asyncValidator
 * @param  {Function} reject
 *                      reject callback provided by asyncValidator
 */
var validateEmailUniqueness = exports.validateEmailUniqueness = function validateEmailUniqueness(email, dispatch, resolve, reject) {
  _superagent2.default.post(_constants.ROUTES.emailCheck).send((0, _forms.serialize)({ email: email })).end(function (err, res) {
    if (err || !res.ok) {
      dispatch(handleInvalidEmailCheck(res.body.key, email, resolve, reject));
    } else {
      resolve();
    }
  });
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewWrapper = function ViewWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: 'user-account ' + className },
    _react2.default.createElement(
      'div',
      { className: 'module-wrap' },
      children
    )
  );
};

ViewWrapper.propTypes = {
  children: _propTypes2.default.array,
  className: _propTypes2.default.string
};

ViewWrapper.defaultProps = {
  className: 'login'
};

exports.default = ViewWrapper;
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BodyWrapper = function BodyWrapper(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'module-body' },
    children
  );
};

BodyWrapper.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = BodyWrapper;
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var children = _ref.children,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'module-head' },
    _react2.default.createElement(
      'h2',
      null,
      text
    ),
    children && _react2.default.createElement(
      'p',
      null,
      children
    )
  );
};

Header.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
  text: _propTypes2.default.string.isRequired
};

exports.default = Header;
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/Form");

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _after2 = __webpack_require__(53);

var _after3 = _interopRequireDefault(_after2);

exports.default = function (pageURL) {
    var doTrack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !_constants.APP_CONFIG.isLightbox;

    // sync any react-router path changes with the global store's regLogin path
    syncAfterInitalLoad(pageURL);

    if (doTrack) {
        (0, _universalAnalytics.trackPageview)({ pageURL: pageURL });
    }

    // TODO: Why do we need this????
    // store.dispatch(setOnClose(onCloseCb));
};

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreActions = __webpack_require__(21);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ACT-1702: ignore first onEnter to avoid race condition for path state set
// in user-session-store before initial app load.
var syncAfterInitalLoad = (0, _after3.default)(2, function (path) {
    (0, _userSessionStoreActions.setRegLoginPath)(path);
});

module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
  var border = _ref.border,
      text = _ref.text,
      children = _ref.children;

  var classes = (0, _classnames2.default)('module-footer', (0, _defineProperty3.default)({}, 'line-' + border, typeof border !== 'undefined'));

  return _react2.default.createElement(
    'div',
    { className: classes },
    text && _react2.default.createElement(
      'span',
      null,
      text
    ),
    children
  );
};

Footer.propTypes = {
  border: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left', 'none']),
  children: _propTypes2.default.node,
  text: _propTypes2.default.string
};

exports.default = Footer;
module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputProps = undefined;

var _zsgReduxInputs = __webpack_require__(11);

var getInputProps = exports.getInputProps = function getInputProps(types, inputs) {
  return function (dispatch) {
    return (0, _zsgReduxInputs.getInputProps)(types, inputs, dispatch);
  };
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("@zillow/user-session-store-actions");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormError = function FormError(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'error zsg-form-field_error' },
    _react2.default.createElement(
      'strong',
      { className: 'zsg-form-error-text' },
      text
    )
  );
};

FormError.propTypes = {
  text: _propTypes2.default.string.isRequired
};

exports.default = FormError;
module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appSubView = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Checks for valid subarray of supported views
var appSubView = exports.appSubView = _propTypes2.default.arrayOf(function (propVal, key, componentName, location, propFullName) {
    if (_constants.APP_VIEWS.indexOf(propVal[key]) === -1) {
        return new Error('Invalid prop ' + propFullName + ' supplied to ' + componentName + '.\n            Must be subest of ' + _constants.APP_VIEWS + '.');
    }

    return true;
});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("superagent");

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExternalLink = __webpack_require__(64);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsOfUse = function TermsOfUse(_ref) {
  var _ref$showToggleLink = _ref.showToggleLink,
      showToggleLink = _ref$showToggleLink === undefined ? false : _ref$showToggleLink,
      toggleEmailConsentDisplay = _ref.toggleEmailConsentDisplay;
  return _react2.default.createElement(
    'div',
    { className: 'zsg-fineprint' },
    showToggleLink && _react2.default.createElement(
      'a',
      { onClick: toggleEmailConsentDisplay },
      'Outside the US?'
    ),
    _react2.default.createElement(
      'p',
      null,
      'I accept Zillow\'s ',
      _react2.default.createElement(_ExternalLink2.default, { text: 'Terms of Use', url: '/corp/Terms.htm', target: '_blank' })
    )
  );
};

// ShowToggleLink: this bool controls the display of `Outside the US?` link
// toggleEmailConsentDisplay: this function will toggle the dislplay of `Outside the US?` link
TermsOfUse.propTypes = {
  showToggleLink: _propTypes2.default.bool,
  toggleEmailConsentDisplay: _propTypes2.default.func
};

exports.default = TermsOfUse;
module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/keys");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _FacebookLogin = __webpack_require__(60);

var _FacebookLogin2 = _interopRequireDefault(_FacebookLogin);

var _GooglePlusSignin = __webpack_require__(61);

var _GooglePlusSignin2 = _interopRequireDefault(_GooglePlusSignin);

var _GoogleLogo = __webpack_require__(62);

var _GoogleLogo2 = _interopRequireDefault(_GoogleLogo);

var _actions = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLogins = function SocialLogins(props) {
  var onLoginSuccess = props.onLoginSuccess,
      facebookAppId = props.facebookAppId,
      gaLabel = props.gaLabel,
      _props$social = props.social,
      fbErrorMessage = _props$social.fbErrorMessage,
      showFbError = _props$social.showFbError;


  return _react2.default.createElement(
    'span',
    { className: 'social-logins' },
    _react2.default.createElement(
      _FacebookLogin2.default,
      {
        className: 'btn-social-connect btn-facebook',
        handleFacebookConnectClick: props.handleFacebookConnectClick,
        handleFacebookConnectionFailure: props.handleFacebookConnectionFailure,
        onSuccess: onLoginSuccess,
        gaLabel: gaLabel,
        appId: facebookAppId },
      _react2.default.createElement('span', { className: 'zsg-icon-facebook' })
    ),
    _react2.default.createElement(
      _GooglePlusSignin2.default,
      {
        className: 'btn-social-connect btn-google-plus',
        onSuccess: onLoginSuccess,
        gaLabel: gaLabel },
      _react2.default.createElement(_GoogleLogo2.default, { dimensions: 30, badge: true, className: 'social-icon-google-g' })
    ),
    fbErrorMessage && showFbError && _react2.default.createElement(
      'div',
      { className: 'social-error-msg' },
      fbErrorMessage
    )
  );
};

SocialLogins.propTypes = {
  onLoginSuccess: _propTypes2.default.func.isRequired,
  gaLabel: _propTypes2.default.string.isRequired,
  facebookAppId: _propTypes2.default.string.isRequired,
  handleFacebookConnectClick: _propTypes2.default.func,
  handleFacebookConnectionFailure: _propTypes2.default.func,
  social: _propTypes2.default.object
};

var mapDispatchToProps = {
  handleFacebookConnectClick: _actions.handleFacebookConnectClick,
  handleFacebookConnectionFailure: _actions.handleFacebookConnectionFailure
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    social: state.social
  };
};

exports.default = (0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(SocialLogins);
module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = require("@zillow/event-utils");

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = require("@zillow/client-profiler");

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _omit2 = __webpack_require__(32);

var _omit3 = _interopRequireDefault(_omit2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zsgReduxInputs = __webpack_require__(11);

var _constants = __webpack_require__(2);

var _ValidationMessage = __webpack_require__(65);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _StrengthMeter = __webpack_require__(66);

var _StrengthMeter2 = _interopRequireDefault(_StrengthMeter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = function PasswordInput(props) {
  var value = props.value,
      validationMessages = props.validationMessages;

  var inputProps = (0, _omit3.default)(props, ['validationMessages']);
  var validationMarkup = null;

  if (validationMessages) {
    validationMarkup = validationMessages.map(function (_ref, i) {
      var validated = _ref.validated,
          message = _ref.message;

      var status = validated ? 'pass' : value ? 'fail' : 'neutral';
      return message ? _react2.default.createElement(
        'li',
        { key: i },
        _react2.default.createElement(_ValidationMessage2.default, { text: message, status: status })
      ) : null;
    });
  }

  return _react2.default.createElement(
    'div',
    { className: 'password-input' },
    _react2.default.createElement(_zsgReduxInputs.Input, (0, _extends3.default)({
      controlled: true,
      type: 'password',
      overlayRight: _react2.default.createElement(_StrengthMeter2.default, { password: value })
    }, inputProps)),
    _react2.default.createElement(
      'ul',
      { className: 'validation-messages' },
      validationMarkup
    )
  );
};
PasswordInput.propTypes = {
  value: _propTypes2.default.string.isRequired,
  validationMessages: _propTypes2.default.array
};

exports.default = PasswordInput;
module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = require("lodash/omit");

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/promise");

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GLOBAL_KEY = 'ProxiedReactAppConfig';

/**
 * Returns rendered react app config.
 * @kind function
 * @param  {String} bundleName
 *                    name of app bundle
 * @param  {String} configPath
 *                    location of config path within bundle
 * @param  {String} oldGlobalKey
 *                    name of legacy key to access config (used when subclassing)
 * @return {Object} app config object
 */
var getAppConfig = exports.getAppConfig = function getAppConfig(bundleName, configPath, oldGlobalKey) {
  if (window && window[GLOBAL_KEY] && window[GLOBAL_KEY][bundleName] && window[GLOBAL_KEY][bundleName][configPath]) {
    return window[GLOBAL_KEY][bundleName][configPath];
  } else if (window && window[oldGlobalKey]) {
    return window[oldGlobalKey];
  }

  return {};
};

/**
 * Returns proTypes based on string object. This function reverses the key: value
 * as this is how redux inputs needs it to be. The reversal is done here instead of in the
 * backend to ensure that the options order is maintained.
 *
 * @kind function
 * @param  {String} proTypeString
 *                    proTypes string to be parsed as an object
 * @return {Object} proTypes
 */
var getProTypes = exports.getProTypes = function getProTypes(proTypeString) {
  if (proTypeString) {
    try {
      var proTypesObject = JSON.parse(proTypeString);
      var proTypes = {};

      for (var proValue in proTypesObject) {
        if (proTypesObject.hasOwnProperty(proValue)) {
          var proName = proTypesObject[proValue];

          proTypes[proName] = proValue;
        }
      }

      return proTypes;
    } catch (e) {
      console.warn('Unable to parse proTypes string from appConfig');
    }
  }

  return null;
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/toConsumableArray");

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/defineProperty");

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/typeof");

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tab = __webpack_require__(59);

var _Tab2 = _interopRequireDefault(_Tab);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = function Nav(_ref) {
  var activeTabType = _ref.activeTabType,
      tabs = _ref.tabs;
  return _react2.default.createElement(
    'div',
    { className: 'module-nav' },
    _react2.default.createElement(
      'ul',
      { className: 'zsg-tabs zsg-tabs_lg' },
      tabs.map(function (type, index) {
        return _react2.default.createElement(_Tab2.default, { key: index,
          type: type,
          isActive: type === activeTabType
        });
      })
    )
  );
};

Nav.propTypes = {
  activeTabType: _propTypes2.default.oneOf((0, _keys2.default)(_constants.TAB_TYPES)),
  tabs: _propTypes2.default.array.isRequired
};

exports.default = Nav;
module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns GA prefix for social tracking based on current auth process.
 * @kind function
 * @param  {String} authProcess
 *                    string representing auth process context
 * @return {String} corresponding label prefix, defaults to 'signin'
 */
var parseGAPrefixFromAuthProcess = exports.parseGAPrefixFromAuthProcess = function parseGAPrefixFromAuthProcess(authProcess) {
  try {
    var type = authProcess.match(/\/(signin|join|signuphere)/)[1];
    var eventLabelMap = {
      'signin': 'signin',
      'join': 'register',
      'signuphere': 'register'
    };

    return eventLabelMap[type];
  } catch (e) {
    return 'signin';
  }
};

/**
 * Determine GA prefix based on response from externalAuthentication endpoint.
 * endpoint returns "logged in" for existing users and "new Zillow account
 * created with external auth" for new users
 *
 * @kind function
 * @param  {String} res
 *                    response from extneralAuth endpoin
 * @return {String} corresponding label prefix
 */
var parseGAPrefixFromResponse = exports.parseGAPrefixFromResponse = function parseGAPrefixFromResponse(res) {
  try {
    var message = res.body.message;

    return message === 'logged in' ? 'signin' : 'register';
  } catch (e) {
    return 'signin';
  }
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleInvalidEmailTokenSubmit = exports.handleInvalidEmailToken = exports.handleNotFromEmail = exports.handleConfirmEmailSuccess = exports.updateIsValidEmailToken = undefined;

var _constants = __webpack_require__(2);

var _actions = __webpack_require__(13);

var _updateIsValidEmailToken = function _updateIsValidEmailToken(isValid) {
    return { type: _constants.UPDATE_VALID_EMAIL_TOKEN, isValid: isValid };
};

var updateIsValidEmailToken = exports.updateIsValidEmailToken = function updateIsValidEmailToken(isValid) {
    return function (dispatch) {
        dispatch(_updateIsValidEmailToken, isValid);
    };
};
/**
 * User has successfully added password
 */
var handleConfirmEmailSuccess = exports.handleConfirmEmailSuccess = function handleConfirmEmailSuccess(redirectUrl) {
    return function () {
        (0, _actions.handleLoggedIn)(false, {}, redirectUrl);
    };
};

var handleNotFromEmail = exports.handleNotFromEmail = function handleNotFromEmail(router) {
    return function () {
        router.push(_constants.ROUTES.passwordlessCreatePassword);
    };
};

var handleInvalidEmailToken = exports.handleInvalidEmailToken = function handleInvalidEmailToken(router) {
    return function () {
        router.push(_constants.ROUTES.invalidTokenMsg);
    };
};

var handleInvalidEmailTokenSubmit = exports.handleInvalidEmailTokenSubmit = function handleInvalidEmailTokenSubmit(router) {
    router.push(_constants.ROUTES.forgot);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setOneTapOnLoadBreak = exports.isOneTapOnLoadBreak = exports.ONE_TAP_ON_LOAD_BREAK_DURATION = exports.NEW_SESSION_LIFETIME = exports.CONFIG_KEY = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

exports.getLocalStorageConfig = getLocalStorageConfig;
exports.setLocalStorageConfig = setLocalStorageConfig;
exports.clearLocalStorageConfig = clearLocalStorageConfig;
exports.isNewSession = isNewSession;
exports.setNewSessionExpiration = setNewSessionExpiration;
exports.getRedirectUrl = getRedirectUrl;
exports.setRedirectUrl = setRedirectUrl;

var _isLocalStorageSupported = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG_KEY = exports.CONFIG_KEY = 'regLoginConfig';
var NEW_SESSION_LIFETIME = exports.NEW_SESSION_LIFETIME = 1000 * 60 * 30;
var ONE_TAP_ON_LOAD_BREAK_DURATION = exports.ONE_TAP_ON_LOAD_BREAK_DURATION = 1000 * 60 * 60 * 24 * 7;

var isLocalStorage = (0, _isLocalStorageSupported.isLocalStorageSupported)();

/**
 * Get regLogin local storage config
 * @returns {Object} config
 */
function getLocalStorageConfig() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONFIG_KEY;

    if (isLocalStorage) {
        try {
            return JSON.parse(global.localStorage.getItem(key)) || {};
        } catch (e) {
            //config value is malformed
        }
    }
    return {};
}

/**
 * Set regLogin local storage config
 * @param {Object} config
 */
function setLocalStorageConfig(config) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CONFIG_KEY;

    if (isLocalStorage) {
        global.localStorage.setItem(key, (0, _stringify2.default)((0, _extends3.default)({}, exports.getLocalStorageConfig(), config)));
    }
}

/**
 * Clear regLogin local storage config
 */
function clearLocalStorageConfig() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONFIG_KEY;

    if (isLocalStorage) {
        global.localStorage.removeItem(key);
    }
}

/**
 * If this is the user's first session or session has expired
 * @returns {Bool}
 */
function isNewSession() {
    var newSessionExpiration = exports.getLocalStorageConfig().newSessionExpiration || 0;
    return Date.now() > newSessionExpiration;
}

/**
 * If oneTapOnLoad is taking a break
 */
var isOneTapOnLoadBreak = exports.isOneTapOnLoadBreak = function isOneTapOnLoadBreak() {
    var breakDuration = exports.getLocalStorageConfig().oneTapOnLoadBreak || 0;
    return Date.now() <= breakDuration;
};

/**
 * Set newSessionExpiration to 30 minutes from time
 */
function setNewSessionExpiration() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NEW_SESSION_LIFETIME + Date.now();

    exports.setLocalStorageConfig({
        newSessionExpiration: duration
    });
}

/**
 * Potentially get (and remove) stored redirectUrl
 * @param {Boolean} remove whether to remove the value after reading it 
 * @return {String}
 */
function getRedirectUrl() {
    var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CONFIG_KEY;

    var _exports$getLocalStor = exports.getLocalStorageConfig(key),
        redirectUrl = _exports$getLocalStor.redirectUrl;

    if (remove) {
        exports.setLocalStorageConfig({
            redirectUrl: null
        }, key);
    }

    return redirectUrl || '';
}

/**
 * Set redirectUrl in localStorage
 * @param {String} redirectUrl
 */
function setRedirectUrl(redirectUrl) {
    setLocalStorageConfig({ redirectUrl: redirectUrl });
}

/**
 * Set oneTapOnLoadBreak to 1 week from date
 */
var setOneTapOnLoadBreak = exports.setOneTapOnLoadBreak = function setOneTapOnLoadBreak() {
    exports.setLocalStorageConfig({
        oneTapOnLoadBreak: Date.now() + ONE_TAP_ON_LOAD_BREAK_DURATION
    });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = require("redux");

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _App = __webpack_require__(44);

var _App2 = _interopRequireDefault(_App);

var _regLogin = __webpack_require__(93);

var _regLogin2 = _interopRequireDefault(_regLogin);

var _userSessionStoreCore = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _userSessionStoreCore.createUserSessionStore)();

/* eslint-disable react/no-danger */

exports.default = function (props) {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: _regLogin2.default.toString() } }),
        _react2.default.createElement(_App2.default, props)
    );
};
/* eslint-enable react/no-danger */


module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(45);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(46);

var _reactRouterDom = __webpack_require__(10);

var _zsgReduxInputs = __webpack_require__(11);

var _userSessionStoreActions = __webpack_require__(21);

var _universalAnalytics = __webpack_require__(3);

var _eventUtils = __webpack_require__(29);

var _CoreLayout = __webpack_require__(47);

var _CoreLayout2 = _interopRequireDefault(_CoreLayout);

var _createStore = __webpack_require__(85);

var _createStore2 = _interopRequireDefault(_createStore);

var _customProps = __webpack_require__(23);

var _profilerEvents = __webpack_require__(91);

var _deprecatedListeners = __webpack_require__(92);

var _localStorageConfig = __webpack_require__(41);

var _constants = __webpack_require__(2);

var _appConfig = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { syncHistoryWithStore } from 'react-router-redux'
var Router = void 0;

var App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    var facebookAppId = props.facebookAppId,
        fromEmail = props.fromEmail,
        headerText = props.headerText,
        subHeaderText = props.subHeaderText,
        inputConfigs = props.inputConfigs,
        isLightbox = props.isLightbox,
        isNativeApp = props.isNativeApp,
        isShowEmailOptIn = props.isShowEmailOptIn,
        isAlwaysPro = props.isAlwaysPro,
        hideConfirmPassword = props.hideConfirmPassword,
        proTypes = props.proTypes,
        redirectUrl = props.redirectUrl,
        showGoogleOneTapOnload = props.showGoogleOneTapOnload,
        rest = (0, _objectWithoutProperties3.default)(props, ['facebookAppId', 'fromEmail', 'headerText', 'subHeaderText', 'inputConfigs', 'isLightbox', 'isNativeApp', 'isShowEmailOptIn', 'isAlwaysPro', 'hideConfirmPassword', 'proTypes', 'redirectUrl', 'showGoogleOneTapOnload']);

    var proTypesOptions = (0, _appConfig.getProTypes)(proTypes);
    var updatedProSelectProps = (0, _extends3.default)({}, _constants.INPUT_TYPES.proSelect.props, proTypesOptions ? { options: proTypesOptions } : {});
    var updatedInputConfigs = (0, _extends3.default)({}, _constants.INPUT_TYPES, {
      proSelect: (0, _extends3.default)({}, _constants.INPUT_TYPES.proSelect, { props: updatedProSelectProps }),
      newPassword: _constants.STRONG_PASSWORD_NEW_PASSWORD_INPUT_CONFIG
    }, inputConfigs);

    var facebookAppIdFromDOM = void 0;
    if (!facebookAppId) {
      try {
        facebookAppIdFromDOM = document.querySelector('meta[property="fb:app_id"]').content;
      } catch (e) {
        // No id in DOM
      }
    }

    _this.isLightbox = isLightbox;
    Router = isLightbox || isNativeApp ? _reactRouterDom.MemoryRouter : _reactRouterDom.BrowserRouter;

    _this.store = (0, _createStore2.default)({
      appConfig: (0, _extends3.default)({
        isLightbox: isLightbox,
        facebookAppId: facebookAppId || facebookAppIdFromDOM,
        fromEmail: fromEmail === 'true',
        inputConfigs: updatedInputConfigs,
        showEmailOptIn: isShowEmailOptIn === 'true',
        alwaysPro: isAlwaysPro === 'true',
        hideConfirmPassword: hideConfirmPassword === 'true',
        showGoogleOneTapOnload: showGoogleOneTapOnload && (0, _localStorageConfig.isNewSession)() && !(0, _localStorageConfig.isOneTapOnLoadBreak)()
      }, rest)
    }, { inputs: (0, _zsgReduxInputs.createInputsReducer)(updatedInputConfigs) });

    // set or refresh session expiration
    (0, _localStorageConfig.setNewSessionExpiration)();
    /**
     * Should only need to dispatch redirectUrl/headerText
     * if passed to <App/> directly. These values are
     * reset on clicks to topnav/upsell and therefore only
     * serve a purpose on initial load (for non native apps
     * at least).
     */
    // dispatch redirect URL to user session store
    if (redirectUrl) {
      (0, _userSessionStoreActions.setRegLoginRedirectUrl)(redirectUrl);
    }

    // dispatch headerText/subHeaderText to user session store
    if (headerText || subHeaderText) {
      var uiConfig = (0, _extends3.default)({}, headerText ? { headerText: headerText } : {}, subHeaderText ? { subHeaderText: subHeaderText } : {});
      (0, _userSessionStoreActions.setRegLoginUiConfig)(uiConfig);
    }
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _profilerEvents.profileIntervalBegin)(_constants.PROFILER_APP_RENDER_EVENT);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.removeAppRedirectEventListener = (0, _eventUtils.listen)(_constants.APP_REDIRECT, (0, _deprecatedListeners.addDeprecatedListeners)({
        isLightbox: this.isLightbox
      }));
      (0, _eventUtils.listen)('auth:hide_lightbox', _userSessionStoreActions.hideRegLoginLightbox);

      (0, _eventUtils.trigger)(_constants.APP_LOAD);

      // Load Google Analytics if not already on page.
      // Not a promise, therefore no callback option available.
      // Initializing in componentWillMount provides ample time
      // for script to load.
      if (typeof document !== 'undefined' && !(0, _universalAnalytics.isInitialized)()) {
        (0, _universalAnalytics.requestUAScript)();
      }

      (0, _profilerEvents.profileIntervalEnd)(_constants.PROFILER_APP_RENDER_EVENT);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // remove global subscriber when App unmounts
      this.store.userSessionStoreUnsubscribe();

      if (typeof this.removeAppRedirectEventListener === 'function') {
        this.removeAppRedirectEventListener();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(
          Router,
          null,
          _react2.default.createElement(_CoreLayout2.default, this.props)
        )
      );
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  authToken: _propTypes2.default.string,
  facebookAppId: _propTypes2.default.string,
  fromEmail: _propTypes2.default.string,
  /**
   * Input configs that might be altered subject
   * to AB tests or other external factors.
   */
  inputConfigs: _propTypes2.default.object,
  isLightbox: _propTypes2.default.string,
  isLoggedIn: _propTypes2.default.bool,
  isShowEmailOptIn: _propTypes2.default.string,
  /**
   * Whether or not to check
   * the pro checkbox on Reg form
   */
  isAlwaysPro: _propTypes2.default.string,
  /**
   * Whether to hide
   * confirm password input
   */
  hideConfirmPassword: _propTypes2.default.string,
  proTypes: _propTypes2.default.string,
  redirectUrl: _propTypes2.default.string,
  disableSubmitOnValidate: _propTypes2.default.bool.isRequired,
  headerText: _propTypes2.default.string,
  subHeaderText: _propTypes2.default.string,
  isNativeApp: _propTypes2.default.bool,
  views: _customProps.appSubView,
  passwordless: _propTypes2.default.bool,
  showGoogleOneTapOnload: _propTypes2.default.bool
};

App.defaultProps = {
  disableSubmitOnValidate: false,
  inputConfigs: {},
  isNativeApp: false,
  views: [_constants.LOGIN, _constants.REGISTER, _constants.SOCIAL, _constants.PASSWORDLESS]
};

exports.default = App;
module.exports = exports['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/objectWithoutProperties");

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = require("react-redux");

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(32);

var _omit3 = _interopRequireDefault(_omit2);

var _isNil2 = __webpack_require__(48);

var _isNil3 = _interopRequireDefault(_isNil2);

var _isEqual2 = __webpack_require__(49);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(50);

var _reactRouterDom = __webpack_require__(10);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(51);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _Login = __webpack_require__(52);

var _Login2 = _interopRequireDefault(_Login);

var _Register = __webpack_require__(63);

var _Register2 = _interopRequireDefault(_Register);

var _ForgotPassword = __webpack_require__(70);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _ForgotPasswordSuccess = __webpack_require__(71);

var _ForgotPasswordSuccess2 = _interopRequireDefault(_ForgotPasswordSuccess);

var _PasswordRecovery = __webpack_require__(72);

var _PasswordRecovery2 = _interopRequireDefault(_PasswordRecovery);

var _PasswordlessSignin = __webpack_require__(73);

var _PasswordlessSignin2 = _interopRequireDefault(_PasswordlessSignin);

var _PasswordlessCreatePassword = __webpack_require__(74);

var _PasswordlessCreatePassword2 = _interopRequireDefault(_PasswordlessCreatePassword);

var _ConfirmEmail = __webpack_require__(75);

var _ConfirmEmail2 = _interopRequireDefault(_ConfirmEmail);

var _InvalidTokenMsg = __webpack_require__(76);

var _InvalidTokenMsg2 = _interopRequireDefault(_InvalidTokenMsg);

var _userSessionStoreActions = __webpack_require__(21);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _universalAnalytics = __webpack_require__(3);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _googleOneTap = __webpack_require__(77);

var _actions = __webpack_require__(13);

var _globalClass = __webpack_require__(79);

var _deviceSpecific = __webpack_require__(80);

var _pipe = __webpack_require__(81);

var _pipe2 = _interopRequireDefault(_pipe);

var _localStorageConfig = __webpack_require__(41);

var _eventUtils = __webpack_require__(29);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoreLayout = function (_Component) {
  (0, _inherits3.default)(CoreLayout, _Component);

  function CoreLayout(props, context) {
    (0, _classCallCheck3.default)(this, CoreLayout);

    // Allows us to extract appConfig values
    var _this = (0, _possibleConstructorReturn3.default)(this, (CoreLayout.__proto__ || (0, _getPrototypeOf2.default)(CoreLayout)).call(this, props));

    var _context$store$getSta = context.store.getState(),
        appConfig = _context$store$getSta.appConfig;

    _this.state = {
      hasBeenClosed: false,
      isPostLoadComplete: false
    };

    _this.isLightbox = props.isLightbox === 'true';
    _this.shouldFixCursor = (0, _deviceSpecific.isBrokenCursorOS)(window.navigator.userAgent);
    _this.googleClientId = props.googleClientId || _constants.GOOGLE_CLIENT_ID;
    _this.hideLightbox = _this.hideLightbox.bind(_this);
    _this.showGoogleOneTap = _this.showGoogleOneTap.bind(_this);
    _this.renderToLightbox = _this.renderToLightbox.bind(_this);
    _this.wrapContainer = _this.wrapContainer.bind(_this);
    _this.renderToNodeTarget = _this.renderToNodeTarget.bind(_this);
    _this.onLightboxToggle = _this.onLightboxToggle.bind(_this);

    if (props.path !== '/') {
      props.history.push(props.path);
    }

    if (_this.isLightbox) {
      _this._initLightbox();
    }
    return _this;
  }

  /**
   * Initializes lightbox logic and listeners.
   * @kind function
   */


  (0, _createClass3.default)(CoreLayout, [{
    key: '_initLightbox',
    value: function _initLightbox() {
      // Enable external triggers
      this._setListeners();

      // Start inactivity reg prompt
      this._initPostLoadTimeout();
    }
  }, {
    key: '_initPostLoadTimeout',
    value: function _initPostLoadTimeout() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          isPostLoadComplete: true
        });
      }, _constants.POST_LOAD_TIMEOUT);
    }

    /**
     * Adds message event listener for
     * communication outside lightbox.
     * @kind function
     */

  }, {
    key: '_setListeners',
    value: function _setListeners() {
      var _this3 = this;

      // Only open lightbox if user has been on page long enough
      // and has not opened and closed sign in already
      (0, _eventUtils.listenUntil)(_constants.FOCUS, function () {
        if (!_this3.state.hasBeenClosed && _this3.state.isPostLoadComplete) {
          (0, _userSessionStoreActions.setRegLoginPath)(_constants.ROUTES.register + '?il=1');

          return true;
        }

        return false;
      });
    }
  }, {
    key: 'getShouldRenderApp',
    value: function getShouldRenderApp() {
      var _props = this.props,
          isLightbox = _props.isLightbox,
          showLightbox = _props.showLightbox;


      return !isLightbox || showLightbox;
    }

    /**
     * Toggles class to hide lightbox and mask, then execute onClose
     * @kind function
     */

  }, {
    key: 'hideLightbox',
    value: function hideLightbox() {
      this.setState({
        hasBeenClosed: true
      });

      (0, _userSessionStoreActions.hideRegLoginLightbox)();
      this.props.onClose();
    }

    /**
     * Shows Google one tap dialog.
     * @kind function
     */

  }, {
    key: 'showGoogleOneTap',
    value: function showGoogleOneTap() {
      var _props2 = this.props,
          history = _props2.history,
          redirectUrl = _props2.redirectUrl,
          showLightbox = _props2.showLightbox;

      // One tap takes a `context` parameter to determine dialog text

      var context = 'signIn';

      try {
        var pathname = history.location.pathname;

        if (pathname.indexOf('/register') > -1) {
          context = 'signUp';
        }
      } catch (err) {
        console.log('Couldnt parse location for one tap: ' + err);
      }

      var dispatch = this.context.store.dispatch;


      (0, _googleOneTap.init)(this.googleClientId || typeof document !== 'undefined' && document.querySelector('meta[name="google-signin-clientid"]').content, context, {
        successHandler: function successHandler() {
          (0, _actions.handleLoggedIn)(false, {}, redirectUrl);
        },
        errorHandler: function errorHandler(message) {
          dispatch((0, _actions.handleError)(404, message));
        },
        dismissHandler: function dismissHandler() {
          //if one tap was triggered on load and user has dismissed it, set the break so it does not show for the set duration
          if (!showLightbox) {
            (0, _localStorageConfig.setOneTapOnLoadBreak)();
          }
        }
      });
    }

    /**
     * Wraps the node with Lightbox component
     * @param {Object} node layout
     * @return {Object} node layout
     */

  }, {
    key: 'renderToLightbox',
    value: function renderToLightbox(layout) {
      var _props3 = this.props,
          renderNodeTarget = _props3.renderNodeTarget,
          showLightbox = _props3.showLightbox;


      if (this.isLightbox && (0, _isNil3.default)(renderNodeTarget) && showLightbox) {
        var lightboxClasses = (0, _classnames2.default)('act-auth-lightbox', {
          'hidden': !showLightbox
        });
        var screenWidth = window.innerWidth;
        var width = Math.min(_constants.MAX_INLINE_WIDTH, screenWidth - 2 * _constants.INLINE_BUFFER) + 'px';

        // Enable page scrolling
        (0, _globalClass.addGlobalClass)('zsg-lightbox_override');

        return _react2.default.createElement(
          _Lightbox2.default,
          { className: lightboxClasses,
            isOpen: true,
            maskClassName: lightboxClasses,
            onClose: this.hideLightbox,
            renderInline: true,
            width: width },
          layout
        );
      }

      return layout;
    }

    /**
     * Wraps the node in act-auth-container
     * @param {Object} node layout
     * @return {Object} node layout
     */

  }, {
    key: 'wrapContainer',
    value: function wrapContainer(layout) {
      var _this4 = this;

      var _props4 = this.props,
          renderNodeTarget = _props4.renderNodeTarget,
          showLightbox = _props4.showLightbox;


      var shouldRenderLayout = showLightbox || !(0, _isNil3.default)(renderNodeTarget) || !this.isLightbox;

      return _react2.default.createElement(
        'div',
        { className: 'act-auth-container',
          ref: function ref(node) {
            _this4.layoutContainer = node;
          } },
        shouldRenderLayout && layout
      );
    }
    /**
     * Renders the passed node into a the nodeTarget prop
     * @param {Object} node layout
     * @return {Object} node layout
     */

  }, {
    key: 'renderToNodeTarget',
    value: function renderToNodeTarget(layout) {
      if (this.props.renderNodeTarget) {
        return (0, _reactDom.createPortal)(layout, this.props.renderNodeTarget);
      }
      return layout;
    }
  }, {
    key: 'onLightboxToggle',
    value: function onLightboxToggle(onShow, onHide) {
      if (this.props.showLightbox) {
        onShow();
      } else {
        onHide();
      }
    }

    /**
     * @param {Array} blacklistPages Array of pages to suspend one tap thingy
     * @return {Boolean}
     */

  }, {
    key: 'getShouldShowGoogleOneTap',
    value: function getShouldShowGoogleOneTap() {
      var blacklistPages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [_constants.ROUTES.changePasswordForgot, _constants.ROUTES.confirmEmail];

      return blacklistPages.indexOf(this.props.history.location.pathname) < 0 && (this.props.showGoogleOneTapOnload || this.getShouldRenderApp());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var inputValues = nextProps.inputValues,
          path = nextProps.path,
          history = nextProps.history;
      var dispatch = this.context.store.dispatch;


      if (!(0, _isEqual3.default)(this.props.inputValues, inputValues)) {
        (0, _actions.setInputValues)((0, _omit3.default)(inputValues, _constants.BLACKLISTED_INPUTS))(dispatch);
      }

      if (this.props.path !== path) {
        history.push(path);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this5 = this;

      if (prevProps.showLightbox !== this.props.showLightbox) {
        this.onLightboxToggle(function () {
          _this5.showGoogleOneTap();
          if (_this5.shouldFixCursor) {
            document.body.classList.add('adjust-ios-carat');
          }
        }, function () {
          (0, _googleOneTap.close)();
          // Enable page scrolling
          (0, _globalClass.removeGlobalClass)('zsg-lightbox_override');
          document.body.classList.remove('adjust-ios-carat');
          // DEPRECATED, remove once nothing depends on @zillow/auth-lightbox-api@0.3.1
          (0, _eventUtils.trigger)(_constants.LIGHTBOX_HIDDEN, { loggedIn: _this5.props.loggedIn });
        });
      }

      if (prevProps.showGoogleOneTap !== this.props.showGoogleOneTap) {
        if (this.props.showGoogleOneTap) {
          this.showGoogleOneTap();
        } else {
          (0, _googleOneTap.close)();
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _userSessionStoreActions.setRegLoginNode)(this.layoutContainer);

      if (this.getShouldShowGoogleOneTap()) {
        this.showGoogleOneTap();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _userSessionStoreActions.setRegLoginNode)();
    }
  }, {
    key: 'render',
    value: function render() {
      var getLayout = (0, _pipe2.default)(this.renderToLightbox, this.wrapContainer, this.renderToNodeTarget);

      return getLayout(_react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.login, component: _Login2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.register, component: _Register2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.registerAdmin, component: _Register2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.forgot, component: _ForgotPassword2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.confirmEmail, component: _ConfirmEmail2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.changePasswordForgot, component: _ForgotPassword2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.forgotSuccess, component: _ForgotPasswordSuccess2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.invalidTokenMsg, component: _InvalidTokenMsg2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.passwordlessSignin, component: _PasswordlessSignin2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.passwordlessCreatePassword, component: _PasswordlessCreatePassword2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: _constants.ROUTES.recovery, component: _PasswordRecovery2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _Login2.default })
      ));
    }
  }]);
  return CoreLayout;
}(_react.Component);

CoreLayout.propTypes = {
  children: _propTypes2.default.element,
  googleClientId: _propTypes2.default.string,
  history: _propTypes2.default.object,
  inputValues: _propTypes2.default.object,
  isLightbox: _propTypes2.default.string,
  location: _propTypes2.default.object,
  loggedIn: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  renderNodeTarget: function renderNodeTarget(props, propName) {
    if (props[propName] && !(props[propName] instanceof Node)) {
      return new Error('reg-login: ' + propName + ' is not a DOM Node');
    }
    return null;
  },
  path: _propTypes2.default.string,
  redirectUrl: _propTypes2.default.string,
  showGoogleOneTap: _propTypes2.default.bool,
  showGoogleOneTapOnload: _propTypes2.default.bool,
  showLightbox: _propTypes2.default.bool
};

CoreLayout.defaultProps = {
  onClose: _constants.NOOP
};

CoreLayout.contextTypes = {
  store: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    googleClientId: state.appConfig.googleClientId,
    inputValues: state.regLogin.inputValues,
    isLightbox: state.appConfig.isLightbox,
    onClose: state.login.onClose,
    path: state.regLogin.path,
    redirectUrl: state.regLogin.redirectUrl,
    renderNodeTarget: state.regLogin.uiConfig.renderNodeTarget,
    showGoogleOneTap: state.regLogin.showGoogleOneTap,
    showGoogleOneTapOnload: state.appConfig.showGoogleOneTapOnload,
    showLightbox: state.regLogin.showLightbox
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps)(CoreLayout));
module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = require("lodash/isNil");

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = require("lodash/isEqual");

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/Lightbox");

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = undefined;

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _zsgReduxInputs = __webpack_require__(11);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _clientProfiler = __webpack_require__(30);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _Nav = __webpack_require__(38);

var _Nav2 = _interopRequireDefault(_Nav);

var _SocialLogins = __webpack_require__(28);

var _SocialLogins2 = _interopRequireDefault(_SocialLogins);

var _actions = __webpack_require__(13);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

var _customProps = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = exports.Login = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props, context) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this.hasLogin = props.views.indexOf(_constants.LOGIN) !== -1;
    _this.hasRegister = props.views.indexOf(_constants.REGISTER) !== -1;
    _this.hasSocial = props.views.indexOf(_constants.SOCIAL) !== -1;

    _this.beforeForgotPassword = _this.beforeForgotPassword.bind(_this);
    return _this;
  }

  /**
   * GA tracking for forgot password link click.
   */


  (0, _createClass3.default)(Login, [{
    key: 'beforeForgotPassword',
    value: function beforeForgotPassword() {
      (0, _universalAnalytics.trackEvent)({
        action: 'forgotpassword//',
        category: 'auth',
        label: this.props.gaLabel
      });
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return { gaLabel: this.props.gaLabel };
    }

    /**
     * Login success callback with GA tracking.
     * @param {Object}  res
     *                    response body
     * @param {Boolean} isEmailLogin
     *                    if false, will forego email GA event
     */

  }, {
    key: 'handleLogin',
    value: function handleLogin(res) {
      var isEmailLogin,
          _props,
          gaLabel,
          onSuccess,
          redirectUrl,
          _this4 = this,
          _arguments = arguments;

      return Promise.resolve().then(function () {
        isEmailLogin = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
        _props = _this4.props;
        gaLabel = _props.gaLabel;
        onSuccess = _props.onSuccess;
        redirectUrl = _props.redirectUrl;


        if (isEmailLogin) {
          (0, _universalAnalytics.trackEvent)({
            action: 'signin/email/',
            category: 'auth',
            label: gaLabel
          });
        }

        if (onSuccess) {
          return onSuccess(res, redirectUrl);
        }
      }).then(function () {
        (0, _actions.handleLoggedIn)(false, res, redirectUrl);
      });
    }

    // Force validation of form inputs.

  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props2 = this.props,
          authAP = _props2.authAP,
          history = _props2.history,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs,
          onFailure = _props2.onFailure;


      this.props.validateInputs(inputConfigs, _constants.LOGIN_INPUT_TYPES.requiredTypes).then(function () {
        (0, _clientProfiler.profileIntervalBegin)(_constants.LOGIN_PROFILE_SUBMIT);

        var _props$getInputProps = _this2.props.getInputProps(inputConfigs, inputs),
            authToken = _props$getInputProps.authToken,
            email = _props$getInputProps.email,
            password = _props$getInputProps.password;

        _this2.props.submitForm({
          path: _constants.ROUTES.loginPost,
          data: {
            ap: authAP,
            authToken: authToken.value,
            email: email.value,
            password: password.value
          },
          success: function success(res) {
            (0, _clientProfiler.profileIntervalEnd)(_constants.LOGIN_PROFILE_SUBMIT);
            _this2.handleLogin(res);
          },
          error: function error(err, link) {
            // We have different non-200 events that are not failures, but all 500+ are bad
            if (err.status >= 500) {
              (0, _clientProfiler.profileIntervalFail)(_constants.LOGIN_PROFILE_SUBMIT);
            }

            if (onFailure) {
              onFailure(err);
            } else {
              (0, _actions.handleLoginRedirect)(history, link);
            }
          }
        });
      }, function () {});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var props = this.props,
          email = this.props.inputs.email;

      // Clear any error messages

      (0, _actions.hideFacebookError)();
      (0, _actions.resetFormError)();

      // Hide expanded email form
      (0, _actions.hideEmailForm)();

      // Update newEmail input with current email value
      if (email.value) {
        (0, _actions.syncInputValues)(email, 'newEmail');
      }

      // Clear password field on leaving
      (0, _actions.resetFields)(['password'], ['email', 'newEmail']);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var login = this.props.login;

      var formErrorMessage = login && login.formErrorMessage;
      var nextLogin = nextProps.login;
      var nextFormErrorMessage = nextLogin && nextLogin.formErrorMessage;

      // GA form error tracking
      if (nextFormErrorMessage && nextFormErrorMessage !== formErrorMessage) {
        (0, _universalAnalytics.trackEvent)({
          action: 'error//',
          category: 'auth',
          label: nextProps.gaLabel
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var forgotPasswordLink = _react2.default.createElement(
        _reactRouterDom.Link,
        { to: _constants.ROUTES.forgot,
          onClick: this.beforeForgotPassword },
        _constants.FORM_TEXT.forgotPasswordLink
      );
      var _props3 = this.props,
          gaLabel = _props3.gaLabel,
          showTabs = _props3.showTabs,
          facebookAppId = _props3.facebookAppId,
          headerText = _props3.headerText,
          subHeaderText = _props3.subHeaderText,
          inputs = _props3.inputs,
          inputConfigs = _props3.inputConfigs,
          formErrorMessage = _props3.login.formErrorMessage;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          authToken = _props$getInputProps2.authToken,
          email = _props$getInputProps2.email,
          password = _props$getInputProps2.password;

      var signIn = _constants.BUTTON_TYPES.signIn;


      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(_Header2.default, { text: headerText, children: subHeaderText }),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          showTabs && this.hasLogin && this.hasRegister && _react2.default.createElement(_Nav2.default, { activeTabType: 'login',
            tabs: ['login', 'register'] }),
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_zsgReduxInputs.Input, authToken),
            _react2.default.createElement(_zsgReduxInputs.Input, email),
            _react2.default.createElement(_zsgReduxInputs.Input, password),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement('input', signIn)
              ),
              _react2.default.createElement(
                'div',
                { className: 'lower-right-panel zsg-lg-1-2 zsg-sm-1-1' },
                forgotPasswordLink
              )
            )
          ),
          formErrorMessage && _react2.default.createElement(_FormError2.default, { text: formErrorMessage })
        ),
        this.hasSocial && _react2.default.createElement(
          _Footer2.default,
          { border: 'top', text: 'Or connect with: ' },
          _react2.default.createElement(_SocialLogins2.default, {
            gaLabel: gaLabel,
            facebookAppId: facebookAppId,
            onLoginSuccess: function onLoginSuccess(res) {
              return _this3.handleLogin(res, false);
            } })
        )
      );
    }
  }]);
  return Login;
}(_react.Component);

// Components


Login.propTypes = {
  authAP: _propTypes2.default.string,
  showTabs: _propTypes2.default.bool,
  facebookAppId: _propTypes2.default.string.isRequired,
  gaLabel: _propTypes2.default.string.isRequired,
  getInputProps: _propTypes2.default.func.isRequired,
  headerText: _propTypes2.default.string.isRequired,
  history: _propTypes2.default.object,
  subHeaderText: _propTypes2.default.string,
  inputs: _propTypes2.default.object,
  inputConfigs: _propTypes2.default.object,
  login: _propTypes2.default.object,
  onFailure: _propTypes2.default.func,
  onSuccess: _propTypes2.default.func,
  /**
  * Redirect URL used after login.
  */
  redirectUrl: _propTypes2.default.string,
  submitForm: _propTypes2.default.func.isRequired,
  validateInputs: _propTypes2.default.func.isRequired,
  views: _customProps.appSubView
};
Login.defaultProps = {
  showTabs: true
};

Login.contextTypes = {
  store: _propTypes2.default.object
};

Login.childContextTypes = {
  gaLabel: _propTypes2.default.string
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  hideEmailForm: _actions.hideEmailForm,
  hideFacebookError: _actions.hideFacebookError,
  resetFields: _actions.resetFields,
  resetFormError: _actions.resetFormError,
  submitForm: _actions.submitForm,
  syncInputValues: _actions.syncInputValues,
  validateInputs: _zsgReduxInputs.validateInputs
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    facebookAppId: state.appConfig.facebookAppId.toString(),
    login: state.login,
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    onFailure: state.appConfig.onFailure,
    onSuccess: state.appConfig.onSuccess,
    headerText: state.regLogin.uiConfig.headerText,
    subHeaderText: state.regLogin.uiConfig.subHeaderText,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    redirectUrl: state.regLogin.redirectUrl,
    showTabs: state.regLogin.uiConfig.showTabs,
    views: state.appConfig.views
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(Login));

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = require("lodash/after");

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getABTestImport = exports.getABTestImportBase = undefined;

var _constants = __webpack_require__(2);

var getABTestImportBase = exports.getABTestImportBase = function getABTestImportBase(abTestsString) {
  var trialName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CONTROL';
  var dictionary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var abtests = abTestsString ? JSON.parse(abTestsString) : {};

  if (abtests && abtests[trialName]) {
    return dictionary[abtests[trialName]];
  }

  return dictionary['CONTROL'];
};

/**
 * Fetches corresponding import based on AB test dictionary.
 * @kind function
 * 
 * @param {String} abTestsString,
 *                    JSON string to be parsed into an ab test object
 * @param  {String} trialName
 *                    name of AB test trial
 * @param  {Object} dictionary
 *                    map where keys are test names and values are the modules
 * @return {Object} resultant import object
 */
var getABTestImport = exports.getABTestImport = function getABTestImport(trialName, dictionary) {
  return getABTestImportBase(_constants.APP_CONFIG.abtests, trialName, dictionary);
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/util/launcherBase");

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = require("@zillow/state-region-id-map");

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueObjectValuesToArray = exports.serialize = undefined;

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(58);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parses dictionary as URL encoded param string.
 * @kind function
 * @param  {Object} obj
 *                    data to be serialized
 * @return {String} encoded param string
 */
var serialize = exports.serialize = function serialize() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _keys2.default)(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  }).join('&');
};

/**
 * Extracts unique values from object
 * @param {Object} obj
 * @return {Array} array of unique object values 
 */
var uniqueObjectValuesToArray = exports.uniqueObjectValuesToArray = function uniqueObjectValuesToArray() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _values2.default)(obj)
  // remove duplicates
  .reduce(function (accu, value) {
    return accu.indexOf(value) === -1 ? [].concat((0, _toConsumableArray3.default)(accu), [value]) : accu;
  }, []);
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/values");

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _universalAnalytics = __webpack_require__(3);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tab = function Tab(_ref, _ref2) {
  var isActive = _ref.isActive,
      type = _ref.type;
  var gaLabel = _ref2.gaLabel;
  var _TAB_TYPES$type = _constants.TAB_TYPES[type],
      text = _TAB_TYPES$type.text,
      url = _TAB_TYPES$type.url;

  var handleTabSwitch = function handleTabSwitch() {
    if (!isActive) {
      (0, _universalAnalytics.trackEvent)({
        action: 'toggle//',
        category: 'auth',
        label: gaLabel
      });
    }
  };

  return _react2.default.createElement(
    'li',
    { className: (0, _classnames2.default)({ 'zsg-tab_active': isActive }) },
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: url, onClick: handleTabSwitch },
      text
    )
  );
};

Tab.propTypes = {
  isActive: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf((0, _keys2.default)(_constants.TAB_TYPES)).isRequired
};

Tab.contextTypes = {
  gaLabel: _propTypes2.default.string
};

exports.default = Tab;
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _superagent = __webpack_require__(24);

var _superagent2 = _interopRequireDefault(_superagent);

var _universalAnalytics = __webpack_require__(3);

var _constants = __webpack_require__(2);

var _gaEvents = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookLogin = function (_Component) {
  (0, _inherits3.default)(FacebookLogin, _Component);

  function FacebookLogin(props, context) {
    (0, _classCallCheck3.default)(this, FacebookLogin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FacebookLogin.__proto__ || (0, _getPrototypeOf2.default)(FacebookLogin)).call(this, props));

    _this._onClick = _this._onClick.bind(_this);
    _this._onLoginAttempt = _this._onLoginAttempt.bind(_this);
    _this._onStatusChange = _this._onStatusChange.bind(_this);
    _this.track = _this.track.bind(_this);
    return _this;
  }

  /**
   * Click handler
   * @param {Object} response
   */


  (0, _createClass3.default)(FacebookLogin, [{
    key: '_onClick',
    value: function _onClick(e) {
      // shows whatever error messages may exist
      e.preventDefault();
      this.props.handleFacebookConnectClick();
      this.track();

      window.FB.login(this._onLoginAttempt, {
        scope: this.props.scope.toString(),
        auth_type: 'rerequest'
      });
    }

    /**
     * FB status change callback
     * @param {Object} response
     *                   object detailing Facebook connection state
     */

  }, {
    key: '_onStatusChange',
    value: function _onStatusChange(response) {
      var handleFacebookConnectionFailure = this.props.handleFacebookConnectionFailure;


      switch (response.status) {
        case 'connected':
          if (this.props.doAutoConnect) {
            // Logged into your app and Facebook.
            this.connectAccount(response.authResponse);
          }
          break;
        case 'not_authorized':
          // The person is logged into Facebook, but not your app.
          handleFacebookConnectionFailure(_constants.FB_NOT_AUTHENTICATED);
          break;
        default:
          // The person is not logged into Facebook, so we're not sure if
          // they are logged into this app or not.
          handleFacebookConnectionFailure(_constants.FB_NOT_LOGGED_IN);
      }
    }

    /**
     * Login callback
     * @param {Object} response
     *                   object detailing Facebook login state
     */

  }, {
    key: '_onLoginAttempt',
    value: function _onLoginAttempt(_ref) {
      var authResponse = _ref.authResponse,
          status = _ref.status;

      if (typeof authResponse !== 'undefined') {
        this.responseApi(authResponse);
      } else {
        this.props.onAuthFailure({ status: status });
      }
    }

    /**
     * Hit the FB API and connect with Zillow
     * @param {Object} authResponse
     */

  }, {
    key: 'responseApi',
    value: function responseApi(authResponse) {
      var _this2 = this;

      window.FB.api('/me', { fields: this.props.fields }, function (me) {
        me.accessToken = authResponse.accessToken;
        me.expiresIn = authResponse.expiresIn;
        _this2.connectAccount(me);
      });
    }

    /**
     * Load the facebook sdk
     */

  }, {
    key: 'loadSDK',
    value: function loadSDK() {
      var element = document.getElementsByTagName('script')[0];
      var jsId = 'facebook-jssdk';
      var fjs = element;
      var js = element;

      if (document.getElementById(jsId)) {
        return;
      }

      js = document.createElement('script');
      js.id = jsId;

      // Use all.js over sdk.js - sdk.js throwing version error on init
      js.src = 'https://connect.facebook.net/en_US/all.js';
      fjs.parentNode.insertBefore(js, fjs);
    }

    /**
     * Do the facebooky init stuff
     */

  }, {
    key: 'fbInit',
    value: function fbInit() {
      var _this3 = this;

      var _props = this.props,
          appId = _props.appId,
          xfbml = _props.xfbml,
          cookie = _props.cookie,
          version = _props.version;


      window.fbAsyncInit = function () {

        if (xfbml) {
          window.FB.Event.subscribe('xfbml.render');
        }

        // All options need to be defined or FB.init will fail silently
        window.FB.init({
          appId: appId,
          xfbml: xfbml,
          cookie: cookie,
          version: version
        });

        window.FB.getLoginStatus(_this3._onStatusChange);
      };

      if (!window.FB) {
        this.loadSDK();
      }
    }

    /**
     * Connect FB account with Zillow account
     * @param {Object} params
        ex: {
          externalID: userID,
          authToken: accessToken,
          expiresIn: expiresIn,
          type: 'some external auth type'
        }
     */

  }, {
    key: 'connectAccount',
    value: function connectAccount(params) {
      var _this4 = this;

      var id = params.id,
          accessToken = params.accessToken,
          expiresIn = params.expiresIn;
      var _props2 = this.props,
          onSuccess = _props2.onSuccess,
          onFailure = _props2.onFailure,
          gaLabel = _props2.gaLabel,
          authType = _props2.authType,
          externalAuthURL = _props2.externalAuthURL;


      _superagent2.default.post(externalAuthURL)
      // Service expecting form post
      .field('accessToken', accessToken).field('expiresIn', expiresIn).field('authID', id).field('ap', authType).field('at', 'facebook').end(function (err, res) {
        if (err) {
          onFailure(err);
        } else {
          _this4.track((0, _gaEvents.parseGAPrefixFromResponse)(res) + '/facebook/');
          onSuccess(res);
        }
      });
    }

    /**
     * Wrapper for track event
     * @param {String} action
     */

  }, {
    key: 'track',
    value: function track() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'socialclick/facebook/';

      (0, _universalAnalytics.trackEvent)({
        action: action,
        category: 'auth',
        label: this.props.gaLabel
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fbInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          buttonText = _props3.buttonText,
          children = _props3.children,
          className = _props3.className;


      return _react2.default.createElement(
        'a',
        { href: '#',
          className: className,
          onClick: this._onClick },
        children ? children : buttonText
      );
    }
  }]);
  return FacebookLogin;
}(_react.Component);

FacebookLogin.propTypes = {
  appId: _propTypes2.default.string.isRequired,
  gaLabel: _propTypes2.default.string,
  authType: _propTypes2.default.string,
  buttonText: _propTypes2.default.string,
  channelUrl: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.string,
  cookie: _propTypes2.default.bool.isRequired,
  doAutoConnect: _propTypes2.default.bool,
  externalAuthURL: _propTypes2.default.string,
  fields: _propTypes2.default.string,
  handleFacebookConnectClick: _propTypes2.default.func,
  handleFacebookConnectionFailure: _propTypes2.default.func,
  onAuthFailure: _propTypes2.default.func,
  onSuccess: _propTypes2.default.func,
  onFailure: _propTypes2.default.func,
  scope: _propTypes2.default.array,
  version: _propTypes2.default.string.isRequired,
  xfbml: _propTypes2.default.bool.isRequired
};

FacebookLogin.defaultProps = {
  gaLabel: 'standalone',
  authType: 'FACEBOOK_DEFAULT',
  channelUrl: '//' + window.location.host + '/FacebookChannel.htm',
  cookie: true,
  doAutoConnect: false,
  externalAuthURL: '/user/account/services/ExternalAuthentication.htm',
  onAuthFailure: function onAuthFailure() {},
  onFailure: function onFailure() {},
  onSuccess: function onSuccess() {},
  scope: ['email'],
  version: 'v2.9',
  xfbml: false
};

exports.default = FacebookLogin;
module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _superagent = __webpack_require__(24);

var _superagent2 = _interopRequireDefault(_superagent);

var _universalAnalytics = __webpack_require__(3);

var _gaEvents = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*
* @class GooglePlusSignin
*/
var GooglePlusSignin = function (_Component) {
  (0, _inherits3.default)(GooglePlusSignin, _Component);

  function GooglePlusSignin(props, context) {
    (0, _classCallCheck3.default)(this, GooglePlusSignin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GooglePlusSignin.__proto__ || (0, _getPrototypeOf2.default)(GooglePlusSignin)).call(this, props));

    _this._onBtnClick = _this._onBtnClick.bind(_this);
    _this.loadGooglePlus = _this.loadGooglePlus.bind(_this);
    _this.state = {
      disabled: 'disabled'
    };
    return _this;
  }

  /**
  * Callback after successful signin (w/ google)
  * @param {Object} response
  **/


  (0, _createClass3.default)(GooglePlusSignin, [{
    key: '_onSigninSuccess',
    value: function _onSigninSuccess(response) {
      this.syncGoogleAuth(response);
    }

    /**
    * Failure callback for signin (w/ google)
    * @param {Object} err
    **/

  }, {
    key: '_onSigninFailure',
    value: function _onSigninFailure(err) {
      // console logging placeholder
      console.error(err);
    }

    /**
    * G+ signin button handler
    **/

  }, {
    key: '_onBtnClick',
    value: function _onBtnClick(e) {
      e.preventDefault();
      this.track();
      this.authWithGoogle();
    }

    /**
    * Wrapper for trackEvent
    * @param {String} action
    **/

  }, {
    key: 'track',
    value: function track() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'socialclick/google/';

      (0, _universalAnalytics.trackEvent)({
        action: action,
        category: 'auth',
        label: this.props.gaLabel
      });
    }

    /**
    * Load the G+ library code and init on callback
    **/

  }, {
    key: 'loadGooglePlus',
    value: function loadGooglePlus() {
      var _this2 = this;

      var auth2InitParams = this.props.auth2InitParams;


      (function (d, s, id, cb) {
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = d.createElement(s);
        js.onload = cb;
        js.id = id;
        js.src = '//apis.google.com/js/client:platform.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'google-login', function () {
        try {
          window.gapi.load('auth2', function () {
            _this2.setState({
              disabled: ''
            });

            if (!window.gapi.auth2.getAuthInstance()) {
              window.gapi.auth2.init(auth2InitParams || {});
            }
          });
        } catch (err) {
          console.log('Error with gapi: ', err);
        }
      });
    }

    /**
    * Initiate auth w/ G+
    **/

  }, {
    key: 'authWithGoogle',
    value: function authWithGoogle() {
      var _this3 = this;

      var auth2 = window.gapi.auth2.getAuthInstance();
      var _props = this.props,
          offline = _props.offline,
          redirectUri = _props.redirectUri;


      try {
        if (offline) {
          var options = {
            redirect_uri: redirectUri
          };

          auth2.grantOfflineAccess(options).then(function (res) {
            _this3._onSigninSuccess(res);
          }, function (err) {
            _this3._onSigninFailure(err);
          });
        } else {
          auth2.signIn().then(function (res) {
            var basicProfile = res.getBasicProfile();
            var authResponse = res.getAuthResponse();

            res.googleId = basicProfile.getId();
            res.tokenObj = authResponse;
            res.expiresIn = authResponse.expires_in;
            res.tokenId = authResponse.id_token;
            res.accessToken = authResponse.access_token;
            res.profileObj = {
              googleId: basicProfile.getId(),
              imageUrl: basicProfile.getImageUrl(),
              email: basicProfile.getEmail(),
              name: basicProfile.getName(),
              givenName: basicProfile.getGivenName(),
              familyName: basicProfile.getFamilyName()
            };

            _this3._onSigninSuccess(res);
          }, function (err) {
            _this3._onSigninFailure(err);
          });
        }
      } catch (e) {
        console.error('Unable to get auth instance', e);
      }
    }

    /**
    * Send google signin info to server for auth
    * @param {Object} response
    **/

  }, {
    key: 'syncGoogleAuth',
    value: function syncGoogleAuth(response) {
      var _this4 = this;

      var _props2 = this.props,
          onSuccess = _props2.onSuccess,
          onFailure = _props2.onFailure,
          gaLabel = _props2.gaLabel,
          externalAuthURL = _props2.externalAuthURL;
      var accessToken = response.accessToken,
          expiresIn = response.expiresIn,
          googleId = response.googleId;


      _superagent2.default.post(externalAuthURL)
      // Service expecting form post
      .field('accessToken', accessToken).field('expiresIn', expiresIn).field('authID', googleId).field('ap', gaLabel).end(function (err, res) {
        if (err) {
          onFailure(err);
        } else {
          _this4.track((0, _gaEvents.parseGAPrefixFromResponse)(res) + '/google/');
          onSuccess(res);
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadGooglePlus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          buttonText = _props3.buttonText,
          children = _props3.children;

      return _react2.default.createElement(
        'a',
        { href: '#',
          className: className,
          onClick: this._onBtnClick,
          disabled: this.state.disabled },
        children ? children : buttonText
      );
    }
  }]);
  return GooglePlusSignin;
}(_react.Component);

GooglePlusSignin.propTypes = {
  onSuccess: _propTypes2.default.func.isRequired,
  onFailure: _propTypes2.default.func.isRequired,
  gaLabel: _propTypes2.default.string,
  buttonText: _propTypes2.default.string,
  offline: _propTypes2.default.bool,
  scope: _propTypes2.default.string,
  className: _propTypes2.default.string,
  // By default we get init params from meta tags, but one could override these here
  // See: /user/account/GoogleSignInMetaTags.html
  auth2InitParams: _propTypes2.default.object,
  // Only used for offline mode
  redirectUri: _propTypes2.default.string,
  externalAuthURL: _propTypes2.default.string,
  children: _propTypes2.default.node
};

GooglePlusSignin.defaultProps = {
  gaLabel: 'standalone',
  buttonText: 'Login with Google',
  scope: 'email',
  redirectUri: 'postmessage',
  className: 'btn-google',
  cookiePolicy: 'single_host_origin',
  externalAuthURL: '/user/account/services/ExternalAuthentication.htm',
  onSuccess: function onSuccess() {},
  onFailure: function onFailure() {}
};

exports.default = GooglePlusSignin;
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/GoogleLogo");

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _reactRouterDom = __webpack_require__(10);

var _zsgReduxInputs = __webpack_require__(11);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _clientProfiler = __webpack_require__(30);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _Nav = __webpack_require__(38);

var _Nav2 = _interopRequireDefault(_Nav);

var _TermsOfUse = __webpack_require__(25);

var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);

var _SocialLogins = __webpack_require__(28);

var _SocialLogins2 = _interopRequireDefault(_SocialLogins);

var _PasswordInput = __webpack_require__(31);

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _actions = __webpack_require__(13);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

var _customProps = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register(props) {
    (0, _classCallCheck3.default)(this, Register);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).call(this, props));

    _this.hasLogin = props.views.indexOf(_constants.LOGIN) !== -1;
    _this.hasRegister = props.views.indexOf(_constants.REGISTER) !== -1;
    _this.hasSocial = props.views.indexOf(_constants.SOCIAL) !== -1;
    _this.isPro = props.views.indexOf(_constants.PRO_REG) !== -1;
    return _this;
  }

  (0, _createClass3.default)(Register, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { gaLabel: this.props.gaLabel };
    }
  }, {
    key: 'getZipCode',
    value: function getZipCode(countrySelect) {
      var _props$getInputProps = this.props.getInputProps(this.props.inputConfigs, this.props.inputs),
          zipCode = _props$getInputProps.zipCode,
          zipCodeCanada = _props$getInputProps.zipCodeCanada;

      if (this.getIsCountryCanada(countrySelect)) {
        return zipCodeCanada;
      }
      return zipCode;
    }
  }, {
    key: 'getIsCountryCanada',
    value: function getIsCountryCanada(countrySelect) {
      return countrySelect.value === _constants.COUNTRY_TYPE_OPTIONS.Canada;
    }
  }, {
    key: 'handleRegister',
    value: function handleRegister(params) {
      var _props,
          gaLabel,
          onSuccess,
          redirectUrl,
          hideConfirmPassword,
          _params$isEmailLogin,
          isEmailLogin,
          isPro,
          proLevel,
          res,
          _ref,
          gaSuffix,
          url,
          _this4 = this;

      return Promise.resolve().then(function () {
        _props = _this4.props;
        gaLabel = _props.gaLabel;
        onSuccess = _props.onSuccess;
        redirectUrl = _props.redirectUrl;
        hideConfirmPassword = _props.hideConfirmPassword;
        _params$isEmailLogin = params.isEmailLogin;
        isEmailLogin = _params$isEmailLogin === undefined ? true : _params$isEmailLogin;
        isPro = params.isPro;
        proLevel = params.proLevel;
        res = params.res;
        _ref = _constants.REG_PRO_TYPES[proLevel] || _constants.REG_PRO_TYPES[0];
        gaSuffix = _ref.gaSuffix;


        if (isEmailLogin) {
          (0, _universalAnalytics.trackEvent)({
            action: 'register/email/' + (isPro ? gaSuffix || '' : ''),
            category: 'auth',
            label: gaLabel
          });
          // Add event trigger for GTM registration tracking tags
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'Registration' });
        }

        url = redirectUrl;
        // If redirectUrl not explicitly set and user is a pro try to follow the corresponding redirectUrl

        if (isPro && (!url || url === _constants.DEFAULT_REDIRECT_URL) && !hideConfirmPassword) {
          url = _constants.REG_PRO_TYPES[proLevel].redirectUrl;
        }

        if (onSuccess) {
          return onSuccess(res, url);
        }
      }).then(function () {
        (0, _actions.handleLoggedIn)(false, res, url);
      });
    }

    // Force validation of form inputs.

  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var inputTypes = _constants.REG_INPUT_TYPES.requiredTypes;

      var _props2 = this.props,
          gaLabel = _props2.gaLabel,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs,
          onFailure = _props2.onFailure,
          register = _props2.register,
          hideConfirmPassword = _props2.hideConfirmPassword,
          alwaysPro = _props2.alwaysPro;
      var isOutsideUSClicked = register.isOutsideUSClicked,
          overrideProSelection = register.overrideProSelection;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          areaCode = _props$getInputProps2.areaCode,
          authToken = _props$getInputProps2.authToken,
          isCommunityPillar = _props$getInputProps2.isCommunityPillar,
          emailConsent = _props$getInputProps2.emailConsent,
          firstName = _props$getInputProps2.firstName,
          lastName = _props$getInputProps2.lastName,
          newEmail = _props$getInputProps2.newEmail,
          newPassword = _props$getInputProps2.newPassword,
          phoneExt = _props$getInputProps2.phoneExt,
          phonePrefix = _props$getInputProps2.phonePrefix,
          phoneSuffix = _props$getInputProps2.phoneSuffix,
          proCheck = _props$getInputProps2.proCheck,
          proSelect = _props$getInputProps2.proSelect,
          countrySelect = _props$getInputProps2.countrySelect;

      var zipCode = this.getZipCode(countrySelect);

      proCheck.value = proCheck.value || alwaysPro && !overrideProSelection;

      if (proCheck.value) {
        inputTypes = _constants.REG_PRO_TYPES[proSelect.value] ? _constants.REG_PRO_TYPES[proSelect.value].requiredTypes : _constants.REG_PRO_TYPES[0].requiredTypes;

        if (proSelect.value !== _constants.DEFAULT_PRO_TYPE_OPTIONS['Mortgage Lender'] && this.getIsCountryCanada(countrySelect)) {
          inputTypes.push('zipCodeCanada');
        } else if (proSelect.value !== _constants.DEFAULT_PRO_TYPE_OPTIONS['Mortgage Lender']) {
          inputTypes.push('zipCode');
        }
      }

      if (hideConfirmPassword) {
        var index = inputTypes.indexOf('newPassword');
        if (index > -1) {
          inputTypes.splice(index, 1);
        }
      }

      this.props.validateInputs(inputConfigs, inputTypes).then(function () {
        (0, _clientProfiler.profileIntervalBegin)(_constants.REGISTER_PROFILE_SUBMIT);
        _this2.props.submitForm({
          path: _constants.ROUTES.registerPost,
          data: {
            ap: gaLabel,
            areaCode: areaCode.value,
            authToken: authToken.value,
            isCommunityPillar: isCommunityPillar.value,
            email: newEmail.value,
            emailOptInCheckbox: emailConsent.value,
            isOutsideUSClicked: isOutsideUSClicked,
            extension: phoneExt.value,
            firstName: firstName.value,
            lastName: lastName.value,
            number: phoneSuffix.value,
            password: newPassword.value,
            prefix: phonePrefix.value,
            proCheckbox: _this2.isPro || proCheck.value ? 1 : 0,
            proSelect: proSelect.value,
            suppressredirect: true,
            zip: zipCode.value.toUpperCase().replace(/\s/g, '')
          },
          success: function success(res) {
            (0, _clientProfiler.profileIntervalEnd)(_constants.REGISTER_PROFILE_SUBMIT);
            _this2.handleRegister({
              res: res,
              isPro: proCheck.value,
              proLevel: proSelect.value
            });
          },
          error: function error(err) {
            // We have different non-200 events that are not failures, but all 500+ are bad
            if (err.status >= 500) {
              (0, _clientProfiler.profileIntervalFail)(_constants.REGISTER_PROFILE_SUBMIT);
            }

            onFailure();
          }
        });
      }, function () {});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props,
          _props3 = this.props,
          register = _props3.register,
          newEmail = _props3.inputs.newEmail;

      // Reset any social errors

      props.hideFacebookError();

      // Hide expanded email form
      props.hideEmailForm();

      // Update email input with current newEmail value
      if (newEmail.value) {
        props.syncInputValues(newEmail, 'email');
      }

      // Clear password field and professional checkbox when leaving
      props.resetProfessionalForm(['newPassword', 'proCheck']);
      //reset validation for password
      props.resetPasswordValidation();

      if (!register.isGeoIPApiCalled) {
        this.props.setEmailConsentIfCanada();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props4 = this.props,
          register = _props4.register,
          disableSubmitOnValidate = _props4.disableSubmitOnValidate;

      var nextRegister = nextProps.register;
      var formErrorMessage = register.formErrorMessage;

      var nextFormErrorMessage = nextRegister.formErrorMessage;

      // GA form error tracking
      if (nextFormErrorMessage && nextFormErrorMessage !== formErrorMessage) {
        (0, _universalAnalytics.trackEvent)({
          action: 'error//',
          category: 'auth',
          label: nextRegister.gaLabel
        });
      }

      if (disableSubmitOnValidate) {
        this.updateFormValidation(nextProps);
      }
    }

    /**
     * Check whether both email and password fields pass validation, and set the validated state
     * @param {Object} props
     */

  }, {
    key: 'updateFormValidation',
    value: function updateFormValidation(_ref2) {
      var inputs = _ref2.inputs,
          inputConfigs = _ref2.inputConfigs,
          register = _ref2.register;

      var _props$getInputProps3 = this.props.getInputProps(inputConfigs, inputs),
          newEmail = _props$getInputProps3.newEmail,
          newPassword = _props$getInputProps3.newPassword;

      var dispatch = this.context.store.dispatch;
      var hideConfirmPassword = this.props.hideConfirmPassword;

      var validated = newEmail.value && !newEmail.error;

      if (!hideConfirmPassword) {
        validated = validated && newPassword.value && !newPassword.error;
      }

      if (register.validated !== validated) {
        (0, _actions.validateForm)(validated)(dispatch);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          disableSubmitOnValidate = _props5.disableSubmitOnValidate,
          gaLabel = _props5.gaLabel,
          headerText = _props5.headerText,
          subHeaderText = _props5.subHeaderText,
          inputs = _props5.inputs,
          inputConfigs = _props5.inputConfigs,
          register = _props5.register,
          facebookAppId = _props5.facebookAppId,
          showEmailOptIn = _props5.showEmailOptIn,
          alwaysPro = _props5.alwaysPro,
          hideConfirmPassword = _props5.hideConfirmPassword,
          showTabs = _props5.showTabs;

      var _props$getInputProps4 = this.props.getInputProps(inputConfigs, inputs),
          areaCode = _props$getInputProps4.areaCode,
          authToken = _props$getInputProps4.authToken,
          isCommunityPillar = _props$getInputProps4.isCommunityPillar,
          emailConsent = _props$getInputProps4.emailConsent,
          firstName = _props$getInputProps4.firstName,
          lastName = _props$getInputProps4.lastName,
          newEmail = _props$getInputProps4.newEmail,
          newPassword = _props$getInputProps4.newPassword,
          phoneExt = _props$getInputProps4.phoneExt,
          phonePrefix = _props$getInputProps4.phonePrefix,
          phoneSuffix = _props$getInputProps4.phoneSuffix,
          proCheck = _props$getInputProps4.proCheck,
          proSelect = _props$getInputProps4.proSelect,
          countrySelect = _props$getInputProps4.countrySelect;

      var zipCode = this.getZipCode(countrySelect);

      var carryOn = _constants.BUTTON_TYPES.carryOn,
          submit = _constants.BUTTON_TYPES.submit,
          submitDisabled = _constants.BUTTON_TYPES.submitDisabled;
      var contextData = register.contextData,
          formErrorMessage = register.formErrorMessage,
          validateOnKeyup = register.validateOnKeyup,
          newPasswordValidationMessages = register.newPasswordValidationMessages,
          showEmailConsent = register.showEmailConsent,
          isOutsideUSClicked = register.isOutsideUSClicked,
          validated = register.validated,
          overrideProSelection = register.overrideProSelection;

      // Compare with corresponding dropdown index

      var isRealEstateAgent = proSelect.value === '1';
      var primaryPhoneClasses = (0, _classnames2.default)('zsg-sm-1-1', {
        'zsg-lg-1-1': isRealEstateAgent,
        'zsg-lg-1-2': !isRealEstateAgent
      });
      var phoneNumberEntryClasses = (0, _classnames2.default)({
        'zsg-lg-1-5': isRealEstateAgent,
        'zsg-lg-1-3': !isRealEstateAgent
      });

      // error is unknown prop type for Form.checkbox
      delete proCheck.error;

      // handling for manually enforced pro login
      if (this.isPro || alwaysPro && !overrideProSelection) {
        proCheck.value = true;
      }
      var isSubmitEnabled = !disableSubmitOnValidate || validated;
      var PasswordField = _PasswordInput2.default;
      newPassword.validationMessages = newPasswordValidationMessages;

      var submitProps = (0, _extends3.default)({}, submit, proCheck.value && carryOn);

      var submitDisabledProps = (0, _extends3.default)({}, submitDisabled, proCheck.value && carryOn);

      var showEmailConsentCheckbox = showEmailConsent || showEmailOptIn;

      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
          _Header2.default,
          { text: headerText, children: subHeaderText },
          contextData && _react2.default.createElement(
            'p',
            null,
            contextData.message
          )
        ),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          showTabs && this.hasLogin && this.hasRegister && _react2.default.createElement(_Nav2.default, { activeTabType: 'register',
            tabs: ['login', 'register'] }),
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_zsgReduxInputs.Input, authToken),
            _react2.default.createElement(_zsgReduxInputs.Input, (0, _extends3.default)({ controlled: validateOnKeyup }, newEmail)),
            !hideConfirmPassword && _react2.default.createElement(PasswordField, newPassword),
            _react2.default.createElement(_zsgReduxInputs.Checkbox, (0, _extends3.default)({}, proCheck, { onClick: function onClick() {
                return _this3.props.resetProfessionalForm([], true);
              }, disabled: proCheck.value && this.isPro })),
            showEmailConsentCheckbox && _react2.default.createElement(_zsgReduxInputs.Checkbox, (0, _extends3.default)({ className: 'require-email-consent' }, emailConsent)),
            _react2.default.createElement(
              'div',
              { className: proCheck.value ? 'professional pro-type-' + proSelect.value : 'professional hide' },
              _react2.default.createElement(
                'h3',
                null,
                'Professional Information'
              ),
              _react2.default.createElement(_zsgReduxInputs.Select, proSelect),
              _react2.default.createElement(
                'div',
                { className: 'name-fields zsg-g' },
                _react2.default.createElement(
                  'div',
                  { className: 'zsg-lg-1-2 zsg-sm-1-1' },
                  _react2.default.createElement(_zsgReduxInputs.Input, firstName)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'zsg-lg-1-2 zsg-sm-1-1' },
                  _react2.default.createElement(_zsgReduxInputs.Input, lastName)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'zsg-lg-1-2 zsg-sm-1-1' },
                  _react2.default.createElement(_zsgReduxInputs.Select, countrySelect)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'zsg-lg-1-2 zsg-sm-1-1' },
                  _react2.default.createElement(_zsgReduxInputs.Input, zipCode)
                ),
                _react2.default.createElement('div', { className: 'zsg-lg-1-2 sm-hide' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'phone-fields zsg-g' },
                _react2.default.createElement(
                  'div',
                  { className: primaryPhoneClasses },
                  _react2.default.createElement(
                    'div',
                    { className: 'zsg-g' },
                    _react2.default.createElement(
                      'div',
                      { className: 'phone-label zsg-lg-1-4' },
                      _constants.PHONE_LABEL,
                      ':'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: phoneNumberEntryClasses },
                      _react2.default.createElement(_zsgReduxInputs.Input, areaCode)
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: phoneNumberEntryClasses },
                      _react2.default.createElement(_zsgReduxInputs.Input, phonePrefix)
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: phoneNumberEntryClasses },
                      _react2.default.createElement(_zsgReduxInputs.Input, phoneSuffix)
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'phone-ext-field zsg-lg-1-2 zsg-sm-1-1' },
                  _react2.default.createElement(
                    'div',
                    { className: 'zsg-g' },
                    _react2.default.createElement(
                      'div',
                      { className: 'extension-label zsg-lg-1-5' },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'extension' },
                        'ext'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'zsg-lg-2-5' },
                      _react2.default.createElement(_zsgReduxInputs.Input, phoneExt)
                    )
                  )
                )
              ),
              _react2.default.createElement(_zsgReduxInputs.Checkbox, (0, _extends3.default)({ className: 'community-pillar-field' }, isCommunityPillar)),
              _react2.default.createElement(
                'p',
                { className: 'zsg-fineprint community-pillar-field' },
                _constants.COMMUNITY_PILLAR_DESCRIPTION
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                isSubmitEnabled && _react2.default.createElement('input', submitProps),
                !isSubmitEnabled && _react2.default.createElement('input', submitDisabledProps)
              ),
              _react2.default.createElement(
                'div',
                { className: 'lower-right-panel zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement(_TermsOfUse2.default, {
                  showToggleLink: !showEmailConsentCheckbox,
                  toggleEmailConsentDisplay: this.props.toggleEmailConsentDisplay
                })
              )
            )
          ),
          formErrorMessage && _react2.default.createElement(_FormError2.default, { text: formErrorMessage })
        ),
        this.hasSocial && _react2.default.createElement(
          _Footer2.default,
          { border: 'top', text: 'Or connect with: ' },
          _react2.default.createElement(_SocialLogins2.default, {
            gaLabel: gaLabel,
            facebookAppId: facebookAppId,
            onLoginSuccess: function onLoginSuccess() {
              return _this3.handleRegister({ isEmailLogin: false });
            } })
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  /**
   * Prevent user from clicking on the submit button if the inputs fail validation
   */
  disableSubmitOnValidate: _propTypes2.default.bool.isRequired,
  /**
   * Facebook app id used for social reg/login
   */
  facebookAppId: _propTypes2.default.string.isRequired,
  /**
   * GA Label for our events
   */
  gaLabel: _propTypes2.default.string.isRequired,
  /**
   * Input props action
   */
  getInputProps: _propTypes2.default.func.isRequired,
  /**
   * Header text for view
   */
  headerText: _propTypes2.default.string.isRequired,
  history: _propTypes2.default.object,
  /**
   * subheader text for view
   */
  subHeaderText: _propTypes2.default.string,
  /**
   * input fields
   */
  inputs: _propTypes2.default.object,
  /**
   * Input configs that might be altered subject
   * to AB tests or other external factors.
   */
  inputConfigs: _propTypes2.default.object,
  /**
   * failure callback for submitForm
   */
  onFailure: _propTypes2.default.func,
  /**
   * success callback for submitForm
   */
  onSuccess: _propTypes2.default.func,
  /**
   * Redirect URL used after login.
   */
  redirectUrl: _propTypes2.default.string,
  /**
   * register state
   */
  register: _propTypes2.default.object,
  /**
   * Pro form reset action
   */
  resetProfessionalForm: _propTypes2.default.func.isRequired,
  /**
   * Whether to show email opt in checkbox
   */
  showEmailOptIn: _propTypes2.default.bool,
  /**
   * Whether to check pro checkbox
   */
  alwaysPro: _propTypes2.default.bool,
  /**
   * Whether to hide confirm
   * password input
   */
  hideConfirmPassword: _propTypes2.default.bool,
  /**
   * Render Sign in/New account tabs
   */
  showTabs: _propTypes2.default.bool,
  /**
   * Submit form action
   */
  submitForm: _propTypes2.default.func.isRequired,
  /**
   * Pro form toggle the display of email content checkbox
   */
  toggleEmailConsentDisplay: _propTypes2.default.func,
  /**
   * Display consent box action
   */
  setEmailConsentIfCanada: _propTypes2.default.func,
  /**
   * Input validation action
   */
  validateInputs: _propTypes2.default.func.isRequired,
  views: _customProps.appSubView
};
Register.defaultProps = {
  showTabs: true
};

Register.contextTypes = {
  store: _propTypes2.default.object
};

Register.childContextTypes = {
  gaLabel: _propTypes2.default.string
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  hideEmailForm: _actions.hideEmailForm,
  hideFacebookError: _actions.hideFacebookError,
  resetProfessionalForm: _actions.resetProfessionalForm,
  resetPasswordValidation: _actions.resetPasswordValidation,
  submitForm: _actions.submitForm,
  syncInputValues: _actions.syncInputValues,
  toggleEmailConsentDisplay: _actions.toggleEmailConsentDisplay,
  setEmailConsentIfCanada: _actions.setEmailConsentIfCanada,
  validateInputs: _zsgReduxInputs.validateInputs
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    disableSubmitOnValidate: state.appConfig.disableSubmitOnValidate,
    facebookAppId: state.appConfig.facebookAppId.toString(),
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    onFailure: state.appConfig.onFailure,
    onSuccess: state.appConfig.onSuccess,
    redirectUrl: state.regLogin.redirectUrl,
    register: state.login,
    headerText: state.regLogin.uiConfig.headerText,
    subHeaderText: state.regLogin.uiConfig.subHeaderText,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    showEmailOptIn: state.appConfig.showEmailOptIn,
    alwaysPro: state.appConfig.alwaysPro,
    hideConfirmPassword: state.appConfig.hideConfirmPassword,
    showTabs: state.regLogin.uiConfig.showTabs,
    views: state.appConfig.views
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(Register));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
  var target = _ref.target,
      text = _ref.text,
      url = _ref.url;
  return _react2.default.createElement(
    'a',
    { href: url, target: target },
    text
  );
}; /**
    * This is for external links only. Not to be
    * confused with react-router's Link component.
    * @kind function
    */


Link.propTypes = {
  target: _propTypes2.default.oneOf(_constants.LINK_TARGETS),
  text: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
};

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALIDATION_CLASS_NAMES = {
  neutral: '',
  pass: 'zsg-icon-check',
  fail: 'zsg-icon-circle-x'
};

var ValidationMessage = function ValidationMessage(_ref) {
  var text = _ref.text,
      status = _ref.status;
  return _react2.default.createElement(
    'div',
    { className: 'auth-validation-message validation-' + status },
    _react2.default.createElement('span', { className: 'validation-icon ' + VALIDATION_CLASS_NAMES[status] }),
    _react2.default.createElement(
      'span',
      { className: 'validation-text' },
      text
    )
  );
};

ValidationMessage.propTypes = {
  text: _propTypes2.default.string.isRequired,
  status: _propTypes2.default.oneOf(['pass', 'fail', 'neutral'])
};

ValidationMessage.defaultProps = {
  status: 'neutral'
};

exports.default = ValidationMessage;
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = __webpack_require__(33);

var _promise2 = _interopRequireDefault(_promise);

var _debounce2 = __webpack_require__(67);

var _debounce3 = _interopRequireDefault(_debounce2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Donut = __webpack_require__(68);

var _Donut2 = _interopRequireDefault(_Donut);

var _Tooltip = __webpack_require__(69);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _superagent = __webpack_require__(24);

var _superagent2 = _interopRequireDefault(_superagent);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var METER_CONFIG = {
    null: {
        color: '#FFFFFF',
        text: '',
        percent: 0
    },
    0: {
        color: '#F10000',
        text: 'Poor',
        percent: 0
    },
    1: {
        color: '#F10000',
        text: 'Weak',
        percent: 25
    },
    2: {
        color: '#FF6E01',
        text: 'Fair',
        percent: 50
    },
    3: {
        color: '#3ACE09',
        text: 'Good',
        percent: 75
    },
    4: {
        color: '#3ACE09',
        text: 'Excellent',
        percent: 100
    }

    // TODO (ACT-1600): Add/Ensure test coverage for getPasswordStrength in StrengthMeter.js
};function getPasswordStrength(password) {
    return new _promise2.default(function (resolve, reject) {
        if (!password || password.length === 0) {
            return reject(new Error('Password too short'));
        }
        return _superagent2.default.post(_constants.PASSWORD_STRENGTH_ENDPOINT).type('form').send({ password: password }).end(function (err, res) {

            if (err) {
                return reject(err);
            }

            return resolve(res.body.score);
        });
    });
}

var TOOLTIP_MESSAGE = 'Good passwords are hard to guess. Use uncommon words, non-standard uPPercasing, numb3rs or symbol$ in place of letters, or creative spelling.';
// TODO (ACT-1601): move Overlay to its own component and add unit tests
var tooltipId = 'strength-tooltip';

var Overlay = function (_Component) {
    (0, _inherits3.default)(Overlay, _Component);

    function Overlay() {
        (0, _classCallCheck3.default)(this, Overlay);
        return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
    }

    (0, _createClass3.default)(Overlay, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Ok, ok, super hacky, but the tooltip is trying to unmountAtNode even when that node doesn't exist
            // TODO: ACT-2167 - update ZSG tooltips to not unmountAtNode if element doesnt exist
            if (document && !document.getElementById(tooltipId)) {
                var el = document.createElement('div');
                el.id = tooltipId;
                document.body.appendChild(el);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _ref = METER_CONFIG[this.props.score] || {},
                color = _ref.color,
                text = _ref.text,
                percent = _ref.percent;

            var meter = _react2.default.createElement(
                'div',
                { className: 'overlay-content' },
                _react2.default.createElement(
                    'span',
                    { className: 'strength-label' },
                    text
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'strength-donut' },
                    _react2.default.createElement(_Donut2.default, { percent: percent,
                        width: 15,
                        color: color,
                        animationDuration: 300,
                        animationDelay: 100 })
                )
            );

            return _react2.default.createElement(
                _Tooltip2.default,
                { id: tooltipId, launcher: meter },
                text && _react2.default.createElement(
                    'h3',
                    null,
                    text
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    TOOLTIP_MESSAGE
                )
            );
        }
    }]);
    return Overlay;
}(_react.Component);

Overlay.propTypes = {
    score: _propTypes2.default.number
};

var StrengthMeter = function (_Component2) {
    (0, _inherits3.default)(StrengthMeter, _Component2);

    function StrengthMeter() {
        var _ref2;

        var _temp, _this2, _ret;

        (0, _classCallCheck3.default)(this, StrengthMeter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = StrengthMeter.__proto__ || (0, _getPrototypeOf2.default)(StrengthMeter)).call.apply(_ref2, [this].concat(args))), _this2), _this2.updatePasswordStrength = (0, _debounce3.default)(function (newPassword) {
            getPasswordStrength(newPassword).then(function (score) {
                _this2.setState({ score: score });
            });
        }, 500), _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
    }

    (0, _createClass3.default)(StrengthMeter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.password !== nextProps.password) {
                this.updatePasswordStrength(nextProps.password);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _ref3 = this.state || {},
                score = _ref3.score;

            return _react2.default.createElement(
                'div',
                { className: 'password-strength-meter' },
                _react2.default.createElement(Overlay, { score: score })
            );
        }
    }]);
    return StrengthMeter;
}(_react.Component);

StrengthMeter.propTypes = {
    password: _propTypes2.default.string.isRequired
};

exports.default = StrengthMeter;
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = require("lodash/debounce");

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/Donut");

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = require("@zillow/react-zsg/Tooltip");

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _zsgReduxInputs = __webpack_require__(11);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _SocialLogins = __webpack_require__(28);

var _SocialLogins2 = _interopRequireDefault(_SocialLogins);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _actions = __webpack_require__(13);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

var _customProps = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword(props, context) {
    (0, _classCallCheck3.default)(this, ForgotPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).call(this, props));

    var dispatch = context.store.dispatch;


    _this.dispatch = dispatch;
    _this.hasSocial = props.views.indexOf(_constants.SOCIAL) !== -1 && !props.passwordless;

    _this.beforeSignIn = _this.beforeSignIn.bind(_this);
    _this.onSocialLoginSuccess = _this.onSocialLoginSuccess.bind(_this);
    return _this;
  }

  /**
   * GA tracking for sign in now link click.
   */


  (0, _createClass3.default)(ForgotPassword, [{
    key: 'beforeSignIn',
    value: function beforeSignIn() {
      (0, _universalAnalytics.trackEvent)({
        action: 'forgotpasswordsigninnow//',
        category: 'auth',
        label: this.props.gaLabel
      });
    }
  }, {
    key: 'onSocialLoginSuccess',
    value: function onSocialLoginSuccess(e) {
      (0, _actions.handleLoggedIn)(false, e);
    }

    // Force validation of form inputs.

  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          authAP = _props.authAP,
          gaLabel = _props.gaLabel,
          history = _props.history,
          inputs = _props.inputs,
          inputConfigs = _props.inputConfigs;


      this.props.validateInputs(inputConfigs, _constants.FORGOT_INPUT_TYPES.requiredTypes).then(function () {
        var _props$getInputProps = _this2.props.getInputProps(inputConfigs, inputs),
            authToken = _props$getInputProps.authToken,
            email = _props$getInputProps.email;

        (0, _universalAnalytics.trackEvent)({
          action: 'forgotpasswordsubmit//',
          category: 'auth',
          label: gaLabel
        });

        _this2.props.submitForm({
          path: _constants.ROUTES.forgotPost,
          data: {
            ap: authAP,
            authToken: authToken.value,
            email: email.value
          },
          success: function success() {
            _this2.props.handleForgotSuccess(history);
          }
        });
      }, function () {});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var props = this.props;
      // Clear any error messages

      props.resetFormError();

      // Suppress email field error
      props.resetFields([], ['email']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var loginLink = _react2.default.createElement(
        _reactRouterDom.Link,
        { to: _constants.ROUTES.login,
          onClick: this.beforeSignIn },
        _constants.FORM_TEXT.loginLink
      );
      var _props2 = this.props,
          facebookAppId = _props2.facebookAppId,
          forgot = _props2.forgot,
          gaLabel = _props2.gaLabel,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs,
          passwordless = _props2.passwordless;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          authToken = _props$getInputProps2.authToken,
          email = _props$getInputProps2.email;

      var send = _constants.BUTTON_TYPES.send;
      var formErrorMessage = forgot.formErrorMessage;


      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
          _Header2.default,
          { text: passwordless ? _constants.FORM_TEXT.forgotPasswordPasswordless : _constants.FORM_TEXT.forgotPasswordLink },
          'Enter your email address and we\'ll send you a link to set your password.'
        ),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_zsgReduxInputs.Input, authToken),
            _react2.default.createElement(_zsgReduxInputs.Input, email),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement('input', send)
              ),
              _react2.default.createElement(
                'div',
                { className: 'lower-right-panel zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement(
                  'div',
                  null,
                  'Know your password? ',
                  _react2.default.createElement('br', null),
                  ' ',
                  loginLink
                )
              )
            )
          ),
          formErrorMessage && _react2.default.createElement(_FormError2.default, { text: formErrorMessage }),
          passwordless && _react2.default.createElement(
            'div',
            { className: 'zsg-copy_secondary' },
            _react2.default.createElement(
              'p',
              { className: 'zsg-notification-bar' },
              '* You\'ve reached this page because you don\'t have a password set'
            )
          )
        ),
        this.hasSocial && _react2.default.createElement(
          _Footer2.default,
          { border: 'top', text: 'Or connect with:' },
          _react2.default.createElement(_SocialLogins2.default, {
            gaLabel: gaLabel,
            facebookAppId: facebookAppId,
            onLoginSuccess: this.onSocialLoginSuccess })
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  authAP: _propTypes2.default.string,
  facebookAppId: _propTypes2.default.string.isRequired,
  forgot: _propTypes2.default.object,
  gaLabel: _propTypes2.default.string.isRequired,
  getInputProps: _propTypes2.default.func.isRequired,
  handleForgotSuccess: _propTypes2.default.func.isRequired,
  history: _propTypes2.default.object,
  inputs: _propTypes2.default.object,
  inputConfigs: _propTypes2.default.object,
  submitForm: _propTypes2.default.func.isRequired,
  validateInputs: _propTypes2.default.func.isRequired,
  views: _customProps.appSubView,
  passwordless: _propTypes2.default.bool
};

ForgotPassword.contextTypes = {
  store: _propTypes2.default.object
};

ForgotPassword.contextTypes = {
  store: _propTypes2.default.object
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  handleForgotSuccess: _actions.handleForgotSuccess,
  resetFields: _actions.resetFields,
  resetFormError: _actions.resetFormError,
  submitForm: _actions.submitForm,
  validateInputs: _zsgReduxInputs.validateInputs
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    facebookAppId: state.appConfig.facebookAppId.toString(),
    forgot: state.login,
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    views: state.appConfig.views,
    passwordless: state.appConfig.passwordless
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(ForgotPassword));
module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordSuccess = function (_Component) {
  (0, _inherits3.default)(ForgotPasswordSuccess, _Component);

  function ForgotPasswordSuccess(props) {
    (0, _classCallCheck3.default)(this, ForgotPasswordSuccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordSuccess.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordSuccess)).call(this, props));

    _this.beforeLogin = _this.beforeLogin.bind(_this);
    return _this;
  }
  /**
   * GA tracking for sign in link
   */


  (0, _createClass3.default)(ForgotPasswordSuccess, [{
    key: 'beforeLogin',
    value: function beforeLogin() {
      (0, _universalAnalytics.trackEvent)({
        action: 'forgotpasswordsigninnow//',
        category: 'auth',
        label: this.props.gaLabel
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputs = _props.inputs,
          inputConfigs = _props.inputConfigs;

      var _props$getInputProps = this.props.getInputProps(inputConfigs, inputs),
          email = _props$getInputProps.email;

      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
          _Header2.default,
          { text: 'Request received!' },
          _react2.default.createElement(
            'p',
            null,
            'An email has been sent with a link to reset your password.'
          )
        ),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          email.value && _react2.default.createElement(
            'p',
            null,
            'Email sent to: ',
            _react2.default.createElement(
              'strong',
              null,
              email.value
            )
          )
        ),
        _react2.default.createElement(
          _Footer2.default,
          { text: 'Know your password? ' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            {
              to: _constants.ROUTES.login,
              onClick: this.beforeLogin
            },
            'Sign in now'
          )
        )
      );
    }
  }]);
  return ForgotPasswordSuccess;
}(_react.Component);

ForgotPasswordSuccess.propTypes = {
  history: _propTypes2.default.object,
  inputs: _propTypes2.default.object.isRequired,
  inputConfigs: _propTypes2.default.object,
  gaLabel: _propTypes2.default.string.isRequired,
  getInputProps: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    gaLabel: state.regLogin.uiConfig.gaLabel
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(ForgotPasswordSuccess));
module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Need a stateful component class as
 * connectToUserSession will rerender component
 * with each user session store update.
 * 
 * GA payload needs componentDidMount as this only
 * fires once per mount/unmount.
 */
var PasswordRecovery = function (_Component) {
  (0, _inherits3.default)(PasswordRecovery, _Component);

  function PasswordRecovery() {
    (0, _classCallCheck3.default)(this, PasswordRecovery);
    return (0, _possibleConstructorReturn3.default)(this, (PasswordRecovery.__proto__ || (0, _getPrototypeOf2.default)(PasswordRecovery)).apply(this, arguments));
  }

  (0, _createClass3.default)(PasswordRecovery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _universalAnalytics.trackEvent)({
        category: 'auth',
        action: 'confirmemail//',
        label: this.props.gaLabel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(_Header2.default, { text: 'Check your email' }),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          _react2.default.createElement(
            'p',
            null,
            _constants.FORM_TEXT.passwordRecovery
          ),
          _react2.default.createElement(
            'p',
            null,
            'Email sent to: ',
            _react2.default.createElement(
              'strong',
              null,
              this.props.email
            )
          )
        )
      );
    }
  }]);
  return PasswordRecovery;
}(_react.Component);

PasswordRecovery.propTypes = {
  gaLabel: _propTypes2.default.string.isRequired,
  email: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    email: state.inputs.email.value,
    gaLabel: state.regLogin.uiConfig.gaLabel
  };
};

exports.default = (0, _userSessionStoreConnect2.default)(mapStateToProps)(PasswordRecovery);
module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordlessSignin = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _zsgReduxInputs = __webpack_require__(11);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _SocialLogins = __webpack_require__(28);

var _SocialLogins2 = _interopRequireDefault(_SocialLogins);

var _TermsOfUse = __webpack_require__(25);

var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _actions = __webpack_require__(13);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

var _customProps = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordlessSignin = exports.PasswordlessSignin = function (_Component) {
  (0, _inherits3.default)(PasswordlessSignin, _Component);

  function PasswordlessSignin(props) {
    (0, _classCallCheck3.default)(this, PasswordlessSignin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordlessSignin.__proto__ || (0, _getPrototypeOf2.default)(PasswordlessSignin)).call(this, props));

    _this.hasSocial = props.views.indexOf(_constants.SOCIAL) !== -1;
    _this.onSocialLoginSuccess = _this.onSocialLoginSuccess.bind(_this);
    return _this;
  }

  // Force validation of form inputs.


  (0, _createClass3.default)(PasswordlessSignin, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          authAP = _props.authAP,
          gaLabel = _props.gaLabel,
          inputs = _props.inputs,
          inputConfigs = _props.inputConfigs,
          history = _props.history,
          register = _props.register;
      var isOutsideUSClicked = register.isOutsideUSClicked;


      this.props.validateInputs(inputConfigs, _constants.PASSWORDLESS_SIGNIN_INPUT_TYPES.requiredTypes).then(function () {
        var _props$getInputProps = _this2.props.getInputProps(inputConfigs, inputs),
            authToken = _props$getInputProps.authToken,
            email = _props$getInputProps.email,
            emailConsent = _props$getInputProps.emailConsent;

        (0, _universalAnalytics.trackEvent)({
          category: 'auth',
          action: 'emailsubmit//',
          label: gaLabel
        });

        _this2.props.submitForm({
          path: _constants.ROUTES.registerPost,
          data: {
            ap: authAP,
            authToken: authToken.value,
            email: email.value,
            emailOptInCheckbox: emailConsent.value,
            isOutsideUSClicked: isOutsideUSClicked
          },
          success: function success(data) {
            _this2.props.handlePasswordlessSigninSuccess(data, history);

            (0, _universalAnalytics.trackEvent)({
              category: 'auth',
              action: 'register/email/',
              label: gaLabel
            });
          },
          error: function error(err, link, hasPassword) {
            _this2.props.handlePasswordlessSigninFailure(hasPassword, history);
          }
        });
      }, function () {});
    }
  }, {
    key: 'onSocialLoginSuccess',
    value: function onSocialLoginSuccess() {
      (0, _actions.handleLoggedIn)();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var props = this.props,
          email = this.props.inputs.email;

      // Update newEmail input with current email value, used for validation

      if (email.value) {
        props.syncInputValues(email, 'newEmail');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          facebookAppId = _props2.facebookAppId,
          gaLabel = _props2.gaLabel,
          headerText = _props2.headerText,
          subHeaderText = _props2.subHeaderText,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs,
          showEmailConsent = _props2.showEmailConsent,
          showEmailOptIn = _props2.showEmailOptIn;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          authToken = _props$getInputProps2.authToken,
          email = _props$getInputProps2.email,
          emailConsent = _props$getInputProps2.emailConsent;

      var submit = _constants.BUTTON_TYPES.submit;


      var showEmailConsentCheckbox = showEmailConsent || showEmailOptIn;

      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(_Header2.default, { text: headerText, children: subHeaderText }),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_zsgReduxInputs.Input, authToken),
            _react2.default.createElement(_zsgReduxInputs.Input, email),
            showEmailConsentCheckbox && _react2.default.createElement(_zsgReduxInputs.Checkbox, (0, _extends3.default)({ className: 'require-email-consent' }, emailConsent)),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement('input', submit)
              ),
              _react2.default.createElement(
                'div',
                { className: 'lower-right-panel zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement(_TermsOfUse2.default, {
                  showToggleLink: !showEmailConsentCheckbox,
                  toggleEmailConsentDisplay: this.props.toggleEmailConsentDisplay
                })
              )
            )
          )
        ),
        this.hasSocial && _react2.default.createElement(
          _Footer2.default,
          { border: 'top', text: 'Or connect with:' },
          _react2.default.createElement(_SocialLogins2.default, {
            gaLabel: gaLabel,
            facebookAppId: facebookAppId,
            onLoginSuccess: function onLoginSuccess() {
              return _this3.onSocialLoginSuccess();
            } })
        )
      );
    }
  }]);
  return PasswordlessSignin;
}(_react.Component);

PasswordlessSignin.propTypes = {
  /**
   * Auth process needed for the register/auth endpoint
   */
  authAP: _propTypes2.default.string,
  facebookAppId: _propTypes2.default.string.isRequired,
  gaLabel: _propTypes2.default.string.isRequired,
  getInputProps: _propTypes2.default.func.isRequired,
  handlePasswordlessSigninSuccess: _propTypes2.default.func.isRequired,
  handlePasswordlessSigninFailure: _propTypes2.default.func.isRequired,
  headerText: _propTypes2.default.string.isRequired,
  history: _propTypes2.default.object,
  subHeaderText: _propTypes2.default.string,
  inputs: _propTypes2.default.object,
  inputConfigs: _propTypes2.default.object,
  /**
   * Whether to show email opt in checkbox
   */
  showEmailOptIn: _propTypes2.default.bool,
  submitForm: _propTypes2.default.func.isRequired,
  showEmailConsent: _propTypes2.default.bool,
  toggleEmailConsentDisplay: _propTypes2.default.func,
  validateInputs: _propTypes2.default.func.isRequired,
  views: _customProps.appSubView,
  register: _propTypes2.default.object
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  handlePasswordlessSigninSuccess: _actions.handlePasswordlessSigninSuccess,
  handlePasswordlessSigninFailure: _actions.handlePasswordlessSigninFailure,
  submitForm: _actions.submitForm,
  syncInputValues: _actions.syncInputValues,
  toggleEmailConsentDisplay: _actions.toggleEmailConsentDisplay,
  validateInputs: _zsgReduxInputs.validateInputs
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    authAP: state.regLogin.uiConfig.authAP,
    facebookAppId: state.appConfig.facebookAppId.toString(),
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    headerText: state.regLogin.uiConfig.headerText,
    subHeaderText: state.regLogin.uiConfig.subHeaderText,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    showEmailConsent: state.login.showEmailConsent,
    showEmailOptIn: state.appConfig.showEmailOptIn,
    views: state.appConfig.views,
    register: state.login
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(PasswordlessSignin));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordlessCreatePassword = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _zsgReduxInputs = __webpack_require__(11);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _TermsOfUse = __webpack_require__(25);

var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);

var _PasswordInput = __webpack_require__(31);

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _actions = __webpack_require__(13);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

var _customProps = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordlessCreatePassword = exports.PasswordlessCreatePassword = function (_Component) {
  (0, _inherits3.default)(PasswordlessCreatePassword, _Component);

  function PasswordlessCreatePassword(props, context) {
    (0, _classCallCheck3.default)(this, PasswordlessCreatePassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordlessCreatePassword.__proto__ || (0, _getPrototypeOf2.default)(PasswordlessCreatePassword)).call(this, props));

    var dispatch = context.store.dispatch;


    _this.dispatch = dispatch;
    return _this;
  }

  // Force validation of form inputs.


  (0, _createClass3.default)(PasswordlessCreatePassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          authAP = _props.authAP,
          authToken = _props.authToken,
          gaLabel = _props.gaLabel,
          inputs = _props.inputs,
          inputConfigs = _props.inputConfigs,
          redirectUrl = _props.redirectUrl,
          doRedirect = _props.doRedirect,
          register = _props.register;
      var isOutsideUSClicked = register.isOutsideUSClicked;


      this.props.validateInputs(inputConfigs, _constants.PASSWORDLESS_CREATE_PASSWORD_INPUT_TYPES.requiredTypes).then(function () {
        var _props$getInputProps = _this2.props.getInputProps(inputConfigs, inputs),
            newPassword = _props$getInputProps.newPassword,
            email = _props$getInputProps.email;

        _this2.props.submitForm({
          path: _constants.ROUTES.confirmEmailPost,
          data: {
            ap: authAP,
            token: authToken,
            email: email.value,
            password: newPassword.value,
            passwordless: true,
            isOutsideUSClicked: isOutsideUSClicked
          },
          success: function success() {
            (0, _universalAnalytics.trackEvent)({
              category: 'auth',
              action: 'passwordsubmit//',
              label: gaLabel
            });

            (0, _actions.handleLoggedIn)(false, {}, doRedirect && redirectUrl);
          }
        });
      }, function () {});
    }
  }, {
    key: 'handleLater',
    value: function handleLater(e) {
      e.preventDefault();

      var _props2 = this.props,
          authAP = _props2.authAP,
          authToken = _props2.authToken,
          gaLabel = _props2.gaLabel,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs,
          redirectUrl = _props2.redirectUrl;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          email = _props$getInputProps2.email;

      this.props.submitForm({
        path: _constants.ROUTES.passwordlessSendEmailPost,
        data: {
          ap: authAP,
          token: authToken,
          email: email.value,
          passwordless: true,
          skipPasswordCreation: true
        },
        success: function success() {
          (0, _actions.handleLoggedIn)(false, {}, redirectUrl);
        }
      });

      (0, _universalAnalytics.trackEvent)({
        category: 'auth',
        action: 'dothislatersubmit//',
        label: gaLabel
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _actions.handleLoggedIn)();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          disableSubmitOnValidate = _props3.disableSubmitOnValidate,
          facebookAppId = _props3.facebookAppId,
          inputs = _props3.inputs,
          inputConfigs = _props3.inputConfigs,
          register = _props3.register;

      var _props$getInputProps3 = this.props.getInputProps(inputConfigs, inputs),
          authToken = _props$getInputProps3.authToken,
          newPassword = _props$getInputProps3.newPassword;

      var submit = _constants.BUTTON_TYPES.submit,
          submitDisabled = _constants.BUTTON_TYPES.submitDisabled,
          later = _constants.BUTTON_TYPES.later;

      var isSubmitEnabled = !((!inputs.newPassword.value || inputs.newPassword.hasOwnProperty('error')) && disableSubmitOnValidate);
      var submitButton = (!inputs.newPassword.value || inputs.newPassword.hasOwnProperty('error')) && disableSubmitOnValidate ? submitDisabled : submit;
      var PasswordField = _PasswordInput2.default;
      newPassword.validationMessages = register.newPasswordValidationMessages;

      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
          _Header2.default,
          { text: _constants.FORM_TEXT.createAPasswordText },
          _constants.FORM_TEXT.createAPasswordMessage
        ),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_zsgReduxInputs.Input, authToken),
            _react2.default.createElement(PasswordField, newPassword),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                isSubmitEnabled && _react2.default.createElement('input', submit),
                !isSubmitEnabled && _react2.default.createElement('input', submitDisabled)
              ),
              _react2.default.createElement(
                'div',
                { className: 'do-this-later zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement('input', (0, _extends3.default)({ onClick: function onClick(e) {
                    return _this3.handleLater(e);
                  } }, later))
              ),
              _react2.default.createElement(
                'div',
                { className: 'lower-right-panel zsg-lg-1-1 zsg-sm-1-1' },
                _react2.default.createElement(_TermsOfUse2.default, null)
              )
            )
          )
        )
      );
    }
  }]);
  return PasswordlessCreatePassword;
}(_react.Component);

PasswordlessCreatePassword.propTypes = {
  /**
   * Auth process needed for the register/auth endpoint
   */
  authAP: _propTypes2.default.string,
  /**
   * Auth token needed for the register/auth endpoint
   */
  authToken: _propTypes2.default.string,
  /**
   * Prevent user from clicking on the submit button if the inputs fail validation
   */
  disableSubmitOnValidate: _propTypes2.default.bool.isRequired,
  /**
   * Facebook app id used for social reg/login
   */
  facebookAppId: _propTypes2.default.string.isRequired,
  /**
   * GA Label for our events
   */
  gaLabel: _propTypes2.default.string.isRequired,
  /**
   * Helper method for retrieving props from redux-inputs
   */
  getInputProps: _propTypes2.default.func.isRequired,
  history: _propTypes2.default.object,
  /**
   * input fields
   */
  inputs: _propTypes2.default.object,
  /**
   * Input configs that might be altered subject
   * to AB tests or other external factors.
   */
  inputConfigs: _propTypes2.default.object,
  /**
   * submit form action
   */
  submitForm: _propTypes2.default.func.isRequired,
  /**
   * register state
   */
  register: _propTypes2.default.object,
  redirectUrl: _propTypes2.default.string,
  doRedirect: _propTypes2.default.bool,
  validateInputs: _propTypes2.default.func.isRequired,
  views: _customProps.appSubView
};

PasswordlessCreatePassword.contextTypes = {
  store: _propTypes2.default.object
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  submitForm: _actions.submitForm,
  validateInputs: _zsgReduxInputs.validateInputs
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    authAP: state.regLogin.uiConfig.authAP,
    authToken: state.user.authToken,
    disableSubmitOnValidate: state.appConfig.disableSubmitOnValidate,
    facebookAppId: state.appConfig.facebookAppId.toString(),
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    register: state.login,
    redirectUrl: state.appConfig.isLightbox ? null : state.regLogin.redirectUrl,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    doRedirect: !state.appConfig.showLightbox
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(PasswordlessCreatePassword));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmEmail = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _universalAnalytics = __webpack_require__(3);

var _userSessionStoreConnect = __webpack_require__(12);

var _userSessionStoreConnect2 = _interopRequireDefault(_userSessionStoreConnect);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _PasswordInput = __webpack_require__(31);

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _zsgReduxInputs = __webpack_require__(11);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _TermsOfUse = __webpack_require__(25);

var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);

var _pageView = __webpack_require__(18);

var _pageView2 = _interopRequireDefault(_pageView);

var _actions = __webpack_require__(13);

var _confirmEmail = __webpack_require__(40);

var _reduxInputs = __webpack_require__(20);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmEmail = exports.ConfirmEmail = function (_Component) {
  (0, _inherits3.default)(ConfirmEmail, _Component);

  function ConfirmEmail(props) {
    (0, _classCallCheck3.default)(this, ConfirmEmail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmEmail.__proto__ || (0, _getPrototypeOf2.default)(ConfirmEmail)).call(this, props));

    var isValidEmailToken = props.emailConfirmed.isValidEmailToken,
        history = props.history,
        fromEmail = props.fromEmail;


    if (!isValidEmailToken) {
      props.handleInvalidEmailToken(history);
    } else if (!fromEmail) {
      props.handleNotFromEmail(history);
    }
    return _this;
  }

  // Force validation of form inputs.


  (0, _createClass3.default)(ConfirmEmail, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          authToken = _props.authToken,
          gaLabel = _props.gaLabel,
          inputs = _props.inputs,
          inputConfigs = _props.inputConfigs,
          passwordless = _props.passwordless,
          redirectUrl = _props.redirectUrl,
          history = _props.history;


      this.props.validateInputs(inputConfigs, _constants.EMAIL_CONFIRMED_INPUT_TYPES.requiredTypes).then(function () {
        var _props$getInputProps = _this2.props.getInputProps(inputConfigs, inputs),
            newPassword = _props$getInputProps.newPassword;

        (0, _universalAnalytics.trackEvent)({
          action: 'confirmemailsubmit//',
          category: 'auth',
          label: gaLabel
        });

        _this2.props.submitForm({
          path: _constants.ROUTES.confirmEmailPost,
          data: {
            password: newPassword.value,
            passwordless: true,
            token: authToken
          },
          success: function success() {
            _this2.props.handleConfirmEmailSuccess(redirectUrl);
          },
          error: function error(err, link) {
            if (err.response.body.message === 'Invalid token') {
              _this2.props.updateIsValidEmailToken(false);
            }
          }
        });
      }, function () {});
    }

    /**
     * Check whether both email and password fields pass validation, and set the validated state
     * @param {Object} props
     */

  }, {
    key: 'updateFormValidation',
    value: function updateFormValidation(_ref) {
      var inputs = _ref.inputs,
          inputConfigs = _ref.inputConfigs,
          emailConfirmed = _ref.emailConfirmed;

      var _props$getInputProps2 = this.props.getInputProps(inputConfigs, inputs),
          newPassword = _props$getInputProps2.newPassword;

      var dispatch = this.context.store.dispatch;

      var validated = newPassword.value && !newPassword.error;

      if (emailConfirmed.validated !== validated) {
        (0, _actions.validateForm)(validated)(dispatch);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _pageView2.default)(this.props.history.location.pathname);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var isValidEmailToken = this.props.emailConfirmed.isValidEmailToken;
      var emailConfirmed = prevProps.emailConfirmed,
          history = prevProps.history;

      // isValidEmailToken could be undefined initially so need to do explicit comparison

      if (isValidEmailToken === false) {
        this.props.handleInvalidEmailToken(history);
      }

      this.updateFormValidation(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetFormError();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          emailConfirmed = _props2.emailConfirmed,
          gaLabel = _props2.gaLabel,
          inputs = _props2.inputs,
          inputConfigs = _props2.inputConfigs;

      var _props$getInputProps3 = this.props.getInputProps(inputConfigs, inputs),
          newPassword = _props$getInputProps3.newPassword;

      var send = _constants.BUTTON_TYPES.send;
      var formErrorMessage = emailConfirmed.formErrorMessage,
          newPasswordValidationMessages = emailConfirmed.newPasswordValidationMessages,
          validated = emailConfirmed.validated;


      newPassword.validationMessages = newPasswordValidationMessages;

      return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
          _Header2.default,
          { text: _constants.FORM_TEXT.emailConfirmedText },
          _constants.FORM_TEXT.createAPasswordMessage
        ),
        _react2.default.createElement(
          _BodyWrapper2.default,
          null,
          _react2.default.createElement(
            _Form2.default,
            { onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              } },
            _react2.default.createElement(_PasswordInput2.default, newPassword),
            _react2.default.createElement(
              'div',
              { className: 'zsg-form-field' },
              _react2.default.createElement(
                'div',
                { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                _react2.default.createElement('input', (0, _extends3.default)({}, send, { disabled: !validated }))
              )
            )
          ),
          formErrorMessage && _react2.default.createElement(_FormError2.default, { text: formErrorMessage })
        ),
        _react2.default.createElement(
          _Footer2.default,
          null,
          _react2.default.createElement(_TermsOfUse2.default, null)
        )
      );
    }
  }]);
  return ConfirmEmail;
}(_react.Component);

ConfirmEmail.propTypes = {
  authAP: _propTypes2.default.string,
  authToken: _propTypes2.default.string,
  emailConfirmed: _propTypes2.default.object,
  fromEmail: _propTypes2.default.bool,
  gaLabel: _propTypes2.default.string.isRequired,
  getInputProps: _propTypes2.default.func.isRequired,
  handleConfirmEmailSuccess: _propTypes2.default.func.isRequired,
  handleInvalidEmailToken: _propTypes2.default.func,
  handleNotFromEmail: _propTypes2.default.func,
  history: _propTypes2.default.object,
  inputs: _propTypes2.default.object,
  inputConfigs: _propTypes2.default.object,
  passwordless: _propTypes2.default.bool,
  redirectUrl: _propTypes2.default.string,
  resetFormError: _propTypes2.default.func,
  submitForm: _propTypes2.default.func.isRequired,
  updateIsValidEmailToken: _propTypes2.default.func,
  validateInputs: _propTypes2.default.func.isRequired
};

ConfirmEmail.contextTypes = {
  store: _propTypes2.default.object
};

var mapDispatchToProps = {
  getInputProps: _reduxInputs.getInputProps,
  handleConfirmEmailSuccess: _confirmEmail.handleConfirmEmailSuccess,
  handleInvalidEmailToken: _confirmEmail.handleInvalidEmailToken,
  handleNotFromEmail: _confirmEmail.handleNotFromEmail,
  resetFormError: _actions.resetFormError,
  submitForm: _actions.submitForm,
  validateInputs: _zsgReduxInputs.validateInputs,
  updateIsValidEmailToken: _confirmEmail.updateIsValidEmailToken
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    authToken: state.appConfig.authToken,
    emailConfirmed: state.login,
    fromEmail: state.appConfig.fromEmail,
    inputs: state.inputs,
    inputConfigs: state.appConfig.inputConfigs,
    gaLabel: state.regLogin.uiConfig.gaLabel,
    redirectUrl: state.regLogin.redirectUrl
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _userSessionStoreConnect2.default)(mapStateToProps, mapDispatchToProps)(ConfirmEmail));

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidTokenMsg = InvalidTokenMsg;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(10);

var _Form = __webpack_require__(17);

var _Form2 = _interopRequireDefault(_Form);

var _ViewWrapper = __webpack_require__(14);

var _ViewWrapper2 = _interopRequireDefault(_ViewWrapper);

var _BodyWrapper = __webpack_require__(15);

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _Footer = __webpack_require__(19);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormError = __webpack_require__(22);

var _FormError2 = _interopRequireDefault(_FormError);

var _Header = __webpack_require__(16);

var _Header2 = _interopRequireDefault(_Header);

var _TermsOfUse = __webpack_require__(25);

var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);

var _constants = __webpack_require__(2);

var _confirmEmail = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var send = _constants.BUTTON_TYPES.send;
function InvalidTokenMsg(_ref) {
    var history = _ref.history,
        onSubmitHandler = _ref.onSubmitHandler,
        headerText = _ref.headerText,
        headerMsg = _ref.headerMsg;

    return _react2.default.createElement(
        _ViewWrapper2.default,
        null,
        _react2.default.createElement(
            _Header2.default,
            { text: headerText },
            headerMsg
        ),
        _react2.default.createElement(
            _BodyWrapper2.default,
            null,
            _react2.default.createElement(
                _Form2.default,
                { onSubmit: function onSubmit(e) {
                        e.preventDefault();
                        onSubmitHandler(history);
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'zsg-form-field' },
                    _react2.default.createElement(
                        'div',
                        { className: 'submit-div zsg-lg-1-2 zsg-sm-1-1' },
                        _react2.default.createElement('input', send)
                    )
                )
            )
        ),
        _react2.default.createElement(
            _Footer2.default,
            null,
            _react2.default.createElement(_TermsOfUse2.default, null)
        )
    );
}

InvalidTokenMsg.propTypes = {
    onSubmitHandler: _propTypes2.default.func.isRequired,
    history: _propTypes2.default.object,
    headerText: _propTypes2.default.string,
    headerMsg: _propTypes2.default.string
};

InvalidTokenMsg.defaultProps = {
    onSubmitHandler: _confirmEmail.handleInvalidEmailTokenSubmit,
    headerText: _constants.FORM_TEXT.invalidTokenMsgText,
    headerMsg: _constants.FORM_TEXT.invalidTokenMsgMessage
};

exports.default = (0, _reactRouterDom.withRouter)(InvalidTokenMsg);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getOnLoadHandlers = exports.PING_TIME_LIMIT = exports.PING_INTERVAL = exports._smartlock = exports.SMARTLOCK_SELECTOR = exports.ENDPOINT_FAILURE_MSG = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.getVisibleElement = getVisibleElement;
exports.ping = ping;
exports.__onSmartLockLoad = __onSmartLockLoad;
exports.track = track;
exports.getGAEvent = getGAEvent;
exports.loadSDK = loadSDK;
exports.handleIdToken = handleIdToken;
exports.handleBlackListed = handleBlackListed;
exports.init = init;
exports.close = close;

var _superagent = __webpack_require__(24);

var _superagent2 = _interopRequireDefault(_superagent);

var _universalAnalytics = __webpack_require__(3);

var _constants = __webpack_require__(78);

var _clientProfiler = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINT_FAILURE_MSG = exports.ENDPOINT_FAILURE_MSG = 'Unknown Google error. Please try again.';
var SMARTLOCK_SELECTOR = exports.SMARTLOCK_SELECTOR = 'iframe[src^="https://smartlock.google.com"]';
var _smartlock = exports._smartlock = void 0;
var PING_INTERVAL = exports.PING_INTERVAL = 1000;
var PING_TIME_LIMIT = exports.PING_TIME_LIMIT = 7000;

var _cancel = false;
var doTrackLoad = true;
var cancelPing = false;

/**
 * Get a visible element
 * @param {String} selector 
 */
function getVisibleElement(selector) {
	var element = document.querySelector(selector);
	if (element && element.style.display !== 'none') {
		return element;
	}
	return null;
}

/**
 * Wait for an element to be present unless canceled or timed out
 * @param {Number|Date} startTime 
 * @param {Function} elementFn 
 * @param {Function} callback 
 * @returns {Function} Function to cancel/uncancel ping
 */
function ping(startTime) {
	var elementFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_) {};
	var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_) {};

	setTimeout(function () {
		var element = elementFn();
		if (element) {
			callback(element);
		} else if (!cancelPing && Date.now() - startTime <= PING_TIME_LIMIT) {
			ping(startTime, elementFn, callback);
		}
	}, PING_INTERVAL);
}

/**
 * Global callback when sdk loads
 *
 * @param {Object} smartlock
 * @param {Object} smartlockConfig
 ** @param {String} smartlockConfig.clientId
 ** @param {String} smartlockConfig.context
 */
function __onSmartLockLoad(smartlock) {
	var smartlockConfig,
	    handlers,
	    clientId,
	    context,
	    _ref,
	    id,
	    idToken,
	    type,
	    _discriminant,
	    _match,
	    _brokenOut,
	    _arguments = arguments;

	return Promise.resolve().then(function () {
		smartlockConfig = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
		handlers = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
		clientId = smartlockConfig.clientId;
		context = smartlockConfig.context;


		exports._smartlock = _smartlock = smartlock;
		return Promise.resolve().then(function () {
			return smartlock.hint({
				supportedAuthMethods: [_constants.GOOGLE_ACCOUNTS_URI],
				supportedIdTokenProviders: [{
					uri: _constants.GOOGLE_ACCOUNTS_URI,
					clientId: clientId,
					context: context
				}]
			});
		}).then(function (_resp) {
			_ref = _resp;
			id = _ref.id;
			idToken = _ref.idToken;

			// to avoid race conditions we may need to cancel the init bit

			if (_cancel) {
				smartlock.cancelLastOperation().then(function () {
					// Closing...
				});
				return;
			}

			if (id && id.indexOf(_constants.BLACKLIST_DOMAIN) > -1) {
				exports.handleBlackListed(id, handlers.failure);
			}

			if (idToken) {
				exports.handleIdToken(idToken, handlers);
			}
		}).catch(function (err) {
			type = err.type;
			_discriminant = type;
			_match = false;
			_brokenOut = false;

			if (!_brokenOut && (_match || 'userCanceled' === _discriminant)) {
				exports.track(_constants.TRACK_DISMISS);
				handlers.dismiss && handlers.dismiss();
				return;

				_match = true;
			}

			if (!_brokenOut && !_match) {
				cancelPing = true;
				return;
			}
		});
	}).then(function () {});
}

/**
 * Convenience funciton trackEvent
 *
 * {String} action
 */
function track() {
	var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.TRACK_LOAD;

	(0, _universalAnalytics.trackEvent)({
		action: action,
		category: 'auth',
		label: 'onetap//'
	});
}

/**
 * Get the proper GA event from a typical reg/login response
 * @param {Object} response
 * @return {String}
 */
function getGAEvent() {
	var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	if (response.googleAnalyticsEvent && response.googleAnalyticsEvent.action && response.googleAnalyticsEvent.action.indexOf('register') > -1) {
		return _constants.TRACK_REGISTER;
	}

	return _constants.TRACK_LOGIN;
}

/**
 * Load the one tap sdk
 */
function loadSDK() {
	(function (d, s, id) {
		// eslint-disable-line no-unexpected-multiline
		var element = d.getElementsByTagName(s)[0];
		var fjs = element;
		var js = d.createElement(s);
		js.id = id;
		js.src = _constants.SDK_SRC;
		fjs.parentNode.insertBefore(js, fjs);
	})(document, 'script', 'google-1-tap');
}

/**
 * Register / login with one tap token
 *
 * @param {String} idToken
 * @param {Object} handlers
 * 	@param {Function} handlers.prefetch
 * 	@param {Function} handlers.success
 *  @param {Function} handlers.failure
 */
function handleIdToken(idToken, _ref2) {
	var prefetch = _ref2.prefetch,
	    success = _ref2.success,
	    failure = _ref2.failure;

	prefetch();

	_superagent2.default.post(_constants.ID_TOKEN_ENDPOINT).field('idToken', idToken).end(function (err, res) {
		if (err || !res.ok) {
			failure(ENDPOINT_FAILURE_MSG);
		} else {
			var loginResponse = void 0;
			try {
				loginResponse = JSON.parse(res.text);
			} catch (ex) {
				console.log('Error reading Google 1-tap login response', ex);
			}

			success(loginResponse);
		}
	});
}

/**
 *
 * @param {String} email
 * @param {Function} errorHandler
 */
function handleBlackListed(email) {
	var errorHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.noop;

	errorHandler((0, _constants.BLACKLIST_ERROR_FN)(email));
}

/**
 * Compose handlers for request
 *
 * @param {Function} success
 * @param {Function} failure
 * @returns {Object}
 */
function getOnLoadHandlers(_success, _failure) {
	return {
		prefetch: function prefetch() {
			(0, _clientProfiler.profileIntervalBegin)(_constants.PROFILE_EVENT);
		},
		success: function success(res) {
			(0, _clientProfiler.profileIntervalEnd)(_constants.PROFILE_EVENT);
			_success();
			exports.track(getGAEvent(res));
		},
		failure: function failure(msg) {
			(0, _clientProfiler.profileIntervalFail)(_constants.PROFILE_EVENT);
			_failure(msg);
			exports.track('serviceFailure');
		}
	};
}

/**
 * Initialize the thing
 *
 *  @param {String} clientId
 *  @param {String} context
 *  @param {Object}
 *		@param {Function} successHandler
 *		@param {Function} errorHandler
 */
exports.getOnLoadHandlers = getOnLoadHandlers;
function init() {
	var clientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	    errorHandler = _ref3.errorHandler,
	    successHandler = _ref3.successHandler,
	    dismissHandler = _ref3.dismissHandler;

	var smartlockSelector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SMARTLOCK_SELECTOR;

	var config = {
		clientId: clientId,
		context: context
	};

	_cancel = false;
	if (!window.onSmartLockLoad) {
		exports.loadSDK();
		window.onSmartLockLoad = function (smartlock) {
			// No load event currently for smartlock window so need to ping for visible element
			cancelPing = false;
			ping(Date.now(), function () {
				return getVisibleElement(smartlockSelector);
			}, function () {
				exports.track(_constants.TRACK_LOAD);
			});
			__onSmartLockLoad(smartlock, config, (0, _extends3.default)({}, getOnLoadHandlers(successHandler, errorHandler), {
				dismiss: dismissHandler
			}));
		};
	} else if (exports._smartlock) {
		window.onSmartLockLoad(exports._smartlock);
	}
}

/**
 * Close smartlock dialog
 */
function close() {
	_cancel = true;
	if (exports._smartlock) {
		cancelPing = true;
		exports._smartlock.cancelLastOperation().then(function () {
			// Closed...
		});
	}
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
var SDK_SRC = exports.SDK_SRC = 'https://smartlock.google.com/client';
var GOOGLE_ACCOUNTS_URI = exports.GOOGLE_ACCOUNTS_URI = 'https://accounts.google.com';
var ID_TOKEN_ENDPOINT = exports.ID_TOKEN_ENDPOINT = '/user/account/services/ExternalAuthentication.htm';

function noop() {}

var TRACK_LOAD = exports.TRACK_LOAD = 'authopen/onetap/';
var TRACK_LOGIN = exports.TRACK_LOGIN = 'signin/onetap/';
var TRACK_REGISTER = exports.TRACK_REGISTER = 'register/onetap/';
var TRACK_DISMISS = exports.TRACK_DISMISS = 'dismiss/onetap/';
var BLACKLIST_DOMAIN = exports.BLACKLIST_DOMAIN = '@zillowgroup.com';

var PROFILE_EVENT = exports.PROFILE_EVENT = 'reglogin:google_one_tap';

var BLACKLIST_ERROR_FN = exports.BLACKLIST_ERROR_FN = function BLACKLIST_ERROR_FN(email) {
  return 'Email ' + email + ' is not authorized for One Tap sign in, please use email/password credentials';
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Adds class to body and documentElement.
 * @kind function
 * @param {String} globalClass
 *                   global class to be added
 */
var addGlobalClass = exports.addGlobalClass = function addGlobalClass(globalClass) {
  document.body.classList.add(globalClass);
  document.documentElement.classList.add(globalClass);
};

/**
 * Removes class from body and documentElement.
 * @kind function
 * @param {String} globalClass
 *                   global class to be removed
 */
var removeGlobalClass = exports.removeGlobalClass = function removeGlobalClass(globalClass) {
  document.body.classList.remove(globalClass);
  document.documentElement.classList.remove(globalClass);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Determines whether or not device is impacted by
 * carat positioning bug (https://bugs.webkit.org/show_bug.cgi?id=176896)
 * Should only impact iOS >= 11.0 and < 11.3
 * @param {String} userAgent navigator user agent string
 */
var isBrokenCursorOS = exports.isBrokenCursorOS = function isBrokenCursorOS(userAgent) {
  return (/(iPad|iPhone|iPod)[^)]+OS 11_[0-2]/.test(userAgent)
  );
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Accepts an array of functions [fns] and returns a function
 * that applies the passed fns and returns the result
 * add = (a, b) => a+ b
 * double = (num) => num * 2
 * addThenDouble = pipe(add, double)
 * result = sumThenDouble(1,2) // 6
 * @param {Array} Array of functions. Return values
 * @return {Function}
 */
var pipe = function pipe() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (y, f) {
      return f(y);
    }, x);
  };
};

exports.default = pipe;
module.exports = exports["default"];

/***/ }),
/* 82 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/json/stringify");

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = require("@zillow/is-local-storage-supported");

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(37);

var _typeof3 = _interopRequireDefault(_typeof2);

var _redux = __webpack_require__(42);

var _reduxThunk = __webpack_require__(86);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _userSessionStoreSubscribe = __webpack_require__(87);

var _userSessionStoreSubscribe2 = _interopRequireDefault(_userSessionStoreSubscribe);

var _reducers = __webpack_require__(88);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { routerMiddleware } from 'react-router-redux'
exports.default = function () {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var asyncReducers = arguments[1];

  // Middleware Configuration
  var middleware = [_reduxThunk2.default];

  // Store Enhancers
  var enhancers = [];

  // modified compose to allow for use of Redux Tools extension
  // https://github.com/zalmoxisus/redux-devtools-extension
  var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

  // Store Instantiation and HMR Setup
  var store = (0, _redux.createStore)((0, _reducers2.default)(asyncReducers), initialState, composeEnhancers.apply(undefined, [_redux.applyMiddleware.apply(undefined, middleware)].concat(enhancers)));
  store.asyncReducers = asyncReducers;

  // Needed to update connected components on user session store update
  store.userSessionStoreUnsubscribe = (0, _userSessionStoreSubscribe2.default)(function () {
    store.dispatch({
      type: 'REG_LOGIN:ACTION:USER_SESSION_STORE_UPDATE'
    });
  });

  if (false) {
    module.hot.accept('./reducers', function () {
      store.replaceReducer((0, _reducers2.default)(store.asyncReducers));
    });
  }

  return store;
};

module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = require("redux-thunk");

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = require("@zillow/user-session-store-subscribe");

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRootReducer = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(42);

var _login = __webpack_require__(89);

var _social = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeRootReducer = exports.makeRootReducer = function makeRootReducer(asyncReducers) {
  return (0, _redux.combineReducers)((0, _extends3.default)({
    // Add sync reducers here
    login: _login.loginReducer,
    social: _social.socialReducer,
    appConfig: function appConfig() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return state;
    },
    abtestConfig: function abtestConfig() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return state;
    }
  }, asyncReducers));
}; // import { routerReducer as router } from 'react-router-redux'
exports.default = makeRootReducer;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginReducer = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFormHidden: true,
  newPasswordValidationMessages: (0, _constants.getNewPasswordValidationMessagesInitialState)(),
  showEmailConsent: false,
  isOutsideUSClicked: false,
  isValidEmailToken: _constants.APP_CONFIG.isValidEmailToken === 'true',
  isGeoIPApiCalled: false,
  overrideProSelection: false

  /**
   * Reduces register state.
   * @kind function
   * @param  {Object} state
   *                    current state to be reduced
   * @param  {String} action
   *                    action payload
   * @return {Object} reduced state
   */
};var loginReducer = exports.loginReducer = function loginReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.AUTH_TOKEN:
      return (0, _extends3.default)({}, state, {
        authToken: action.authToken
      });
    case _constants.HIDE_EMAIL_FORM:
      return (0, _extends3.default)({}, state, {
        isFormHidden: true
      });

    case _constants.NETWORK_ERROR:
      return (0, _extends3.default)({}, state, {
        formErrorMessage: action.message
      });

    case _constants.REGISTER_CONTEXT:
      return (0, _extends3.default)({}, state, {
        contextData: action.contextData
      });

    case _constants.RESET_FORM_ERROR:
      return (0, _extends3.default)({}, state, {
        formErrorMessage: null
      });

    case _constants.SHOW_EMAIL_FORM:
      return (0, _extends3.default)({}, state, {
        isFormHidden: false
      });

    case _constants.VALIDATE_ON_KEYUP:
      return (0, _extends3.default)({}, state, {
        validateOnKeyup: true
      });

    case _constants.FORM_VALIDATED:
      return (0, _extends3.default)({}, state, {
        validated: action.validated
      });

    case _constants.SET_ON_CLOSE:
      return (0, _extends3.default)({}, state, {
        onClose: action.onClose
      });

    case _constants.SET_NEW_PASSWORD_VALIDATION_MESSAGES:
      return (0, _extends3.default)({}, state, {
        newPasswordValidationMessages: action.messages
      });

    case _constants.TOGGLE_EMAIL_CONSENT_DISPLAY:
      return (0, _extends3.default)({}, state, {
        showEmailConsent: !state.showEmailConsent,
        isOutsideUSClicked: true
      });

    case _constants.UPDATE_VALID_EMAIL_TOKEN:
      return (0, _extends3.default)({}, state, {
        isValidEmailToken: action.isValid
      });

    case _constants.SET_EMAIL_CONSENT_DISPLAY:
      return (0, _extends3.default)({}, state, {
        showEmailConsent: true
      });

    case _constants.SET_GEOIP_API_CALLED:
      return (0, _extends3.default)({}, state, {
        isGeoIPApiCalled: true
      });

    case _constants.OVERRIDE_PRO_SELECTION:
      return (0, _extends3.default)({}, state, {
        overrideProSelection: !state.overrideProSelection
      });

    default:
      return state;
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialReducer = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  fbErrorMessage: null,
  showFbError: false

  /**
   * Reduces register state.
   * @kind function
   * @param  {Object} state
   *                    current state to be reduced
   * @param  {String} action
   *                    action payload
   * @return {Object} reduced state
   */
};var socialReducer = exports.socialReducer = function socialReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.HIDE_FB_CONNECT_ERROR:
      return (0, _extends3.default)({}, state, {
        showFbError: false
      });

    case _constants.SET_FB_CONNECT_ERROR:
      return (0, _extends3.default)({}, state, {
        fbErrorMessage: action.message
      });

    case _constants.SHOW_FB_CONNECT_ERROR:
      return (0, _extends3.default)({}, state, {
        showFbError: true
      });

    default:
      return state;
  }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
* Stub ClientProfiler and warn if not available
**/
if (typeof window.ClientProfiler === 'undefined') {
	var noop = function noop(methodName, eventName) {
		// For debugging purposes only
		// console.log(`ClientProfiler not available for method ${methodName} with event: ${eventName}`)
	};

	window.ClientProfiler = {
		profileIntervalBegin: function profileIntervalBegin(eventName) {
			noop('profileIntervalBegin', eventName);
		},
		profileIntervalEnd: function profileIntervalEnd(eventName) {
			noop('profileIntervalEnd', eventName);
		}
	};
}

/**
* Mark ClientProfiler profileIntervalBegin event
* @param {String} eventName
**/
var profileIntervalBegin = exports.profileIntervalBegin = function profileIntervalBegin(eventName) {
	window.ClientProfiler.profileIntervalBegin(eventName);
};

/**
* Mark ClientProfiler profileIntervalEnd event
* @param {String} eventName
**/
var profileIntervalEnd = exports.profileIntervalEnd = function profileIntervalEnd(eventName) {
	window.ClientProfiler.profileIntervalEnd(eventName);
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addDeprecatedListeners = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _userSessionStoreActions = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DEPRECATED
 * Setup event listeners for APP_REDIRECT, which is still being used by consumers of
 * auth-lightbox-api@0.3.0. We should remove this once everyone has updated to 1.0.0
 * @param {Object} config
 */
var addDeprecatedListeners = function addDeprecatedListeners(_ref) {
    var isLightbox = _ref.isLightbox;

    return function (e) {
        var detail = e.detail;
        var authProcess = detail.authProcess,
            hidden = detail.hidden,
            inputValues = detail.inputValues,
            path = detail.path,
            redirectUrl = detail.redirectUrl,
            uiConfig = detail.uiConfig;


        var defaultUiConfig = {
            headerText: 'Welcome to Zillow',
            authAP: '',
            showTabs: true,
            gaLabel: 'generic/generic',
            renderNodeTarget: null //ensure value is set to empty unless explicitly set during APP_REDIRECT
        };

        (0, _userSessionStoreActions.setRegLoginUiConfig)((0, _extends3.default)({}, defaultUiConfig, uiConfig));

        // authProcess should be set after default UI Config extension
        if (authProcess) {
            (0, _userSessionStoreActions.setRegLoginUiConfig)({ gaLabel: authProcess });
        }

        if (path) {
            (0, _userSessionStoreActions.setRegLoginPath)(path);
        }

        if (isLightbox) {
            if (!hidden) {
                (0, _userSessionStoreActions.showRegLoginLightbox)();
            } else {
                (0, _userSessionStoreActions.hideRegLoginLightbox)();
            }
        }

        if (inputValues) {
            (0, _userSessionStoreActions.setRegLoginInputValues)(inputValues);
        }
    };
};
exports.addDeprecatedListeners = addDeprecatedListeners;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(94)(false);
// imports


// module
exports.push([module.i, "@keyframes zsgLoaderSpin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.act-auth-container .user-account{margin:0 auto;width:100%}@media screen and (max-width:480px){.act-auth-container .user-account{max-width:100%}}.act-auth-container .user-account .module-forgot-password,.act-auth-container .user-account .module-redirect,.act-auth-container .user-account .module-terms-of-use{padding:8px}.act-auth-container .user-account .module-footer{text-align:center}.act-auth-container .user-account .zsg-form-field{position:relative}.act-auth-container .user-account input{height:38px}.act-auth-container .user-account input[type=submit]{width:100%}.act-auth-container .user-account .continue,.act-auth-container .user-account .extension,.act-auth-container .user-account .module-separator{text-align:center}.act-auth-container .user-account .continue a,.act-auth-container .user-account .continue label,.act-auth-container .user-account .extension a,.act-auth-container .user-account .extension label,.act-auth-container .user-account .module-separator a,.act-auth-container .user-account .module-separator label{line-height:38px}.act-auth-container .user-account .phone-label{padding:0 0 0 10px;line-height:38px}.act-auth-container .user-account.passwordless-auth{width:auto;max-width:520px}@media only screen and (max-width:520px){.act-auth-container .user-account.passwordless-auth{max-width:100%}}.act-auth-container .user-account.streamlined-agent{width:560px}.act-auth-container .user-account.streamlined-agent .module-wrap{padding:20px;box-shadow:0 1px 2px #ccc;box-shadow:0 1px 2px rgba(0,0,0,.3)}.act-auth-container .user-account.sem-lightbox .module-right{padding:20px;border:1px solid #ccc}.act-auth-container .user-account.sem-lightbox .module-forgot-password{padding:0;line-height:1em}.act-auth-container .user-account .bold-search-label{font-weight:700}.act-auth-container .user-account .save-search-freq>label{margin-right:15px;margin-right:1rem;display:inline-block}.act-auth-container .user-account .save-search-freq .zsg-list_inline{display:inline-block}.act-auth-container .user-account .save-search-option-label.sms{margin-top:5px}@media screen and (max-width:768px){.act-auth-container .user-account .save-search-option-label.sms{margin-left:15px}}.act-auth-container .user-account .submit-div{text-align:center}@media screen and (max-width:480px){.act-auth-container .user-account .submit-div{width:100%}}@media screen and (max-width:768px){.act-auth-container .user-account .sms-phone-number{margin-left:15px}}.act-auth-container .user-account .sem-auth-header-image{width:100%}.act-auth-container .user-account .sem-auth-header-image img{width:100%;margin-bottom:15px}.act-auth-container .user-account .async-validator-feedback{position:absolute;text-indent:-9999px;top:5px;right:10px;background-position:right 10px}@media only screen and (min-width:448px){.act-auth-container .user-account .zsg-lg-1-2.zsg-sm-1-1{width:50%}.act-auth-container .user-account .zsg-lg-1-5.zsg-sm-1-1{width:20%}.act-auth-container .user-account .zsg-lg-2-5.zsg-sm-1-1{width:40%}.act-auth-container .user-account .zsg-lg-3-5.zsg-sm-1-1{width:60%}.act-auth-container .user-account h2{font-size:28px;line-height:1.3;font-weight:700}.act-auth-container .user-account .continue{text-align:left}}@media only screen and (max-width:447px){.act-auth-container .user-account .phone-label{width:28%}.act-auth-container .user-account .sm-hide{display:none}.act-auth-container .user-account .continue a,.act-auth-container .user-account .continue label,.act-auth-container .user-account .module-separator a,.act-auth-container .user-account .module-separator label{line-height:1}}.act-auth-container .user-account.login input[readonly],.act-auth-container .user-account.register input[readonly]{background-color:#EEE;border-color:#CCC;box-shadow:none;color:#CCC;cursor:default;opacity:1}.inline-auth .user-account{width:auto;min-width:375px;max-width:448px;padding:20px}@media only screen and (max-width:448px){.inline-auth .user-account{min-width:300px;max-width:100%}}.inline-auth .user-account.save-search{max-width:645px}.inline-auth .user-account.passwordless-auth{max-width:520px}@media only screen and (max-width:520px){.inline-auth .user-account.passwordless-auth{max-width:100%}}.inline-auth .user-account.sem-lightbox{max-width:645px}.inline-auth .user-account.save-image-digs-lightbox{min-width:457px;padding:0}.login-success .login-success_hide{display:none}@media screen and (min-width:481px){.login-success .submit-div .zsg-button_primary{width:75%}}.sms-tooltip-launch{margin-top:10px}.sms-phone-form{margin-right:7px;width:auto}.sms-phone-form-large{width:auto}#website-reg-steps ol.zsg-steps li>a{padding-left:20px;padding-right:20px;word-spacing:normal}[class^=zsg-button]{margin-bottom:0}[class^=zsg-button] input{border:none;background:inherit}.act-auth-container .submit-div{padding:0}@media screen and (max-width:480px){.act-auth-container .do-this-later{padding:10px 0 0}}.module-footer{padding:8px;text-align:center}.module-footer.line-bottom{margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #ccc}.module-footer.line-left{margin-left:15px;padding-left:15px;border-left:1px solid #ccc}.module-footer.line-right{margin-right:15px;padding-right:15px;border-right:1px solid #ccc}.module-footer.line-top{margin-top:15px;padding-top:15px;border-top:1px solid #ccc}.module-footer{padding:15px 0 8px 0;text-align:center}.module-footer.line-bottom{margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #ccc}.module-footer.line-left{margin-left:15px;padding-left:15px;border-left:1px solid #ccc}.module-footer.line-right{margin-right:15px;padding-right:15px;border-right:1px solid #ccc}.module-footer.line-top{margin-top:15px;padding-top:15px;border-top:1px solid #ccc}.module-footer.line-none{padding-top:0}.module-footer .btn-email.hidden~.zsg-form{margin-bottom:15px;text-align:left}.module-footer .view-toggle-msg{margin-right:4px}.module-footer .outer-fineprint{padding:8px 0}.social-logins .btn-social-connect{display:inline-block}.social-logins .social-error-msg{color:#fc384a}.social-logins .social-icon-google-g,.social-logins .zsg-icon-facebook,.social-logins .zsg-icon-google-plus{margin-left:10px;font-size:30px}.social-logins .social-icon-google-g{vertical-align:-2px}.social-logins .social-icon-google-g:hover{border-color:#999}.social-logins .zsg-icon-google-plus{color:#DD4B39}.social-logins .zsg-icon-google-plus:visited{color:#DD4B39}.social-logins .zsg-icon-google-plus:hover{color:#E47365}.social-logins .zsg-icon-facebook{color:#3B5998}.social-logins .zsg-icon-facebook:visited{color:#3B5998}.social-logins .zsg-icon-facebook:hover{color:#4C70BA}.user-account .fb-button{background:0 0}iframe[src^=\"https://apis.google.com/u/0/_/widget/oauthflow/toast\"]{display:none}.act-50-social-on-top .btn-social-connect{position:relative;margin-bottom:15px;padding:.7em .67em;font-size:1.2rem;display:block}.act-50-social-on-top .btn-social-connect.hidden{display:none}.act-50-social-on-top .social-logo{position:absolute;left:20px;padding-top:.2em}.act-50-social-on-top .social-text:before{margin-right:4px}.act-50-social-on-top .social-error-msg{text-align:center;color:#fc384a}.act-50-social-on-top.login .social-text:before{content:\"Sign in with\"}.act-50-social-on-top.register .social-text:before{content:\"Sign up with\"}.act-50-social-on-top .btn-google-plus{background:#fff;color:#666;border-color:#ccc}.act-50-social-on-top .btn-google-plus:visited{background:#fff}.act-50-social-on-top .btn-google-plus:hover{background:#fff}.act-50-social-on-top .btn-google-plus:hover{color:#444;border-color:#aaa}.act-50-social-on-top .btn-facebook{background:#3B5998;color:#fff}.act-50-social-on-top .btn-facebook:visited{background:#3B5998}.act-50-social-on-top .btn-facebook:hover{background:#4C70BA}.professional.pro-type-0 .community-pillar-field,.professional.pro-type-10 .community-pillar-field,.professional.pro-type-11 .community-pillar-field,.professional.pro-type-6 .community-pillar-field,.professional.pro-type-7 .community-pillar-field,.professional.pro-type-8 .community-pillar-field{display:none}.professional.pro-type-0 .phone-label,.professional.pro-type-10 .phone-label,.professional.pro-type-11 .phone-label,.professional.pro-type-6 .phone-label,.professional.pro-type-7 .phone-label,.professional.pro-type-8 .phone-label{display:none}.professional.pro-type-1 .community-pillar-field{display:none}.professional.pro-type-1 .phone-ext-field{display:none}.professional.pro-type-2 .community-pillar-field{display:none}.professional.pro-type-2 .name-fields{display:none}.professional.pro-type-2 .phone-fields{display:none}.professional.pro-type-2 .phone-label{display:none}.professional.pro-type-3 .community-pillar-field{display:none}.professional.pro-type-3 .phone-label{display:none}.professional.pro-type-4 .phone-label,.professional.pro-type-9 .phone-label{display:none}.professional.pro-type-5 .phone-label{display:none}.async-validator-feedback{color:#aaa;display:inline;margin-left:-15px;position:absolute;background-repeat:no-repeat;background-position:0 3px;line-height:30px}.async-validator-feedback.invalid,.async-validator-feedback.valid{font-weight:700;padding-left:20px}.async-validator-feedback.valid{color:#03c04a;background-image:url(/static/images/icon_checkmark.gif)}.async-validator-feedback.invalid{color:#fc384a;background-image:url(/static/images/icon_negative-x.gif)}.act-auth-lightbox{-webkit-overflow-scrolling:auto!important}.act-auth-lightbox.mobile-scroll-override{-webkit-overflow-scrolling:touch!important}.act-auth-lightbox .user-account{padding:20px}.act-auth-lightbox.yui3-lightbox-mask.hidden,.act-auth-lightbox.yui3-lightbox.hidden{display:none!important}.act-auth-lightbox .yui3-lightbox-content .lightbox-body{padding:0}@media screen and (max-width:767px){.act-auth-lightbox .yui3-lightbox-content{margin:0;padding-top:30px;border:none;box-shadow:none;max-width:none!important;min-height:100%}.act-auth-lightbox .yui3-lightbox-content iframe[scrolling=no]{position:absolute;left:50%;transform:translateX(-50%)}}.digs .auth-lightbox:not(.faux-hidden) .yui3-lightbox-content .lightbox-body{display:block}@media screen and (max-width:767px){.yui3-lightbox-mask.auth-lightbox{opacity:1}}.zsg-lightbox_override{overflow:visible!important}iframe[scrolling=no]{overflow:hidden}iframe[src*=\"//smartlock.google.com\"]{z-index:1000003!important}body.adjust-ios-carat{position:fixed}.password-strength-meter{margin-top:4px;cursor:pointer}.password-strength-meter .overlay-content{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.password-strength-meter .strength-label{font-size:12px;margin-right:5px}.password-strength-meter .zsg-donut{width:22px;height:22px}.password-strength-meter .zsg-loading-spinner{margin-top:4px}#strength-tooltip .zsg-tooltip-content{box-shadow:3px 3px 3px rgba(0,0,0,.2)}#strength-tooltip .zsg-tooltip-content h3{font-size:17px;margin-bottom:6px}#strength-tooltip .zsg-tooltip-content p{font-size:13px}.password-input>.zsg-form-field{margin-bottom:8px}.password-input input[type=password]{padding-right:95px}.password-input .validation-messages{margin-bottom:20px}.auth-validation-message{color:#aaa;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:2px 0}.auth-validation-message .validation-icon{padding-right:10px;min-width:25px}.auth-validation-message .validation-text{font-size:12px}.auth-validation-message.validation-pass{color:#666}.auth-validation-message.validation-pass .validation-icon{color:#3ACE09}.auth-validation-message.validation-fail{color:#F10000}@media screen and (max-width:768px) and (max-height:500px){iframe[src*=\"smartlock.google.com\"]{display:none!important}}.z-google-g-logo.z-google-g-logo_badge{display:inline-block;line-height:0;border:1px solid #CCC}.act-auth-container .lower-right-panel{height:38px;padding:8px;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center}@media screen and (max-width:767px){.act-auth-container .lower-right-panel{-ms-flex-pack:center;justify-content:center;text-align:center;margin-top:4px}}.act-auth-container .lower-right-panel p{margin-bottom:0}.act-auth-container .extension-label{padding:4px 0;text-align:center}.act-auth-container .hidden{display:none}", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = require("@zillow/user-session-store-core");

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/index.js
// module id = 508
// module chunks = 0